import * as i0 from '@angular/core';
import { Injectable, EventEmitter, InjectionToken, Inject, Component, Input, NgModule, ViewChild, ViewContainerRef, Directive, HostListener, Output, Pipe, ViewEncapsulation } from '@angular/core';
import * as i1 from '@angular/material/snack-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import * as i5 from '@angular/cdk/drag-drop';
import { moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import * as i1$3 from '@angular/common';
import { CommonModule } from '@angular/common';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import * as i1$8 from '@plantandfood/kup.auth';
import { KupAuthModule } from '@plantandfood/kup.auth';
import { of, Subject, ReplaySubject, forkJoin, BehaviorSubject, never, throwError, isObservable, from } from 'rxjs';
import { tap, map, catchError, take, startWith, debounceTime } from 'rxjs/operators';
import * as i1$1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { NativeEventSource, EventSourcePolyfill } from 'event-source-polyfill';
import { flatten } from 'flat';
import * as _ from 'lodash';
import { cloneDeep, omitBy, isNil, get } from 'lodash';
import * as i1$2 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import * as i2 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i3 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i4 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i1$4 from '@angular/router';
import * as i1$5 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { __rest, __awaiter } from 'tslib';
import { FlexLayoutModule } from '@angular/flex-layout';
import * as i2$3 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule, FormGroup } from '@angular/forms';
import * as i2$5 from '@ng-select/ng-select';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import * as i1$6 from '@ngx-formly/core';
import { FormlyForm, FieldWrapper, FieldArrayType, FormlyModule } from '@ngx-formly/core';
import { FieldType, FormlyMaterialModule } from '@ngx-formly/material';
import { FormlyMatDatepickerModule } from '@ngx-formly/material/datepicker';
import * as i1$7 from 'ngx-quill';
import { QuillEditorComponent, QuillModule } from 'ngx-quill';
import * as i4$2 from '@angular/material/datepicker';
import { MatDatepickerInput, MatDatepickerModule } from '@angular/material/datepicker';
import * as i4$1 from '@angular/material/autocomplete';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import * as i4$3 from '@angular/material/chips';
import { MatChipsModule } from '@angular/material/chips';
import * as i3$2 from '@angular/material/input';
import { MatInputModule, MatInput } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import * as i2$2 from '@angular/material/core';
import { MatNativeDateModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTreeModule } from '@angular/material/tree';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import * as i2$1 from '@angular/flex-layout/flex';
import * as i3$1 from '@angular/flex-layout/extended';
import * as i2$4 from '@angular/material/form-field';
import { ENTER, COMMA, TAB } from '@angular/cdk/keycodes';
import * as i2$6 from '@angular/platform-browser';
import * as moment from 'moment';
import swalNative from 'sweetalert2';

class KupSnackBarService {
    constructor(snackBar, zone) {
        this.snackBar = snackBar;
        this.zone = zone;
    }
    open(message, action) {
        this.zone.run(() => {
            this.snackBar.open(message, action, { duration: 4000 });
        });
    }
}
KupSnackBarService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: KupSnackBarService, deps: [{ token: i1.MatSnackBar }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Injectable });
KupSnackBarService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: KupSnackBarService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: KupSnackBarService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1.MatSnackBar }, { type: i0.NgZone }]; } });

var ApiActionType;
(function (ApiActionType) {
    ApiActionType["Undefined"] = "";
    ApiActionType["Create"] = "create";
    ApiActionType["Update"] = "update";
    ApiActionType["Delete"] = "delete";
    ApiActionType["Clone"] = "clone";
    ApiActionType["Load"] = "load";
    ApiActionType["LoadCollection"] = "load-collection";
    ApiActionType["Upload"] = "upload";
    ApiActionType["Execute"] = "execute";
})(ApiActionType || (ApiActionType = {}));

var NotificationCondition;
(function (NotificationCondition) {
    NotificationCondition["Always"] = "always";
    NotificationCondition["FailureOnly"] = "failure-only";
    NotificationCondition["Default"] = "always";
})(NotificationCondition || (NotificationCondition = {}));
var FailureLevel;
(function (FailureLevel) {
    FailureLevel["Warn"] = "warn";
    FailureLevel["Error"] = "error";
    FailureLevel["Default"] = "warn";
})(FailureLevel || (FailureLevel = {}));

var ApiErrorCategory;
(function (ApiErrorCategory) {
    /**
     * Represents response codes that cannot be mapped to a more specific ApiErrorCategory.
     */
    ApiErrorCategory[ApiErrorCategory["GenericError"] = 0] = "GenericError";
    /**
     * Represents response codes that occur after an attempted operation violates an entity's unique name constraint.
     */
    ApiErrorCategory[ApiErrorCategory["UniqueNameViolation"] = 1] = "UniqueNameViolation";
    /**
     * Represents response codes that occur after an attempted operation violates an entity's unique constraint which is not the entity's name.
     */
    ApiErrorCategory[ApiErrorCategory["UniqueConstraintViolation"] = 2] = "UniqueConstraintViolation";
})(ApiErrorCategory || (ApiErrorCategory = {}));

/**
 * The set of API response codes.
 */
var ApiResponseCode;
(function (ApiResponseCode) {
    ApiResponseCode["Ok"] = "ok";
    ApiResponseCode["ApplicationError"] = "application_error";
    ApiResponseCode["Cancelled"] = "application_cancelled";
    ApiResponseCode["Custom"] = "custom";
    ApiResponseCode["Exists"] = "generic_exists";
    ApiResponseCode["HttpError"] = "http_error";
    ApiResponseCode["InternalServerError"] = "internal_server_error";
    ApiResponseCode["NotReady"] = "not_ready";
    ApiResponseCode["NotFound"] = "not_found";
    ApiResponseCode["BadRequest"] = "bad_request";
    ApiResponseCode["AccessDenied"] = "access_denied";
    ApiResponseCode["BiomaterialCollectionUniqueName"] = "biomaterial_collection_unique_name";
    ApiResponseCode["GenotypeUniqueName"] = "genotype_unique_name";
    ApiResponseCode["TrialUniqueName"] = "trial_unique_name";
    ApiResponseCode["SiteUniqueName"] = "site_unique_name";
    ApiResponseCode["SiteUniqueCode"] = "site_unique_code";
    ApiResponseCode["TraitUniqueName"] = "trait_unique_name";
    ApiResponseCode["FactorUniqueName"] = "factor_unique_name";
    ApiResponseCode["ImportTypeUniqueName"] = "import_type_unique_name";
    ApiResponseCode["MethodUniqueName"] = "method_unique_name";
    ApiResponseCode["TreatmentUniqueName"] = "treatment_unique_name_trial";
    ApiResponseCode["OperationsPlanUniqueName"] = "operations_plan_unique_name";
    ApiResponseCode["UserGroupUniqueName"] = "user_group_unique_name";
    ApiResponseCode["TaskUniqueName"] = "task_unique_name";
    ApiResponseCode["OperationPlansTaskUniqueName"] = "operations_plan_task_unique";
    ApiResponseCode["DuplicateOperationsPlanTaskObservation"] = "task_observation_unique_opt_tms";
    ApiResponseCode["DuplicateTaskObservation"] = "duplicate_task_observation";
    ApiResponseCode["SeasonUniqueName"] = "season_unique_name";
    ApiResponseCode["ScaleUniqueName"] = "scale_unique_name";
    ApiResponseCode["ProcessUniqueName"] = "process_unique_name";
    ApiResponseCode["FactorKeywordUniqueName"] = "keyword_unique_name";
    ApiResponseCode["ObservationsUniqueName"] = "observations_unique_name";
    ApiResponseCode["ObservationsUniqueCode"] = "observations_unique_code";
    ApiResponseCode["GlobalObservationsUniqueName"] = "global_observation_unique_name";
    ApiResponseCode["GlobalObservationsUniqueCode"] = "global_observation_unique_code";
    ApiResponseCode["GlobalObservationsUniqueTmsp"] = "global_observation_unique_tmsp";
    ApiResponseCode["GlobalObservationsUniqueTms"] = "global_observation_unique_tms";
    ApiResponseCode["SingleActiveBiomaterial"] = "single_active_biomaterial_per_location";
    ApiResponseCode["TagUniqueName"] = "tag_unique_name_category";
    ApiResponseCode["ProgrammeUniqueName"] = "programme_unique_name";
})(ApiResponseCode || (ApiResponseCode = {}));

function httpErrorResponseFactory(response) {
    const result = {
        code: '',
        message: '',
        result: undefined
    };
    getResolutionFunction(response)(result, response);
    if (result.code == undefined)
        result.code = ApiResponseCode.ApplicationError;
    result.error = response;
    return result;
}
function getResolutionFunction(response) {
    if (response.error == undefined)
        return resolveGenericError;
    if (response.error.constraint != undefined)
        return resolveContraintViolation;
    return resolveGenericError;
}
function resolveGenericError(data, response) {
    switch (response.status) {
        case 400:
            data.code = ApiResponseCode.BadRequest;
            break;
        case 404:
            data.code = ApiResponseCode.NotFound;
            break;
        case 403:
            data.code = ApiResponseCode.AccessDenied;
            break;
        case 500:
            data.code = ApiResponseCode.InternalServerError;
            break;
        default:
            data.code = ApiResponseCode.HttpError;
            break;
    }
    data.message = resolveErrorMessage(response);
}
function resolveContraintViolation(data, response) {
    data.code = response.error.constraint;
    data.message = resolveErrorMessage(response);
}
function resolveErrorMessage(response) {
    const error = response.error;
    let result;
    if (error instanceof ProgressEvent) {
        result = response.message ? response.message : 'HTTP Failure Event';
    }
    else if (Array.isArray(error)) {
        if (error.length > 0) {
            result = error[0].message;
        }
    }
    else if (error != undefined) {
        result = error.message;
    }
    return result;
}

/**
 * The structure returned by API methods.
 */
// @dynamic
class ApiResponse {
    constructor(response, result) {
        if (typeof response === 'string') {
            this.code = response;
            if (this.isOk) {
                this.result = result;
            }
            else if (typeof result === 'string') {
                this.message = result;
            }
        }
        else if (response != undefined) {
            this.code = response.code;
            this.result = response.result;
            this.error = response.error;
            this.message = response.message;
        }
    }
    /**
     * Returns true if the associated API operation completed without error, otherwise returns false.
     */
    get isOk() {
        return this.code === ApiResponseCode.Ok;
    }
    /**
     * Converts a candidate object to an ApiResponse.
     * @param o The object to convert.
     */
    static as(o) {
        if (!o)
            return ApiResponse.error(ApiResponseCode.ApplicationError);
        let result;
        if (o instanceof ApiResponse) {
            result = o;
        }
        else if (typeof o === 'string' ||
            (o.hasOwnProperty('code') && o.hasOwnProperty('result'))) {
            result = new ApiResponse(o);
        }
        else {
            result = ApiResponse.error(ApiResponseCode.ApplicationError);
        }
        return result;
    }
    static resolveErrorCode(apiResponse) {
        if (!apiResponse || typeof apiResponse.code !== 'string') {
            return ApiResponseCode.ApplicationError;
        }
        return apiResponse.code;
    }
    /**
     * Creates a success response with the specified object as the result.
     * @param result The instance to embed as the result.
     */
    static ok(result) {
        return new ApiResponse(ApiResponseCode.Ok, result);
    }
    /**
     * Creates an error with the specified `ApiResponseCode` and optional error object.
     * @param code The error response code.
     * @param error (optional) The associated error object.
     */
    static errorCustom(code, error) {
        return new ApiResponse({ code: code, error: error, result: undefined });
    }
    /**
     * Creates an error response whicbh is a clone of another error response but with a different code.
     * @param original The original response.
     * @param newCode  The new error code.
     */
    static errorReassign(original, newCode) {
        return new ApiResponse({
            code: newCode,
            error: original.error,
            message: original.message,
            result: undefined
        });
    }
    /**
     * Creates an error response from the object.
     * @param error The object used to generate the error response.
     * @param message An optional error message.
     */
    static error(error, message) {
        if (error.status != undefined) {
            return ApiResponse.errorFromHttpResponse(error);
        }
        if (error instanceof Error) {
            return new ApiResponse(ApiResponseCode.ApplicationError, error.message);
        }
        return new ApiResponse(error, message);
    }
    /**
     * Creates an error from an `HttpErrorResponse`.
     * @param response The `HttpErrorResponse`.
     */
    static errorFromHttpResponse(response) {
        const data = httpErrorResponseFactory(response);
        return new ApiResponse(data);
    }
    /**
     * Wraps the specified object in a succesful `ApiResponse` and returns it as a resolved `Promise`.
     * @param result The object to wrap.
     */
    static resolve(result) {
        return Promise.resolve(new ApiResponse(ApiResponseCode.Ok, result));
    }
    /**
     * Wraps the specified object in a succesful `ApiResponse` and returns it as an `AsyncApiResponse`.
     * @param result The object to wrap.
     */
    static resolve$(result) {
        return of(new ApiResponse(ApiResponseCode.Ok, result));
    }
    /**
     * Creates an error `ApiResponse` from the specified source and returns it as a rejected `Promise`.
     * @param result The response source.
     */
    static reject(response) {
        return Promise.reject(ApiResponse.as(response));
    }
    /**
     * Creates an error `ApiResponse` from the specified source and returns it as an `AsyncApiResponse`.
     * @param result The response source.
     */
    static reject$(response) {
        return of(ApiResponse.as(response));
    }
    /**
     * Creates an error `ApiResponse` from the specified source and returns it as a rejected `Promise<void>`.
     * @param result The response source.
     */
    static rejectVoid(response) {
        return Promise.reject(ApiResponse.as(response));
    }
    /**
     * Maps the output of an `AsyncApiResponse<T>` instance to an `Observable<T>` instance, and optionally
     * throws an error if the response is a failure response.
     * @param response The input response
     * @param raiseError If `true`, an error will be thrown if the response is a failure response. The default value is `true`.
     */
    static map(response, raiseError = true) {
        return response.pipe(tap(response => {
            if (response.isOk || !raiseError)
                return;
            throw response.errorFrom();
        }), map(response => response.result));
    }
    /**
     * Maps the output of an `Observable<T>` instance to an instance of `AysncApiResponse<T>`.
     * @param source The soruce observable.
     */
    static inverseMap(source) {
        return source.pipe(map(result => ApiResponse.ok(result)), catchError(error => of(ApiResponse.error(error))));
    }
    /**
     * Returns the ApiErrorCategory associated with an ApiResponseCode.
     * @param code The ApiResponseCode.
     */
    static getErrorCategory(code) {
        switch (code) {
            case ApiResponseCode.FactorUniqueName:
            case ApiResponseCode.GenotypeUniqueName:
            case ApiResponseCode.ImportTypeUniqueName:
            case ApiResponseCode.TraitUniqueName:
            case ApiResponseCode.FactorUniqueName:
            case ApiResponseCode.MethodUniqueName:
            case ApiResponseCode.SiteUniqueName:
            case ApiResponseCode.SeasonUniqueName:
            case ApiResponseCode.ProcessUniqueName:
            case ApiResponseCode.ScaleUniqueName:
            case ApiResponseCode.FactorKeywordUniqueName:
            case ApiResponseCode.TreatmentUniqueName:
            case ApiResponseCode.OperationsPlanUniqueName:
            case ApiResponseCode.OperationPlansTaskUniqueName:
            case ApiResponseCode.TrialUniqueName:
            case ApiResponseCode.TaskUniqueName:
            case ApiResponseCode.UserGroupUniqueName:
            case ApiResponseCode.BiomaterialCollectionUniqueName:
            case ApiResponseCode.TagUniqueName:
            case ApiResponseCode.ObservationsUniqueName:
            case ApiResponseCode.GlobalObservationsUniqueName:
            case ApiResponseCode.Exists:
                return ApiErrorCategory.UniqueNameViolation;
            case ApiResponseCode.SiteUniqueCode:
                return ApiErrorCategory.UniqueConstraintViolation;
            default:
                return ApiErrorCategory.GenericError;
        }
    }
    /**
     * Wraps this instance in an `Observable` and returns it as an `AsyncApiResponse<T>`.
     */
    async() {
        return of(this);
    }
    /**
     * Generates an `Error` from this instance.
     */
    errorFrom() {
        if (this.error)
            return this.error;
        return this.message
            ? new Error(`[API Error][${this.code}][${this.message}]`)
            : new Error(`[API Error][${this.code}]`);
    }
}

/**
 * Reflects the state of asynchronous loading operations which are being monitored by a state monitor.
 */
var LoadingState;
(function (LoadingState) {
    /**
     * The state monitor is initialising.
     */
    LoadingState[LoadingState["Initial"] = 0] = "Initial";
    /**
     * One or more monitored asynchronous loading operations are active.
     */
    LoadingState[LoadingState["Loading"] = 1] = "Loading";
    /**
     * All monitored asynchronous loading operations have completed successfully.
     */
    LoadingState[LoadingState["Loaded"] = 2] = "Loaded";
    /**
     * One or more monitored asynchronous loading operations have failed.
     */
    LoadingState[LoadingState["Failed"] = 3] = "Failed";
})(LoadingState || (LoadingState = {}));

function unsubscribe(sub) {
    if (sub !== undefined && !sub.closed) {
        sub.unsubscribe();
    }
}
/**
 * Exposes helper methods to automatically manage disposable resources (such as rxjs Subscriptions) within the scope of their
 * immediate useage.
 */
// @dynamic
class AutoDispose {
    constructor() { }
    /**
     * Subscribes to an observable for zero or one events, and automatically unsubscribes when an event has completed.
     * @param observable The observable to subscribe to.
     * @param Function next a handler for each value emitted by the observable
     * @returns A throw-away Observable which can be subscribed to inline by client code but needn't be unsubscribed from.
     */
    static subscribeSubjectOnce(observable, next, error, complete) {
        return this.observeSubjectOnce(observable).subscribe(next, error, complete);
    }
    /**
     * Returns an observable which proxies zero or one events raised by a source observable, and automatically unsubscribes from
     * the source observable when the event has completed.
     * @param observable The source observable to subscribe to.
     * @returns A throw-away Observable which can be subscribed to inline by client code but needn't be unsubscribed from.
     */
    static observeSubjectOnce(observable) {
        return AutoDispose.observeOnce(new Subject(), observable);
    }
    /**
     * Subscribes to an observable for zero or one events, and automatically unsubscribes when an event has completed.
     * @param observable The observable to subscribe to.
     * @param Function next a handler for each value emitted by the observable
     * @returns A throw-away Observable which can be subscribed to inline by client code but needn't be unsubscribed from.
     */
    static subscribeReplayOnce(observable, next, error, complete) {
        return this.observeReplayOnce(observable).subscribe(next, error, complete);
    }
    /**
     * Returns an observable which proxies zero or one events raised by a source observable, and automatically unsubscribes from
     * the source observable when the event has completed.
     * @param observable The source observable to subscribe to.
     * @returns A throw-away Observable which can be subscribed to inline by client code but needn't be unsubscribed from.
     */
    static observeReplayOnce(observable) {
        return AutoDispose.observeOnce(new ReplaySubject(1), observable);
    }
    /**
     * Returns an observable that emits and completes when an array of Observables have all emitted and completed.
     * @param items  New elements of the Array.
     */
    static all(items) {
        if (items === undefined || items.length === 0) {
            return of(Promise.resolve());
        }
        const result = new ReplaySubject(1);
        forkJoin(items).subscribe(() => {
            result.next(undefined);
            result.complete();
        });
        return result;
    }
    /**
     * Returns a Promise that completes when an array of Observables have all emitted and completed.
     * @param items  New elements of the Array.
     */
    static allAsPromise(items) {
        return AutoDispose.all(items).toPromise();
    }
    static observeOnce(result, observable) {
        const sub = observable.subscribe((value) => {
            unsubscribe(sub);
            result.next(value);
        }, (e) => {
            unsubscribe(sub);
            result.error(e);
        }, () => {
            unsubscribe(sub);
            result.complete();
        });
        return result.asObservable();
    }
}
/**
 * Manages disposable resources such as rxjs Subscriptions.
 */
class Disposables {
    /**
     * Registers a subscription for automatic disposal when dispose() has been invoked.
     * @param Function next a handler for each value emitted by the observable
     */
    addSubscription(subscription) {
        if (!this._subscriptions) {
            this._subscriptions = [];
        }
        this._subscriptions.push(subscription);
    }
    /**
     * Subscribes to an observable and automatically unsubscribes from it when dispose() has been invoked.
     * @param Function next a handler for each value emitted by the observable
     */
    subscribeTo(observable, next, error, complete) {
        this.addSubscription(observable.subscribe(next, error, complete));
    }
    /**
     * Subscribes to an observable for zero or one events, and automatically unsubscribes when an event has completed or
     * dispose() has been invoked, whichever occurs first.
     * @param observable The observable to subscribe to.
     * @param Function next a handler for each value emitted by the observable
     * @returns A throw-away Observable which can be subscribed to inline by client code but needn't be unsubscribed from.
     */
    subscribeOnce(observable, next, error, complete) {
        const result = this.observeOnce(observable);
        result.subscribe(next, error, complete);
        return result;
    }
    /**
     * Returns an observable which proxies zero or one events raised by a source observable, and automatically unsubscribes from
     * the source observable when the event has completed or dispose() has been invoked, whichever occurs first.
     * @param observable The source observable to subscribe to.
     * @returns A throw-away Observable which can be subscribed to inline by client code but needn't be unsubscribed from.
     */
    observeOnce(observable) {
        const result = new ReplaySubject(1);
        let sub = observable.subscribe((value) => {
            removeSub(this._subscriptions, sub);
            sub = undefined;
            result.next(value);
            result.complete();
        }, (e) => {
            removeSub(this._subscriptions, sub);
            sub = undefined;
            result.error(e);
            result.complete();
        }, () => {
            removeSub(this._subscriptions, sub);
            result.complete();
        });
        if (sub !== undefined && !sub.closed) {
            this.addSubscription(sub);
        }
        return result.asObservable();
    }
    /**
     * Registers a disposable resource to be automatically disposed of during this instance's dispose sequence.
     *
     * Where the resource implements multiple interfaces, only one disposal method will be invoked, following the order-of-precedence
     * `OnDestroy`, `Disposable`, `Destructible`.
     *
     * @param disposable the resource to register for automatic disposal.
     */
    autoDispose(resource) {
        if (resource === undefined) {
            throw new Error(`The argument "resource" cannot be null.`);
        }
        if (this._disposables === undefined) {
            this._disposables = [];
        }
        this._disposables.push(resource);
    }
    /**
     * Releases all resources maintained by this instance.
     */
    dispose() {
        if (this._subscriptions !== undefined) {
            this._subscriptions.forEach((s) => {
                s.unsubscribe();
            });
            this._subscriptions = undefined;
        }
        if (this._disposables !== undefined) {
            this._disposables.forEach((d) => {
                if (d.ngOnDestroy !== undefined) {
                    d.ngOnDestroy();
                }
                else if (d.dispose !== undefined) {
                    d.dispose();
                }
                else if (d.destroy !== undefined) {
                    d.destroy();
                }
            });
            this._disposables = undefined;
        }
    }
}
/** A convenience reference to the static AutoDispose type. */
Disposables.global = AutoDispose;
function removeSub(array, sub) {
    if (sub === undefined) {
        return;
    }
    if (!sub.closed) {
        sub.unsubscribe();
    }
    if (array === undefined) {
        return;
    }
    const idx = array.indexOf(sub);
    if (idx >= 0) {
        array.splice(idx, 1);
    }
}

//#region BusyWatcher
class BusyWatcher {
    constructor(obs) {
        this.obs = obs;
        this._activeCount = 0;
        this._active = [];
    }
    get isBusy() {
        return this._activeCount > 0;
    }
    watch(target) {
        let completed = false;
        this._activeCount++;
        this.next(true);
        const sub = Disposables.global.subscribeSubjectOnce(target, () => {
            completed = true;
            this.complete(sub);
        }, () => {
            completed = true;
            this.complete(sub);
        }, () => {
            if (!completed) {
                completed = true;
                this.complete(sub);
            }
        });
        if (!completed) {
            this._active.push(sub);
        }
    }
    reset() {
        this._active.forEach(sub => {
            if (!sub.closed) {
                sub.unsubscribe();
            }
        });
        this._active = [];
        this.next(false);
    }
    complete(sub) {
        this._activeCount--;
        const idx = this._active.indexOf(sub);
        if (idx >= 0) {
            this._active.splice(idx, 1);
        }
        this.next(this._activeCount > 0);
    }
    next(value) {
        if (this.obs.value !== value) {
            this.obs.next(value);
        }
    }
}
//#endregion
//#region Supporting Types
class LoadingStateEventArgs {
    constructor(sender) {
        this.sender = sender;
    }
}
class LoadingStateChangedEventArgs extends LoadingStateEventArgs {
    constructor(sender, state) {
        super(sender);
        this.state = state;
    }
}
class LoadingStateErrorEventArgs extends LoadingStateEventArgs {
    constructor(sender, error) {
        super(sender);
        this.error = error;
    }
}
//#endregion
//#region Manual
class ManualBusyState {
    constructor(initialLoadingState = LoadingState.Loaded, initialBusyState = false) {
        this._loadingState$ = new BehaviorSubject(initialLoadingState);
        this._busyState$ = new BehaviorSubject(initialBusyState);
        this.loadingState$ = this._loadingState$.asObservable();
        this.busyState$ = this._busyState$.asObservable();
    }
    get isBusy() {
        return this._busyState$.value;
    }
    set isBusy(value) {
        this._busyState$.next(value === true);
    }
    get loadingState() {
        return this._loadingState$.value;
    }
    set loadingState(value) {
        this._loadingState$.next(value);
    }
}
//#endregion
class LoadingStateMonitor {
    constructor() {
        this._nonce = 0;
        this._state = LoadingState.Initial;
        this._isPreparing = false;
        this._disposables = new Disposables();
        this._refCount = 0;
        this._errors = [];
        this._loadingState$ = new BehaviorSubject(LoadingState.Initial);
        this._busyState$ = new BehaviorSubject(false);
        /**
         * An `Observable` which emits a `LoadingStateErrorEventArgs` instance the errors reported during this instances
         * currently active cycle.
         */
        this.onError = new EventEmitter();
        /**
         * An `Observable` which emits the current `LoadingState` of this instance.
         */
        this.loadingState$ = this._loadingState$.asObservable();
        /**
         * An `Observable` which emits a boolean value which is `true` of this instance is managing one or more active worker actions.
         */
        this.busyState$ = this._busyState$.asObservable();
        /**
         * An `Observable` which emits a `LoadingStateChangedEventArgs` instance describing the current `LoadingState` of this instance.
         */
        this.onStateChanged = new EventEmitter();
    }
    /**
     * Returns true if this instance is in the `LoadingState.Loading` state, otherwise returns false.
     */
    get isLoading() {
        return this._state === LoadingState.Loading;
    }
    /**
     * Returns true if this instance is in the `LoadingState.Loaded` state, otherwise returns false.
     */
    get isLoaded() {
        return this._state === LoadingState.Loaded;
    }
    /**
     * Returns true if this instance is monitoring one or more active worker actions, otherwise returns false.
     */
    get isBusy() {
        return this._busyWatcher != undefined && this._busyWatcher.isBusy;
    }
    /**
     * Returns the current `LoadingState` of this instance.
     */
    get loadingState() {
        return this._state;
    }
    /**
     * Returns true if this instance is in the preparing state (see the `enterPrepare` and `exitPrepare` methods).
     */
    get isPreparing() {
        return this._isPreparing;
    }
    /**
     * Returns a collection of any errors that have been raised by managed actions.
     * This collection is cleared each time the `reset` method is invoked.
     */
    get errors() {
        return this._errors;
    }
    /**
     * Enters a preparation state during which `register` method may be invoked freely multiple times.
     * This method will throw if it is invoked while this instance is not in the `LoadingState.Initial` state
     * (see also the `exitPrepare` method).
     */
    enterPrepare() {
        if (this._isPreparing) {
            throw new Error('LoadingStateMonitor is already preparing.');
        }
        if (this._state !== LoadingState.Initial) {
            throw new Error('LoadingStateMonitor must be in the Initial state.');
        }
        this._nonce++;
        this._isPreparing = true;
        this.changeState(LoadingState.Loading);
    }
    /**
     * Enters a preparation state during which `register` method may be invoked freely multiple times.
     * This method will throw if it is invoked while this instance is not in the preparing state (see also the `enterPrepare` method).
     */
    exitPrepare() {
        if (!this._isPreparing) {
            throw new Error('LoadingStateMonitor is not in the preparing state.');
        }
        this._isPreparing = false;
        if (this._errors.length > 0) {
            this.reset(LoadingState.Failed);
        }
        else if (this._refCount <= 0 &&
            this.loadingState === LoadingState.Loading) {
            this.reset(LoadingState.Loaded);
        }
    }
    /**
     * Resets this instance's `loadingState` to the specified state (defaults to `LoadingState.initial`).
     * @param state the state to apply.
     */
    reset(state = LoadingState.Initial) {
        if (this._busyWatcher != undefined) {
            this._busyWatcher.reset();
        }
        this._nonce++;
        this._disposables.dispose();
        this._errors = [];
        this._refCount = 0;
        this.changeState(state);
    }
    /**
     * Registers one or more `Observable` instances as loading actions with this instance,
     * which will remain in a `Loading` state until all such registered actions have completed or one or more has errored.
     *
     * This method will throw if it is invoked while this instance is not either in the `LoadingState.Initial` state,
     * or is not preparing (see the `enterPrepare` and `exitPrepare` methods).
     * @param actions The actions to register.
     */
    register(...resource) {
        if (!(this.isPreparing || this._state === LoadingState.Initial)) {
            throw new Error('LoadingStateMonitor must be preparing or in the Initial state.');
        }
        if (!this._isPreparing) {
            try {
                this.enterPrepare();
                this.watch(resource);
            }
            finally {
                this.exitPrepare();
            }
        }
        else {
            this.watch(resource);
        }
    }
    /**
     * Registers an `Observable` instance with this instance, which will report a busy state
     * until all such registered actions have completed or errored.
     *
     * Workers can be registered at any time during this instance's lifecycle.
     * @param action The action to register.
     */
    registerWorker(target) {
        if (this._busyWatcher == undefined) {
            this._busyWatcher = new BusyWatcher(this._busyState$);
        }
        this._busyWatcher.watch(target);
    }
    /**
     * Unsubscribes from any active subscriptions, and releases any resources associated with this instance.
     */
    dispose() {
        this.reset();
    }
    watch(observables) {
        const nonce = this._nonce;
        observables.forEach(() => {
            this._refCount++;
        });
        observables.forEach(observable => {
            // We use an internal Dispsosables instance (as opposed Disposables.global) because we want to ensure that any active subscriptions
            // are unsubscribed from when the reset method is invoked.
            this._disposables.subscribeOnce(observable, item => {
                if (nonce !== this._nonce)
                    return;
                if (item instanceof ApiResponse && !item.isOk) {
                    this.registerError(item);
                }
                else if (--this._refCount <= 0) {
                    if (!this.isPreparing &&
                        this.loadingState === LoadingState.Loading) {
                        this.reset(LoadingState.Loaded);
                    }
                }
            }, error => {
                if (nonce === this._nonce) {
                    this.registerError(error);
                }
            });
        });
    }
    changeState(state) {
        if (this._state !== state) {
            this._state = state;
            // We queue the state changed event so that client code that subscribes to the registered observables
            // completes before the event is raised.
            setTimeout(() => {
                this._loadingState$.next(state);
                this.onStateChanged.emit(new LoadingStateChangedEventArgs(this, state));
            }, 0);
        }
    }
    registerError(error) {
        if (!this._isPreparing && this.loadingState === LoadingState.Loading) {
            this.reset(LoadingState.Failed);
        }
        this._errors.push(error);
        this.onError.emit(new LoadingStateErrorEventArgs(this, error));
    }
}

function formatAuditHeaders(headers, defaultValue) {
    if (Array.isArray(headers)) {
        const c = headers;
        headers = '';
        c.forEach(h => {
            const s = formatHeader(h);
            if (s != undefined)
                headers += s;
        });
    }
    else {
        headers = formatHeader(headers);
    }
    if (headers == undefined || headers === '') {
        headers = defaultValue ? `[${defaultValue}]` : '';
    }
    return headers;
}
function formatAuditMessage(headers, message) {
    return formatAuditHeaders(headers) + ` ${message}`;
}
function formatHeader(header) {
    let r;
    if (typeof header === 'string') {
        r = `[${header}]`;
    }
    else if (header.constructor) {
        r = `[${header.constructor.name}]`;
    }
    return r;
}

// @dynamic
class ExceptionMessageFormatter {
    static argument(parameterName, detail) {
        return appendDetail(`The argument "${parameterName}" is invalid.`, detail);
    }
    static argumentNull(parameterName) {
        return `The argument "${parameterName}" cannot be null.`;
    }
    static argumentOutOfRange(parameterName, lower, upper) {
        return `The argument "${parameterName}" must be between ${lower} and ${upper}.`;
    }
    static argumentBelowBound(parameterName, lowerBound) {
        return `The argument "${parameterName}" must be greater than or equal to ${lowerBound}.`;
    }
    static argumentAboveBound(parameterName, upperBound) {
        return `The argument "${parameterName}" must be less than or equal to ${upperBound}.`;
    }
    static argumentMustBeInt(parameterName) {
        return `The argument "${parameterName}" must be an integer.`;
    }
    static notImplemented() {
        return 'Not implemented.';
    }
    static notSupported(operationName) {
        return `${operationName} is not supported.`;
    }
    static invalidOperation(context, operationName, condition) {
        if (!operationName) {
            return formatAuditMessage(context, 'The operation is invalid due to the current state of the object.');
        }
        let result = `The "${operationName}" operation is invalid due to the current state of the object.`;
        result = appendDetail(result, condition);
        return formatAuditMessage(context, result);
    }
    static resolverFailed(typeName) {
        return `Failed to resolve ${typeName} on the active route.`;
    }
    static propertyNotAssigned(propertyName, type) {
        let result = `The property "${propertyName}" must be assigned`;
        if (type != undefined) {
            if (typeof type !== 'string' && type.constructor != undefined) {
                type = type.constructor.name;
            }
            result = `[${type}] ${result}`;
        }
        return result;
    }
}
function appendDetail(message, detail) {
    if (detail) {
        message += ' ' + detail;
    }
    return message;
}

class TypeHelper {
    constructor() { }
    static deleteFromArray(array, predicate) {
        if (array == undefined) {
            throw new Error(ExceptionMessageFormatter.argumentNull('array'));
        }
        if (predicate == undefined) {
            throw new Error(ExceptionMessageFormatter.argumentNull('predicate'));
        }
        let idx = array.findIndex(predicate);
        while (idx >= 0) {
            array.splice(idx, 1);
            idx = array.findIndex(predicate);
        }
    }
    static safeConvertInteger(src, defaultValue = 0) {
        let result;
        if (typeof src === 'string') {
            result = Number.parseInt(src, 10);
        }
        return Number.isInteger(result) ? result : defaultValue;
    }
    static isStringNullOrEmpty(s) {
        return s == undefined || s === '';
    }
    static sanitizeString(value, defaultValue = '') {
        if (value == undefined)
            return defaultValue;
        value = value.trim();
        return value.length > 0 ? value : defaultValue;
    }
    static empty() {
        return {};
    }
    static clone(src) {
        return cloneDeep(src);
    }
    static integerSafeSortCompare(x, y) {
        const x1 = parseInt(x);
        const y1 = parseInt(y);
        return x1 !== NaN && y1 !== NaN ? x1 - y1 : x < y ? -1 : 1;
    }
    static stringSortCompare(x, y) {
        return x < y ? -1 : x > y ? 1 : 0;
    }
    /**
     * Creates a new `Date` instance represnting the current date with the time component set to zero.
     */
    static today() {
        return TypeHelper.clearTime(new Date());
    }
    /**
     * Creates a new `Date` instance derived from a specified date, with the time component set to zero.
     */
    static dateOf(d) {
        return TypeHelper.clearTime(new Date(d.getTime()));
    }
    /**
     * Sets the time component of a `Date` instance to zero.
     */
    static clearTime(d) {
        d.setMilliseconds(0);
        d.setSeconds(0);
        d.setMinutes(0);
        d.setHours(0);
        return d;
    }
    static toUTC(date) {
        return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCMilliseconds());
    }
    static toUTCString(date, isLocalTime = true) {
        if (isLocalTime) {
            date = TypeHelper.toUTC(date);
        }
        const r = `${date.getFullYear()}-${formatTimeUnit(date.getMonth() + 1)}-${formatTimeUnit(date.getDate())}T${formatTimeUnit(date.getHours())}:${formatTimeUnit(date.getMinutes())}:${formatTimeUnit(date.getSeconds())}Z`;
        return r;
    }
    static localTimeFromUTCMilliseconds(ms) {
        if (ms == undefined) {
            throw new Error(ExceptionMessageFormatter.argumentNull('ms'));
        }
        const d = new Date(ms); // Construct a date
        return new Date(TypeHelper.toUTCString(d, false)); // Convert to local-time from UTC
    }
}
function formatTimeUnit(n) {
    return n < 10 ? '0' + n.toString() : n.toString();
}

/**
 * Contains helper functions applicable to multiple API services.
 */
class ApiHelper {
    // Returns a clone of the params object stripped of any null/undefined or empty values.
    static cleanParams(params) {
        if (params == undefined)
            return {};
        params = cloneDeep(params);
        return omitBy(params, isNil);
    }
    static addGenotypeSynonymCategoryParam(params, synCat) {
        if (synCat == undefined || synCat === '')
            return;
        params.synonymCategory = synCat;
    }
    static uriFromEntityRef(src) {
        if (typeof src === 'string')
            return src;
        if (ApiHelper.isRestUri(src))
            return src.href;
        return ApiHelper.selfUri(src);
    }
    static isRestUri(src) {
        if (typeof src != 'object')
            return false;
        return typeof src.href === 'string';
    }
    static selfUri(entity) {
        if (entity == undefined ||
            entity._links == undefined ||
            entity._links.self == undefined) {
            return undefined;
        }
        return entity._links.self.href;
    }
    static applyRestLinks(target) {
        if (target == undefined)
            return;
        if (Array.isArray(target)) {
            target.forEach(item => {
                ApiHelper.applyRestLinks(item);
            });
        }
        else if (typeof target._links === 'object') {
            for (const k in target._links) {
                if (k && k.endsWith('-link')) {
                    const v = target._links[k];
                    if (v != undefined) {
                        target[k.substr(0, k.length - 5)] = v.href;
                    }
                }
            }
        }
    }
}

class SequenceProcesor {
    constructor(actions) {
        this.actions = actions;
        this.result = new ReplaySubject(1);
        this._i = -1;
        this.next();
    }
    next() {
        this._i++;
        if (this._i < this.actions.length) {
            let target = this.actions[this._i]();
            if (!Array.isArray(target)) {
                target = [target];
            }
            // tslint:disable-next-line: no-use-before-declare
            AsyncHelper.awaitAsPromise(target).then(() => {
                this.next();
            });
        }
        else {
            this.result.next();
            this.result.complete();
        }
    }
}
/**
 * A helper class which exposes static methods useful for performing and managing asynchronous operations.
 */
// @dynamic
class AsyncHelper {
    static proxyAsSubject(initiator) {
        return proxy(new Subject(), initiator);
    }
    static proxyAsReplaySubject(initiator) {
        return proxy(new ReplaySubject(1), initiator);
    }
    static proxyAsBehaviourSubject(initiator, defaultValue) {
        return proxy(new BehaviorSubject(defaultValue), initiator);
    }
    /**
     * Returns an Observable which completes immediately.
     */
    static immediate() {
        const r = new ReplaySubject(1);
        r.complete();
        return r;
    }
    /**
     * Returns a function which, when invoked, will itself return a flattened array of `Observable` instances representing the actions of each
     * `WaitHandleSource`.
     *
     * This method is useful for processing `WaitHandleSource` implementations that should initiate at the same time and
     * can execute and complete concurrently, but which it is desirable to aggregate and treat as a batch (for example as an argument to the
     * rxjs `forkJoin` operator, or as an `AwaitAction` passed to the `AsyncHelper.awaitSequence` method).
     * @param source The `WaitHandleSource` array from which to construct the resultant `Observable` array.
     */
    static waitHandleInitiator(...source) {
        return () => {
            const actions = [];
            source.forEach((a) => {
                a.getLoadingWaitHandles().forEach((a2) => {
                    actions.push(a2);
                });
            });
            return actions;
        };
    }
    /**
     * Returns an `Observable` which emits and completes following a specified delay period. Useful for mocking.
     * @param milliseconds The period for which to delay.
     */
    static awaitDelay(milliseconds) {
        const r = new ReplaySubject(1);
        setTimeout(() => {
            r.next(undefined);
        }, milliseconds);
        return AsyncHelper.awaitWithComplete([r]);
    }
    /**
     * Accepts one or more `AwaitAction` functions which when executed should return an `Observable` or an array of `Observable` instances,
     * and returns an `Observable` which will emit and complete when the aggregate of all `Observable` instances returned by the
     * `AwaitAction` functions have completed.
     *
     * Each `AwaitAction` function is executed in sequence, with each function only commencing when the preceding function
     * has completed successfully. Be aware that an `AwaitAction` may itself represent a collection of actions, which may
     * themselves execute concurrently (i.e. not in sequence).
     *
     * This method is useful for processing `WaitHandleSource` implementations that should initiate at the same time and
     * can execute and complete concurrently, but which it is desirable to aggregate and treat as a batch (for example as an argument to the
     * rxjs `forkJoin` operator, or as an `AwaitAction` passed to the `AsyncHelper.awaitSequence` method).
     * @param source The `WaitHandleSource` array from which to construct the resultant `Observable` array.
     */
    static awaitSequence(...actions) {
        if (actions == undefined)
            throw new Error('actions');
        const procesor = new SequenceProcesor(actions);
        return procesor.result;
    }
    /**
     * Accepts an input `Observable` array, and returns a `Promise` which completes when all input observables have completed.
     *
     * This method uses the `AsyncHelper.awaitWithComplete` method to ensure that all input observables complete following their next emit.
     * @param source The input observables
     */
    static awaitAsPromise(source) {
        return AsyncHelper.awaitWithComplete(source).toPromise();
    }
    /**
     * Accepts an `Observable` array and returns an `Observable` instance which emits and completes when each input observable
     * has emitted and completed.
     *
     * This method uses the `AsyncHelper.ensureComplete` method to ensure that all input observables complete following their next emit.
     * @param source The input observables
     */
    static awaitWithComplete(source) {
        return AsyncHelper.await(AsyncHelper.ensureComplete(source));
    }
    /**
     * Accepts one or more `Observable` arrays and returns an `Observable` that will emit and complete when
     * all constituent observables in all arrays have emitted and completed.
     *
     * This method uses the `AsyncHelper.ensureComplete` method to ensure that all input observables complete following their next emit.
     * @param source The input observables
     */
    static awaitJoin(...source) {
        const all = [];
        source.forEach((sub) => {
            if (sub != undefined && sub.length > 0) {
                all.concat(sub);
            }
        });
        return AsyncHelper.awaitWithComplete(all);
    }
    /**
     * Accepts an `Observable` collection and returns an `Observable` that will emit and complete when all constituent observables
     * have emitted.
     * @param deps
     */
    static await(deps) {
        const result = new ReplaySubject(1);
        let done = false;
        Disposables.global.subscribeSubjectOnce(forkJoin(...deps).pipe(take(1), tap(() => {
            if (!done) {
                done = true;
                result.next();
                result.complete();
            }
        })), () => {
            if (!done) {
                done = true;
                result.next();
                result.complete();
            }
        });
        return result.asObservable();
    }
    /**
     * Accepts an `Observable` collection and returns a collection where each instance will complete upon the its next event.
     * This is useful when using rxjs functions such as `forkJoin`, and when using the `Observable` `toPromise` method.
     * @param src The input collection.
     */
    static ensureComplete(src) {
        if (src == undefined || src.length === 0)
            return [];
        const array = [];
        for (let i = 0; i < src.length; i++) {
            const o = src[i];
            if (o) {
                array.push(o.pipe(take(1)));
            }
        }
        return array;
    }
}
function proxy(proxy, initiator) {
    let completed = false;
    let subscription = initiator
        .pipe(catchError((e) => {
        completed = true;
        if (subscription != undefined) {
            subscription.unsubscribe();
            subscription = undefined;
        }
        proxy.error(e);
        return never();
    }))
        .subscribe((value) => {
        completed = true;
        if (subscription != undefined) {
            subscription.unsubscribe();
            subscription = undefined;
        }
        proxy.next(value);
        // Complete must be called to allow any downstream toPromise() translations to work.
        proxy.complete();
    });
    if (completed && subscription != undefined) {
        subscription.unsubscribe();
        subscription = undefined;
    }
    return proxy.asObservable();
}

/**
 * HttpClient actions are not initiated unless one or more observers are subscribed to their asscociated Observables.
 * Furthermore, HttpClient actions are initiated once for each subscribed observer.
 * HttpClientProxy acts as a proxy for an HttpClient instance, thereby ensuring that:
 * (a) The expected Http action is initiated irrespective of whether or not client code is observing it; and
 * (b) The action method returns an Observable which can be subscribed to any number of times without initiating further Http actions
 */
class HttpClientProxy {
    constructor(http) {
        this.http = http;
    }
    static create(http) {
        return new HttpClientProxy(http);
    }
    request(method, url, options) {
        return AsyncHelper.proxyAsSubject(this.http.request(method, url, options));
    }
    delete(url, options) {
        return AsyncHelper.proxyAsSubject(this.http.delete(url, options));
    }
    get(url, options) {
        return AsyncHelper.proxyAsSubject(this.http.get(url, options));
    }
    head(url, options) {
        return AsyncHelper.proxyAsSubject(this.http.head(url, options));
    }
    jsonp(url, callbackParam) {
        return AsyncHelper.proxyAsSubject(this.http.jsonp(url, callbackParam));
    }
    options(url, options) {
        return AsyncHelper.proxyAsSubject(this.http.options(url, options));
    }
    patch(url, body, options) {
        return AsyncHelper.proxyAsSubject(this.http.patch(url, body, options));
    }
    post(url, body, options) {
        return AsyncHelper.proxyAsSubject(this.http.post(url, body, options));
    }
    put(url, body, options) {
        return AsyncHelper.proxyAsSubject(this.http.put(url, body, options));
    }
}

class ApiServiceBase {
    constructor(serviceBase, http) {
        this.serviceBase = serviceBase;
        this.http = HttpClientProxy.create(http);
    }
    getLinkedUriAsApiResponse(links, key, params = {}, options) {
        if (key == undefined) {
            throw new Error(ExceptionMessageFormatter.argumentNull('key'));
        }
        if (links == undefined)
            return notFoundResponse();
        const uri = links[key];
        if (uri == undefined || TypeHelper.isStringNullOrEmpty(uri.href)) {
            return notFoundResponse();
        }
        return this.getAsApiResponse(uri.href, params, options);
    }
    getUriAsApiResponse(uri, params = {}, options) {
        if (uri == undefined) {
            throw new Error(ExceptionMessageFormatter.argumentNull('uri'));
        }
        return this.getAsApiResponse(uri, params, options);
    }
    // protected createEventSource(endPoint: string): Observable<NativeEventSource> {
    //   const EventSource = NativeEventSource || EventSourcePolyfill;
    //   const url = `${this.serviceBase}/${endPoint}`;
    //   return AuthService.singleton.getToken().pipe(
    //     map(token => new EventSource(url, { authorizationHeader: "bearer " + token }))
    //   );
    // }
    createEventSource(endPoint) {
        const EventSource = NativeEventSource || EventSourcePolyfill;
        const eventSource = new EventSource(`${this.serviceBase}/${endPoint}`);
        console.log('WARNING: Cannot pass an auth-header using SSE. See ApiServiceBase inline comments for a potential solution.');
        // It seems that it is not possible to pass custom headers to the server using SSE (Server Side Events).
        // One common solution is to pass an authentication token in the SSE URL. It is not recommended that the standard token is pased in
        // this manner, as the URL cannot be encrypted over an HTTPS connection.
        // An option is to expose an API endpoint which accepts an authenticated request in the header
        // and returns a short-lived (example 60 seconds) temporary token which can then be passed to the
        // SSE endpoint embedded in the URL. This requires the client to regularly poll the server
        // for a new temporary token and then update the EventSource with the new auth token.
        return new BehaviorSubject(eventSource).asObservable();
    }
    getAsApiResponse(endPoint, params = {}, options) {
        return this.apiMapWithOptions(options, this.get(endPoint, params));
    }
    get(endPoint, params = {}) {
        params = this.flattenParams(params);
        return this.http
            .get(this.formatUrl(endPoint), { params })
            .pipe(applyRestLinks());
    }
    getAndMapAsApiResponse(endPoint, mapFunction, params = {}, options) {
        return this.apiMapWithOptions(options, this.getAndMap(endPoint, mapFunction, params));
    }
    getAndMap(endPoint, mapFunction, params = {}) {
        params = this.flattenParams(params);
        return this.http
            .get(`${this.serviceBase}/${endPoint}`, { params })
            .pipe(applyRestLinks(), map(mapFunction));
    }
    getCsvResponseAsApiResponse(endPoint, params = {}) {
        return ApiResponse.inverseMap(this.getCsvResponse(endPoint, params));
    }
    getCsvResponse(endPoint, params = {}) {
        params = this.flattenParams(params);
        return this.http.get(this.formatUrl(endPoint), {
            params: params,
            headers: new HttpHeaders({ 'Content-Type': 'text/csv' }),
            responseType: 'blob'
        });
    }
    postJsonDataAsApiResponse(endPoint, body, params = {}) {
        return ApiResponse.inverseMap(this.postJsonData(endPoint, body, params));
    }
    postJsonData(endPoint, body, params = {}) {
        const headers = new HttpHeaders();
        headers.append('Content-Type', 'multipart/form-data');
        headers.append('Accept', 'application/json');
        params = this.flattenParams(params);
        return this.http.post(this.formatUrl(endPoint), body, {
            params: params,
            headers: headers,
            responseType: 'blob'
        });
    }
    postAsApiResponse(endPoint, body, params = {}) {
        return ApiResponse.inverseMap(this.post(endPoint, body, params).pipe(applyRestLinks()));
    }
    post(endPoint, body, params = {}) {
        return this.http
            .post(`${this.serviceBase}/${endPoint}`, body, {
            params
        })
            .pipe(applyRestLinks());
    }
    putAsApiResponse(endPoint, body, params = {}) {
        return ApiResponse.inverseMap(this.put(endPoint, body, params).pipe(applyRestLinks()));
    }
    put(endPoint, body, params = {}) {
        return this.http
            .put(this.formatUrl(endPoint), body, {
            params
        })
            .pipe(applyRestLinks());
    }
    deleteAsApiResponse(endPoint) {
        return ApiResponse.inverseMap(this.delete(endPoint).pipe(applyRestLinks()));
    }
    delete(endPoint) {
        return this.http.delete(this.formatUrl(endPoint)).pipe(applyRestLinks(), catchError((error) => throwError(error)));
    }
    flattenParams(params) {
        const cleanedParams = omitBy(params, isNil);
        return flatten(cleanedParams, { safe: true });
    }
    formatUrl(url) {
        if (!url.startsWith('http:') && !url.startsWith('https:')) {
            url = url = `${this.serviceBase}/${url}`;
        }
        return url;
    }
    apiMapWithOptions(options, source) {
        if (options == undefined)
            return ApiResponse.inverseMap(source);
        // Return a different Observable to prevent this mapping reccurring with each downstream subscription.
        const result = new Subject();
        Disposables.global.subscribeSubjectOnce(ApiResponse.inverseMap(source), r => {
            try {
                result.next(r.isOk ? ApiResponse.ok(this.applyApiOptions(options, r.result)) : r);
            }
            catch (e) {
                result.next(ApiResponse.error(e));
            }
        });
        return result.asObservable();
    }
    applyApiOptions(options, item) {
        if (options == undefined)
            return item;
        if (options.embeddedEntityName != undefined) {
            item = this.stripEmbedded(options.embeddedEntityName, item);
        }
        return item;
    }
    stripEmbedded(entityName, item) {
        if (item == undefined)
            return undefined;
        const opName = 'Strip Spring Embedded Artifacts';
        if (item._embedded == undefined) {
            throw new Error(ExceptionMessageFormatter.invalidOperation(this, opName, 'Not a Spring embedded entity - no _embedded property exists.'));
        }
        const entity = item._embedded[entityName];
        if (entity == undefined) {
            throw new Error(ExceptionMessageFormatter.invalidOperation(this, opName, `No property named "${entityName}" exists on the Spring _embedded entity.`));
        }
        return entity;
    }
}
function notFoundResponse() {
    return of(ApiResponse.error(ApiResponseCode.NotFound));
}
function applyRestLinks() {
    return tap(r => {
        ApiHelper.applyRestLinks(r);
    });
}

class ServiceBase extends ApiServiceBase {
    constructor(http, apiBaseUrl) {
        super(apiBaseUrl, http);
    }
    apiService(serviceType, entity, requestBody, uuid, query) {
        const request = requestBody ? requestBody : entity;
        const queryString = serviceType.query ? serviceType.query : query;
        switch (serviceType.action) {
            case 'GET':
                return this.getAsApiResponse(`${serviceType.endpoint}/${uuid}`);
            case 'CREATE':
                return this.postAsApiResponse(serviceType.endpoint, requestBody);
            case 'UPDATE':
                return this.putAsApiResponse(`${serviceType.endpoint}/${entity.uuid}`, request);
            case 'UPDATEQUERY':
                return this.putAsApiResponse(`${serviceType.endpoint}/${entity.uuid}${queryString}`, request);
            case 'DELETE':
                return this.deleteAsApiResponse(`${serviceType.endpoint}/${entity.uuid}`);
            case 'CLONE':
                return this.postAsApiResponse(`${serviceType.endpoint}/${entity.uuid}/clone`, requestBody);
            case 'GETLIST':
                return this.getAsApiResponse(`${serviceType.endpoint}${uuid ? uuid : ''}${serviceType.query ? serviceType.query : ''}`);
            default:
                throw new Error('invalid or missing actionType');
        }
    }
    uploadService(endpoint, formData) {
        const obs = this.http.post(endpoint, formData, {
            reportProgress: true,
            observe: 'events'
        });
        return obs;
    }
}

const KUP_CORE_CONFIG = new InjectionToken('core.config');

class ApiService extends ServiceBase {
    constructor(http, config) {
        super(http, config.managementApi);
        this.config = config;
    }
    get endpoint() {
        return this.config.managementApi;
    }
}
ApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ApiService, deps: [{ token: i1$1.HttpClient }, { token: KUP_CORE_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable });
ApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ApiService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () {
        return [{ type: i1$1.HttpClient }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [KUP_CORE_CONFIG]
                    }] }];
    } });
class OapiService extends ServiceBase {
    constructor(http, config) {
        super(http, config.observationsApi);
        this.config = config;
    }
}
OapiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: OapiService, deps: [{ token: i1$1.HttpClient }, { token: KUP_CORE_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable });
OapiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: OapiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: OapiService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () {
        return [{ type: i1$1.HttpClient }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [KUP_CORE_CONFIG]
                    }] }];
    } });
class LabApiService extends ServiceBase {
    constructor(http, config) {
        super(http, config.labApi);
        this.config = config;
    }
}
LabApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: LabApiService, deps: [{ token: i1$1.HttpClient }, { token: KUP_CORE_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable });
LabApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: LabApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: LabApiService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () {
        return [{ type: i1$1.HttpClient }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [KUP_CORE_CONFIG]
                    }] }];
    } });
class HapiService extends ServiceBase {
    constructor(http, config) {
        super(http, config.hapApi);
        this.config = config;
    }
}
HapiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: HapiService, deps: [{ token: i1$1.HttpClient }, { token: KUP_CORE_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable });
HapiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: HapiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: HapiService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () {
        return [{ type: i1$1.HttpClient }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [KUP_CORE_CONFIG]
                    }] }];
    } });
class AapiService extends ServiceBase {
    constructor(http, config) {
        super(http, config.aapi);
        this.config = config;
    }
}
AapiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AapiService, deps: [{ token: i1$1.HttpClient }, { token: KUP_CORE_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable });
AapiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AapiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AapiService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () {
        return [{ type: i1$1.HttpClient }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [KUP_CORE_CONFIG]
                    }] }];
    } });
class PapiService extends ServiceBase {
    constructor(http, config) {
        super(http, config.printingApi);
        this.config = config;
    }
}
PapiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: PapiService, deps: [{ token: i1$1.HttpClient }, { token: KUP_CORE_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable });
PapiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: PapiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: PapiService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () {
        return [{ type: i1$1.HttpClient }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [KUP_CORE_CONFIG]
                    }] }];
    } });

class MapiServiceBase extends ApiServiceBase {
    constructor(http, managementApi) {
        super(managementApi, http);
    }
}

const maxPageSize = 1000;
const defaultExportPageSize = 2147483647;

const GET_USER_GROUPS = {
    action: 'GETLIST',
    endpoint: `keycloak/groups?size=${defaultExportPageSize}`
};
/**
 * A collection of shared services used across multiple modules
 */
class ApiSharedServices extends MapiServiceBase {
    constructor(http, service, config) {
        super(http, config.managementApi);
        this.service = service;
    }
    /**
     * format entity permissions for the permission-settings components.
     * @uuid of the entity giving the group permission to
     * @entity is item the group is getting permission to
     */
    loadPermissions(uuid, entity) {
        const endpoint = `${entity}/${uuid}/permissions`;
        return this.getPermissions(endpoint).pipe(map(r => {
            if (r.isOk) {
                return r.result.map(item => {
                    item['canRead'] = {
                        disabled: true,
                        checked: true
                    };
                    item['canCapture'] = {
                        disabled: item['canEdit'] === true,
                        checked: item['canCapture'] === true
                    };
                    item['canEdit'] = {
                        disabled: false,
                        checked: item['canEdit'] === true
                    };
                    return item;
                });
            }
        }));
    }
    /**
     * fetch usergroups
     */
    loadUserGroups() {
        const obs = this.service.apiService(GET_USER_GROUPS, null, null);
        return obs;
    }
    /**
     * fetch usergroups users
     */
    loadUserGroupsUsers(groupId) {
        const GET_USER_GROUP_USERS = {
            action: 'GET',
            endpoint: `keycloak/groups/${groupId}/members?size=${defaultExportPageSize}`
        };
        const obs = this.service.apiService(GET_USER_GROUP_USERS, null, null, '');
        return obs;
    }
    /**
     * save the permission updates
     * @$event is data received from the form
     * @entity is the item the group is getting permission to, to build the endpoint
     * @uuid is the uuid of the entity, to build the endpoint
     */
    setPermission($event, uuid, entity) {
        switch ($event.action) {
            case 'add':
            case 'update':
                return this.service.apiService({
                    action: 'CREATE',
                    endpoint: `${entity}/${uuid}/permissions`
                }, null, {
                    keycloakUserName: $event.action === 'add'
                        ? $event.data.name
                        : $event.data.keycloakUserName,
                    keycloakUserId: $event.action === 'add'
                        ? $event.data.uuid
                        : $event.data.keycloakUserId,
                    canRead: true,
                    canCapture: $event.data.canCapture.checked || $event.data.canEdit.checked,
                    canEdit: $event.data.canEdit.checked
                });
            case 'delete':
                return this.service.apiService({
                    action: 'DELETE',
                    endpoint: `${entity}/${uuid}`
                }, {
                    uuid: `permissions?keycloakUserId=${$event.data.keycloakUserId}`
                });
            default:
                return of();
        }
    }
    /**
     * fetch entity permissions
     * @endpoint is made up from the entity and uuid to get the data
     */
    getPermissions(endpoint) {
        return this.service.apiService({
            action: 'GET',
            endpoint: endpoint
        }, null, null, '');
    }
}
ApiSharedServices.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ApiSharedServices, deps: [{ token: i1$1.HttpClient }, { token: ApiService }, { token: KUP_CORE_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable });
ApiSharedServices.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ApiSharedServices, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ApiSharedServices, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () {
        return [{ type: i1$1.HttpClient }, { type: ApiService }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [KUP_CORE_CONFIG]
                    }] }];
    } });

class AsyncApiOutcomeDescriptorFactory {
    static createBasic(response, entityType, actionType) {
        return {
            response: response,
            actionType: actionType,
            entityType: entityType
        };
    }
    static createEntityNamed(response, entityType, actionType, entityName) {
        const result = AsyncApiOutcomeDescriptorFactory.createBasic(response, entityType, actionType);
        result.entityName = entityName;
        return result;
    }
    static createPropertyNamed(response, entityType, actionType, propertyName) {
        const result = AsyncApiOutcomeDescriptorFactory.createBasic(response, entityType, actionType);
        result.propertyName = propertyName;
        return result;
    }
}
class ApiOutcomeDescriptorFactory {
    static createBasic(response, entityType, actionType) {
        return {
            response: response,
            actionType: actionType,
            entityType: entityType
        };
    }
    static createEntityNamed(response, entityType, actionType, entityName) {
        const result = ApiOutcomeDescriptorFactory.createBasic(response, entityType, actionType);
        result.entityName = entityName;
        return result;
    }
    static createPropertyNamed(response, entityType, actionType, propertyName) {
        const result = ApiOutcomeDescriptorFactory.createBasic(response, entityType, actionType);
        result.propertyName = propertyName;
        return result;
    }
}

function defaultApiOutcomeHandler(formatter, descriptor) {
    let handled = false;
    if (!descriptor.response.isOk) {
        const category = ApiResponse.getErrorCategory(descriptor.response.code);
        switch (category) {
            case ApiErrorCategory.UniqueNameViolation:
                descriptor.failureLevel = FailureLevel.Warn;
                descriptor.detailMessage = formatter.entityExists(descriptor.entityType, descriptor.entityName);
                handled = true;
                break;
            case ApiErrorCategory.UniqueConstraintViolation:
                descriptor.failureLevel = FailureLevel.Warn;
                descriptor.detailMessage = formatter.entityConstraintViolation(descriptor.entityType, descriptor.propertyName
                    ? descriptor.propertyName
                    : getPropertyName(descriptor.response.code));
                handled = true;
                break;
            case ApiErrorCategory.GenericError:
                handled = handleEdgeCases(formatter, descriptor);
                break;
        }
    }
    if (!handled) {
        descriptor.detailMessage = formatter.apiResponse(descriptor);
    }
    return handled;
}
function handleEdgeCases(formatter, descriptor) {
    let handled = true;
    switch (descriptor.response.code) {
        case ApiResponseCode.DuplicateTaskObservation:
        case ApiResponseCode.DuplicateOperationsPlanTaskObservation:
            descriptor.failureLevel = FailureLevel.Warn;
            descriptor.detailMessage = formatter.apiResponseCode(ApiResponseCode.DuplicateOperationsPlanTaskObservation);
            break;
        default:
            handled = false;
            break;
    }
    return handled;
}
function getPropertyName(code) {
    switch (code) {
        case ApiResponseCode.SiteUniqueCode:
            return 'Code';
        default:
            return undefined;
    }
}

class OapiServiceBase extends ApiServiceBase {
    constructor(http, observationApi) {
        super(observationApi, http);
    }
}

class FileLink {
    constructor(name, s3Key) {
        this.name = name;
        this.s3Key = s3Key;
    }
}

class DropdownItem {
    constructor(label, value) {
        this.label = label;
        this.value = value;
    }
}

var UserRightsFlags;
(function (UserRightsFlags) {
    UserRightsFlags[UserRightsFlags["None"] = 0] = "None";
    UserRightsFlags[UserRightsFlags["canRead"] = 1] = "canRead";
    UserRightsFlags[UserRightsFlags["canCapture"] = 2] = "canCapture";
    UserRightsFlags[UserRightsFlags["canEdit"] = 4] = "canEdit";
})(UserRightsFlags || (UserRightsFlags = {}));
class RightsSummary {
    static toUserRightsFlags(summary) {
        let flags = UserRightsFlags.None;
        if (summary != undefined) {
            if (summary.canCapture) {
                // tslint:disable-next-line: no-bitwise
                flags |= UserRightsFlags.canCapture;
            }
            if (summary.canRead) {
                // tslint:disable-next-line: no-bitwise
                flags |= UserRightsFlags.canRead;
            }
            if (summary.canEdit) {
                // tslint:disable-next-line: no-bitwise
                flags |= UserRightsFlags.canEdit;
            }
        }
        return flags;
    }
}

/**
 * api models
 */

class BusyStateWrapperComponent {
    constructor() { }
    ngOnInit() { }
    get isLoading() {
        return (this.state == undefined ||
            (!this.suppressLoading &&
                this.state &&
                this.state.loadingState === LoadingState.Loading));
    }
    get isLoaded() {
        return this.state && this.state.loadingState === LoadingState.Loaded;
    }
    get isBusy() {
        return !this.suppressBusy && this.state && this.state.isBusy;
    }
}
BusyStateWrapperComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: BusyStateWrapperComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
BusyStateWrapperComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: BusyStateWrapperComponent, selector: "app-busystate-wrapper", inputs: { state: "state", suppressLoading: "suppressLoading", suppressBusy: "suppressBusy" }, ngImport: i0, template: "<span *ngIf=\"isLoading\" style=\"padding: 0px 10px 0px 10px;\">\r\n    <mat-spinner class=\"busy-spinner\" diameter=\"40\" style=\"display: inline-block;top:10px;\">\r\n    </mat-spinner>\r\n    Loading...\r\n</span>\r\n<ng-content *ngIf=\"isLoaded\"></ng-content>", styles: [""], dependencies: [{ kind: "component", type: i1$2.MatProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "diameter", "strokeWidth", "mode", "value"], exportAs: ["matProgressSpinner"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: BusyStateWrapperComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-busystate-wrapper', template: "<span *ngIf=\"isLoading\" style=\"padding: 0px 10px 0px 10px;\">\r\n    <mat-spinner class=\"busy-spinner\" diameter=\"40\" style=\"display: inline-block;top:10px;\">\r\n    </mat-spinner>\r\n    Loading...\r\n</span>\r\n<ng-content *ngIf=\"isLoaded\"></ng-content>" }]
        }], ctorParameters: function () { return []; }, propDecorators: { state: [{
                type: Input
            }], suppressLoading: [{
                type: Input
            }], suppressBusy: [{
                type: Input
            }] } });

var ButtonStateFlags;
(function (ButtonStateFlags) {
    ButtonStateFlags[ButtonStateFlags["Never"] = 0] = "Never";
    ButtonStateFlags[ButtonStateFlags["Busy"] = 1] = "Busy";
    ButtonStateFlags[ButtonStateFlags["Loading"] = 2] = "Loading";
    // tslint:disable-next-line: no-bitwise
    ButtonStateFlags[ButtonStateFlags["BusyOrLoading"] = 3] = "BusyOrLoading";
})(ButtonStateFlags || (ButtonStateFlags = {}));

/**
 * Intended to lookup a text resource
 */
var EntityTypeKey$1;
(function (EntityTypeKey) {
    EntityTypeKey["GenericData"] = "entity-type.generic-data";
    EntityTypeKey["BiomaterialCollection"] = "entity-type.biomaterial-collection";
    EntityTypeKey["Cane"] = "entity-type.cane";
    EntityTypeKey["Plant"] = "entity-type.plant";
    EntityTypeKey["Fruit"] = "entity-type.fruit";
    EntityTypeKey["Scion"] = "entity-type.scion";
    EntityTypeKey["Sample"] = "entity-type.sample";
    EntityTypeKey["ObservationValue"] = "entity-type.observation-value";
    EntityTypeKey["Trial"] = "entity-type.trial";
    EntityTypeKey["TrialPermission"] = "entity-type.trial-permission";
    EntityTypeKey["TrialSeason"] = "entity-type.trial-season";
    EntityTypeKey["TrialTask"] = "entity-type.trial-task";
    EntityTypeKey["TrialNote"] = "entity-type.trial-note";
    EntityTypeKey["TrialObservation"] = "entity-type.trial-observation";
    EntityTypeKey["Genotype"] = "entity-type.genotype";
    EntityTypeKey["GenotypeLabelAssignment"] = "entity-type.genotype-label-assignment";
    EntityTypeKey["Site"] = "entity-type.site";
    EntityTypeKey["Season"] = "entity-type.season";
    EntityTypeKey["Scale"] = "entity-type.scale";
    EntityTypeKey["Process"] = "entity-type.process";
    EntityTypeKey["FactorKeyword"] = "entity-type.factor-keyword";
    EntityTypeKey["Trait"] = "entity-type.trait";
    EntityTypeKey["Factor"] = "entity-type.factor";
    EntityTypeKey["ImportType"] = "entity-type.import-type";
    EntityTypeKey["Import"] = "entity-type.import";
    EntityTypeKey["Method"] = "entity-type.method";
    EntityTypeKey["TrialTreatment"] = "entity-type.treatment";
    EntityTypeKey["UserPreferences"] = "entity-type.user-prefs";
    EntityTypeKey["OperationsPlan"] = "entity-type.operations-plan";
    EntityTypeKey["OperationsPlanTask"] = "entity-type.operations-plan-task";
    EntityTypeKey["OperationsPlanTrialAssociation"] = "entity-type.operations-plan-trial-assoc";
    EntityTypeKey["TaskObservation"] = "entity-type.task-observation";
    EntityTypeKey["SeasonOperationsPlan"] = "entity-type.season-operations-plan";
    EntityTypeKey["User"] = "entity-type.user";
    EntityTypeKey["UserData"] = "entity-type.user-data";
    EntityTypeKey["UserGroup"] = "entity-type.user-group";
    EntityTypeKey["QueryFilter"] = "entity-type.query-filter";
    EntityTypeKey["RemoteProcess"] = "entity-type.remote-proc";
    EntityTypeKey["Task"] = "entity-type.task";
    EntityTypeKey["Observation"] = "entity-type.observation";
})(EntityTypeKey$1 || (EntityTypeKey$1 = {}));

class MessageFormatter {
    constructor(resolver) {
        this.resolver = resolver;
    }
    userDisplayName(user) {
        if (TypeHelper.isStringNullOrEmpty(user.firstName) &&
            TypeHelper.isStringNullOrEmpty(user.lastName)) {
            return user.username;
        }
        if (TypeHelper.isStringNullOrEmpty(user.lastName))
            return user.firstName;
        return `${user.firstName} ${user.lastName}`;
    }
    apiResponseCode(code) {
        return this.resolver.getText('api-code.' + code);
    }
    apiResponse(descriptor) {
        let result;
        if (descriptor.response.code === ApiResponseCode.Custom) {
            result = descriptor.response.message;
        }
        return !TypeHelper.isStringNullOrEmpty(result)
            ? result
            : this.standardApiResponse(descriptor);
    }
    standardApiResponse(descriptor) {
        let result;
        const entityType = descriptor.entityType
            ? descriptor.entityType
            : EntityTypeKey$1.GenericData;
        if (descriptor.response.isOk) {
            switch (descriptor.actionType) {
                case ApiActionType.Create:
                    result = this.createSucceeded(entityType, descriptor.entityName);
                    break;
                case ApiActionType.Update:
                    result = this.updateSucceeded(entityType, descriptor.entityName);
                    break;
                case ApiActionType.Delete:
                    result = this.deleteSucceeded(entityType, descriptor.entityName);
                    break;
                case ApiActionType.Upload:
                    result = this.uploadSucceeded(entityType, descriptor.entityName);
                    break;
                case ApiActionType.Execute:
                    result = this.executeSucceeded(entityType, descriptor.entityName);
                    break;
                default:
                    result = this.genericSuccess();
                    break;
            }
        }
        else {
            switch (descriptor.actionType) {
                case ApiActionType.Create:
                    result = this.createFailed(entityType, descriptor.entityName);
                    break;
                case ApiActionType.Update:
                    result = this.updateFailed(entityType, descriptor.entityName);
                    break;
                case ApiActionType.Delete:
                    result = this.deleteFailed(entityType, descriptor.entityName);
                    break;
                case ApiActionType.Load:
                    result = this.loadFailed(entityType);
                    break;
                case ApiActionType.LoadCollection:
                    result = this.loadCollectionFailed(entityType);
                    break;
                case ApiActionType.Upload:
                    result = this.uploadFailed(entityType);
                    break;
                case ApiActionType.Execute:
                    result = this.executeFailed(entityType, descriptor.entityName);
                    break;
                default:
                    result = this.genericFailure();
                    break;
            }
        }
        return result;
    }
    genericSuccess() {
        return 'The operation completed successfully.';
    }
    genericFailure() {
        return 'The operation failed.';
    }
    executeSucceeded(entityTypeKey, name) {
        if (stringHasValue(name)) {
            return `The ${this.resolver.getText(entityTypeKey)} "${name}" executed successfully.`;
        }
        return `The ${this.resolver.getText(entityTypeKey)} executed successfully.`;
    }
    executeFailed(entityTypeKey, name) {
        if (stringHasValue(name)) {
            return `Failed to execute the ${this.resolver.getText(entityTypeKey)} "${name}".`;
        }
        return `Failed to execute the ${this.resolver.getText(entityTypeKey)}.`;
    }
    uploadFailed(entityTypeKey) {
        return `Failed to upload the ${this.resolver.getText(entityTypeKey)}.`;
    }
    loadFailed(entityTypeKey) {
        return `Failed to load the ${this.resolver.getText(entityTypeKey)}.`;
    }
    loadCollectionFailed(entityTypeKey) {
        return `Failed to load the ${this.resolver.getText(entityTypeKey)} collection.`;
    }
    createSucceeded(entityTypeKey, name) {
        if (stringHasValue(name)) {
            return `The ${this.resolver.getText(entityTypeKey)} "${name}" was created successfully.`;
        }
        return `The ${this.resolver.getText(entityTypeKey)} was created successfully.`;
    }
    createFailed(entityTypeKey, name) {
        if (stringHasValue(name)) {
            return `Failed to create the ${this.resolver.getText(entityTypeKey)} "${name}".`;
        }
        return `Failed to create the ${this.resolver.getText(entityTypeKey)}.`;
    }
    updateSucceeded(entityTypeKey, name) {
        if (stringHasValue(name)) {
            return `The ${this.resolver.getText(entityTypeKey)} "${name}" was updated successfully.`;
        }
        return `The ${this.resolver.getText(entityTypeKey)} was updated successfully.`;
    }
    updateFailed(entityTypeKey, name) {
        if (stringHasValue(name)) {
            return `Failed to update the ${this.resolver.getText(entityTypeKey)} "${name}".`;
        }
        return `Failed to update the ${this.resolver.getText(entityTypeKey)}.`;
    }
    deleteSucceeded(entityTypeKey, name) {
        if (stringHasValue(name)) {
            return `The ${this.resolver.getText(entityTypeKey)} "${name}" was deleted.`;
        }
        return `The ${this.resolver.getText(entityTypeKey)} was deleted.`;
    }
    deleteFailed(entityTypeKey, name) {
        if (stringHasValue(name)) {
            return `Failed to delete the ${this.resolver.getText(entityTypeKey)} "${name}".`;
        }
        return `Failed to delete the ${this.resolver.getText(entityTypeKey)}.`;
    }
    notExistsOrDenied(entityTypeKey) {
        return `The ${this.resolver.getText(entityTypeKey)} either does not exist or you do not have permission to access it.`;
    }
    entityExists(entityTypeKey, name) {
        if (stringHasValue(name)) {
            return `The ${this.resolver.getText(entityTypeKey)} "${name}" already exists.`;
        }
        return `The ${this.resolver.getText(entityTypeKey)} already exists.`;
    }
    entityConstraintViolation(entityTypeKey, name) {
        if (stringHasValue(name)) {
            return `The property "${name}" has the same value on another ${this.resolver.getText(entityTypeKey)}.`;
        }
        return `The ${this.resolver.getText(entityTypeKey)} violates a unique contraint rule.`;
    }
    uploadSucceeded(entityTypeKey, name) {
        if (stringHasValue(name)) {
            return `The ${this.resolver.getText(entityTypeKey)} "${name}" was uploaded successfully.`;
        }
        return `The ${this.resolver.getText(entityTypeKey)} was uploaded successfully.`;
    }
    warnValueOutOfRange(fieldName, min, max) {
        if (min == undefined && max == undefined) {
            return `${fieldName} is outside of the range of expected values.`;
        }
        if (min == undefined) {
            return `${fieldName} should be less-than-or-equal-to ${max}.`;
        }
        if (max == undefined) {
            return `${fieldName} should be greater-than-or-equal to ${min}.`;
        }
        return `${fieldName} should be greater-than-or-equal to ${min} and less-than-or-equal-to ${max}.`;
    }
    warnDateValueOutOfRange(fieldName, compFieldName, min, max) {
        if (min == undefined && max == undefined) {
            return `${fieldName} is outside of the range of expected values.`;
        }
        if (min == undefined) {
            return `${fieldName} should be no later than ${max} day(s) after ${compFieldName}.`;
        }
        if (max == undefined) {
            return `${fieldName} should be no earlier than ${min} day(s) before ${compFieldName}.`;
        }
        return `${fieldName} should be between ${min} day(s) before and ${max} day(s) after ${compFieldName}.`;
    }
}
function stringHasValue(s) {
    return s != undefined && s !== '';
}

const stringFormatRegex = /\{([0-9a-zA-Z]+)\}/g;
class FormatHelper {
    static nameOrResolvingToken(src) {
        if (typeof src !== 'string')
            src = src ? src.name : undefined;
        return TypeHelper.isStringNullOrEmpty(src)
            ? FormatHelper.resolvingToken
            : src;
    }
    /**
     * Replaces tokens in the specified format string with the specified arguments.
     *
     * Usage:
     *
     * `FormatHelper.format("Index-0 = {0}, Index-1 = {1}", ["One", "Two"])`
     *
     * or
     *
     * `FormatHelper.format("Lookup-Name = {name}, Lookup-Value = {value}", { name: 'One', value: '1' })`;
     * @param format
     * @param args
     */
    static string(format, ...args) {
        let data;
        if (args.length === 1 && typeof args[0] === 'object') {
            data = args[0];
        }
        else {
            data = args;
        }
        return format.replace(stringFormatRegex, (match, token, index) => {
            let result;
            if (format[index - 1] === '{' && format[index + match.length] === '}') {
                result = token;
            }
            else {
                result = data[token];
            }
            return result != undefined ? result : '';
        });
    }
    static formatEntityName(entity, propertyName = 'name') {
        return entity != undefined && entity[propertyName] !== undefined
            ? entity[propertyName]
            : '[unresolved entity]';
    }
    static formatDateTimeAsUTC(date, isLocalTime = true) {
        return TypeHelper.toUTCString(date, isLocalTime);
    }
    /**
     * Formats a Date as a human-readable date string (time components omitted).
     */
    static formatUIDate(date) {
        return `${FormatHelper.formatTimeUnit(date.getDate())}/${FormatHelper.formatTimeUnit(date.getMonth() + 1)}/${date.getFullYear()}`;
    }
    /**
     * Formats a Date as a human-readable date-time string.
     */
    static formatUIDateTime(date) {
        return `${FormatHelper.formatUIDate(date)} ${FormatHelper.formatTimeUnit(date.getHours())}:${FormatHelper.formatTimeUnit(date.getMinutes())}:${FormatHelper.formatTimeUnit(date.getSeconds())}`;
    }
    /** Formats a Date for binding to a standard UI date-time control (such as <input type="datetime-local" /> ) */
    static formatControlDateTime(date) {
        return `${date.getFullYear()}-${FormatHelper.formatTimeUnit(date.getMonth() + 1)}-${FormatHelper.formatTimeUnit(date.getDate())}T${FormatHelper.formatTimeUnit(date.getHours())}:${FormatHelper.formatTimeUnit(date.getMinutes())}`;
    }
    static formatTimeUnit(n) {
        return n < 10 ? '0' + n.toString() : n.toString();
    }
    static formatRoutePath(route) {
        let result = '';
        route.snapshot.pathFromRoot.forEach((r) => {
            r.url.forEach((s) => {
                if (TypeHelper.isStringNullOrEmpty(s.path))
                    return;
                if (result.length > 0) {
                    result += '/';
                }
                result += s.path;
            });
        });
        return result;
    }
    static formatAuditHeaders(headers, defaultValue) {
        return formatAuditHeaders(headers, defaultValue);
    }
    static formatAuditMessage(headers, message) {
        return formatAuditMessage(headers, message);
    }
}
/**
 * Used in the UI as a placeholder for text that is still being resolved asynchronously.
 */
FormatHelper.resolvingToken = '...';

/**
 * A text-resource dictionary.
 * All application text resources (labels, field-names, messages, form-titles, etc) should be defined here,
 * enabling changes made in one place to be reflected
 * across the application. This will both save time and ensure consistency.
 *
 * It will be possible to port this instance to a JSON file should that be desirable
 * (for example to integrate a pacakge such as `ngx-translate`).
 */
const TextResourceSet = {
    'entity-type': {
        cane: 'Cane',
        plant: 'Plant',
        scion: 'Scion',
        fruit: 'Fruit',
        sample: 'Sample',
        tag: 'Tag',
        'generic-data': 'Remote Database',
        'biomaterial-collection': 'Biomaterial Collection',
        'observation-value': 'Observation Value',
        trial: 'Trial',
        'trial-permission': 'Trial Permission',
        'trial-season': 'Trial Season',
        'trial-task': 'Trial Task',
        genotype: 'Genotype',
        'genotype-label-assignment': 'Genotype Label Assignment',
        site: 'Site',
        season: 'Season',
        scale: 'Scale',
        process: 'Process',
        'factor-keyword': 'Factor Keyword',
        trait: 'Trait',
        factor: 'Factor',
        'import-type': 'Import Type',
        import: 'Import',
        method: 'Method',
        treatment: 'Treatment',
        'user-prefs': 'User Preferences Information',
        'operations-plan': 'Operations Plan',
        'operations-plan-task': 'Operations Plan Task',
        'season-operations-plan': 'Season Operations Plan',
        'operations-plan-trial-assoc': 'Operations Plan Trial Association',
        user: 'User',
        'user-data': 'User Data',
        'user-group': 'User Group',
        'query-filter': 'Saved Query Filter',
        'remote-proc': 'Remote Process',
        task: 'Task',
        'task-observation': 'Task Observation',
        'trial-note': 'Trial Note',
        'trial-observation': 'Trial Observation',
        observation: 'Observation',
        'request-biomaterial': 'Request Biomaterial',
        batch: 'Batch',
        programme: 'Programme',
    },
    'api-code': {
        // api-code resource keys correspond to the ApiCode enum values, which generally correspond to server response codes.
        ok: 'OK',
        application_error: 'Application Error',
        not_ready: 'Not Ready',
        not_found: 'Not Found',
        bad_request: 'Bad Request',
        access_denied: 'Access Denied',
        duplicate_task_observation: 'Duplicate Task Observation',
        task_observation_unique_opt_tms: 'The Observation (Trait/Method/Scale) already exists on the task',
    },
    'error-title': {
        generic: 'An error occurred',
        'generic-value-exists': 'Value Exists',
        'unique-contraint': 'Unique Constraint Violation',
        'unique-name': 'Unique Name Violation',
    },
    'dialog-title': {
        info: 'Information',
    },
    button: {
        cancel: 'Cancel',
        create: 'Create',
        export: 'Export',
        add: 'Add',
        discard: 'Discard Changes',
        save: 'Save',
        close: 'Close',
        preferences: 'Preferences',
        'report-issue': 'Report Issue',
        logout: 'Logout',
        'reset-pin': 'Reset PIN',
        'biomaterials-clear-pending': 'Clear Pending Biomaterials ({0})',
        'add-to-trial': 'Add to Trial',
        'remove-from-trial': 'Remove from Trial',
        'manage-biomaterials': 'Manage Biomaterials',
        'biomaterials-in-trial': 'Biomaterials in Trial',
        'biomaterials-ex-trial': 'Biomaterials NOT in Trial',
        'biomaterials-location-all': 'Include all in Location',
        'trial-permissions': 'Permissions',
        'trial-treatments': 'Treatments',
        'trial-notes': 'Notes',
        'trial-mobile-settings': 'Mobile Settings',
    },
    tooltip: {
        back: 'Go Back',
        cancel: 'Cancel',
        create: 'Create New',
        save: 'Save Changes',
        close: 'Close',
        delete: 'Delete',
        discard: 'Cancel/Discard Changes',
        export: 'Export to CSV',
        refresh: 'Refresh',
        print: 'Print',
        clone: 'Clone this Entity',
        'block-plan': 'Block Plan',
        'save-filters': 'Save Filters',
        'biomaterials-clear-pending': 'Clear all pending Biomaterials',
        'biomaterials-apply-pending': 'Apply pending Biomaterials to Trial',
        'biomaterials-in-trial': 'Select to remove Biomaterials from this Trial',
        'biomaterials-ex-trial': 'Select to add Biomaterials to this Trial',
        'biomaterials-location-all': 
        // eslint-disable-next-line max-len
        'Automatically includes all Biomaterials at the same Location as those selected (eg. select a Cane and add the Plant, all Scions and all Canes connected to it)',
        'biomaterials-in-collection': 'Biomaterials belonging to this Collection',
        'biomaterials-shared-trial': 'Biomaterials shared with this Trial',
        'biomaterials-assigned-trial': 'Biomaterials assigned to this Trial',
        'trial-progress': 'Trial Progress',
        'progress-overview': 'Back to Progress Overview',
        'go-to-trial': 'Go to Trial',
        'to-shared-locations': 'Back to Shared Locations',
        'set-pin': 'Set User PIN',
        'ops-plan-trials': 'Trials associated with this Operations Plan',
        'ops-plan-biomats': 'Biomaterials associated with this Operations Plan',
        'trial-observations-report': 'Trial Observations Report',
    },
};

/**
 * `AppTextService` provides application-wide access to global text resources and formatting utilities.
 */
class AppTextService {
    constructor(config) {
        this.config = config;
        this.textResourceSet = _.merge({}, TextResourceSet, this.config.textResourceSet || {});
        this.messageFormatter = new MessageFormatter(this);
    }
    /**
     * Returns the string in the application text-resource set associated with the specified `ApiResponseCode`.
     * @param code The response code to lookup.
     */
    getApiResponseTitle(code) {
        let key;
        switch (ApiResponse.getErrorCategory(code)) {
            case ApiErrorCategory.UniqueConstraintViolation:
                key = 'error-title.unique-constraint';
                break;
            case ApiErrorCategory.UniqueNameViolation:
                key = 'error-title.unique-name';
                break;
            default:
                key = 'api-code.' + code;
                break;
        }
        return (_.get(this.textResourceSet, key) ||
            _.get(this.textResourceSet, 'error-title.generic'));
    }
    /**
     * Returns the string in the application text-resource set associated with the specified key and applies format arguments to the result.
     * @param key The key to lookup.
     */
    getTextFormat(key, ...format) {
        const result = _.get(this.textResourceSet, key);
        if (result == undefined)
            return formatUnresolved(key);
        return format && format.length > 0
            ? FormatHelper.string(result, ...format)
            : result;
    }
    /**
     * Returns the string in the application text-resource set associated with the specified key.
     * @param key The key to lookup.
     */
    getText(key) {
        const result = _.get(this.textResourceSet, key);
        return result ? result : formatUnresolved(key);
    }
    /**
     * Accepts input text as either a text-resource set key or a literal text value and returns the text that should be displayed by the UI.
     *
     * If the string starts with the resouce-key token (the `@` character) then the string in the application text-resource set associated
     * with that key is returned, otherwise the input text is returned.
     *
     * @param keyOrValue The input text.
     */
    resolveText(keyOrValue) {
        return this.isKeyToken(keyOrValue)
            ? this.getText(stripKeyToken(keyOrValue))
            : keyOrValue;
    }
    /**
     * Accepts input text as either a text-resource set key or a literal text value and returns the text that should be displayed by the UI
     * after having applied format arguments to the result.
     *
     * If the string starts with the resouce-key token (the `@` character) then the string in the application text-resource set associated
     * with that key is returned, otherwise the input text is returned.
     *
     * @param keyOrValue The input text.
     */
    resolveTextFormat(keyOrValue, ...format) {
        if (keyOrValue == undefined)
            return undefined;
        return this.isKeyToken(keyOrValue)
            ? this.getTextFormat(stripKeyToken(keyOrValue), ...format)
            : FormatHelper.string(keyOrValue, ...format);
    }
    isKeyToken(keyOrValue) {
        return keyOrValue == undefined ? false : keyOrValue.startsWith('@');
    }
}
AppTextService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AppTextService, deps: [{ token: KUP_CORE_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable });
AppTextService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AppTextService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AppTextService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [KUP_CORE_CONFIG]
                    }] }];
    } });
function stripKeyToken(keyOrValue) {
    return keyOrValue.startsWith('@') ? keyOrValue.substr(1) : keyOrValue;
}
function formatUnresolved(key) {
    return `[unresolved-token][${key}]`;
}

class ButtonGroupComponent {
    constructor(text) {
        this.text = text;
    }
    ngOnInit() {
        if (this.busyState == undefined) {
            this.busyState = new ManualBusyState();
        }
    }
    getTooltip(b) {
        if (b.tooltip == undefined)
            return undefined;
        if (this.text.isKeyToken(b.tooltip)) {
            b.tooltip = this.text.resolveText(b.tooltip);
        }
        return b.tooltip;
    }
    onButtonClick(b) {
        if (this.clickInterceptor !== undefined) {
            this.clickInterceptor(b);
        }
        else if (b.click !== undefined) {
            b.click();
        }
    }
    evalState(resolver) {
        if (resolver == undefined)
            return undefined;
        if (this.evalStateInterceptor !== undefined) {
            return this.evalStateInterceptor(resolver);
        }
        const f = this.deriveStateFlags();
        let result;
        if (typeof resolver === 'function') {
            result = resolver(f);
        }
        else {
            // tslint:disable-next-line: no-bitwise
            result = (f & resolver) !== ButtonStateFlags.Never;
        }
        return result === true ? result : undefined;
    }
    deriveStateFlags() {
        let f = ButtonStateFlags.Never;
        if (this.busyState.isBusy) {
            // tslint:disable-next-line: no-bitwise
            f |= ButtonStateFlags.Busy;
        }
        if (this.busyState.loadingState !== LoadingState.Loaded) {
            // tslint:disable-next-line: no-bitwise
            f |= ButtonStateFlags.Loading;
        }
        return f;
    }
}
ButtonGroupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ButtonGroupComponent, deps: [{ token: AppTextService }], target: i0.ɵɵFactoryTarget.Component });
ButtonGroupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: ButtonGroupComponent, selector: "app-button-group", inputs: { busyState: "busyState", buttons: "buttons", clickInterceptor: "clickInterceptor", evalStateInterceptor: "evalStateInterceptor" }, ngImport: i0, template: "<li class=\"o-list-inline__item\" *ngFor=\"let b of buttons\">\r\n    <button type=\"button\" mat-mini-fab [disabled]=\"evalState(b.disabled)\" [color]=\"b.color ? b.color : 'accent'\"\r\n        [matTooltip]=\"getTooltip(b)\" (click)=\"onButtonClick(b)\">\r\n        <mat-icon *ngIf=\"b.icon\" class=\"mat-18\">{{b.icon}}</mat-icon>\r\n        <mat-icon *ngIf=\"b.svgIcon\" [svgIcon]=\"b.svgIcon\" class=\"mat-18\"></mat-icon>\r\n    </button>\r\n</li>\r\n", styles: [""], dependencies: [{ kind: "component", type: i2.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i4.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ButtonGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-button-group', template: "<li class=\"o-list-inline__item\" *ngFor=\"let b of buttons\">\r\n    <button type=\"button\" mat-mini-fab [disabled]=\"evalState(b.disabled)\" [color]=\"b.color ? b.color : 'accent'\"\r\n        [matTooltip]=\"getTooltip(b)\" (click)=\"onButtonClick(b)\">\r\n        <mat-icon *ngIf=\"b.icon\" class=\"mat-18\">{{b.icon}}</mat-icon>\r\n        <mat-icon *ngIf=\"b.svgIcon\" [svgIcon]=\"b.svgIcon\" class=\"mat-18\"></mat-icon>\r\n    </button>\r\n</li>\r\n" }]
        }], ctorParameters: function () { return [{ type: AppTextService }]; }, propDecorators: { busyState: [{
                type: Input
            }], buttons: [{
                type: Input
            }], clickInterceptor: [{
                type: Input
            }], evalStateInterceptor: [{
                type: Input
            }] } });

//#region PendingRoute
class PendingRoute {
    constructor() {
        this.promise = new Promise(resolve => {
            this._resolve = resolve;
        });
    }
    resolve(success) {
        this._resolve(success);
    }
}
//#endregion
//#region QueryParamCommandType
var QueryParamCommandType;
(function (QueryParamCommandType) {
    QueryParamCommandType[QueryParamCommandType["Nop"] = 0] = "Nop";
    QueryParamCommandType[QueryParamCommandType["Add"] = 1] = "Add";
    QueryParamCommandType[QueryParamCommandType["Remove"] = 2] = "Remove";
    QueryParamCommandType[QueryParamCommandType["Set"] = 3] = "Set";
    QueryParamCommandType[QueryParamCommandType["Clear"] = 4] = "Clear";
})(QueryParamCommandType || (QueryParamCommandType = {}));
//#endregion
/**
 * `ActiveRouteNavFacade` facilitates the serialization of query parameter router actions by the application.
 * This enables the application to maintain a consistent and predictable query parameter state.
 * Because the Angular router operates asynchronously, conventional changes to query params may be lost when multiple
 * components make non-synchronised changes to the active query parameter collection.
 * `ActiveRouteNavFacade` ensures that such loses do not occur when changes are made via its interface.
 */
class MigrationHelper {
    constructor(router, route) {
        this.router = router;
        this.route = route;
        this._paramQueue = [];
        this._pending = undefined;
        // view.path$.subscribe(() => {
        //   this._paramQueue = [];
        // });
    }
    /**
     * Adds the specified query parameters to the active route without causing other query parameters to be lost.
     */
    addQuery(params) {
        if (params == undefined)
            throw new Error(ExceptionMessageFormatter.argumentNull('params'));
        return this.queueQueryOp({
            type: QueryParamCommandType.Add,
            params: params
        });
    }
    /**
     * Removes the specified query parameters from the active route without causing other query parameters to be lost.
     */
    removeQuery(names) {
        if (names == undefined)
            throw new Error(ExceptionMessageFormatter.argumentNull('names'));
        return this.queueQueryOp({
            type: QueryParamCommandType.Remove,
            params: { keys: names }
        });
    }
    /**
     * Applies the specified query parameters to the active route. All existing query parameters are removed.
     */
    setQuery(params) {
        if (params == undefined)
            throw new Error(ExceptionMessageFormatter.argumentNull('params'));
        return this.queueQueryOp({
            type: QueryParamCommandType.Set,
            params: params
        });
    }
    /**
     * Clears all existing query parameters from the active route.
     */
    clearQuery(params) {
        if (params == undefined)
            throw new Error(ExceptionMessageFormatter.argumentNull('params'));
        return this.queueQueryOp({
            type: QueryParamCommandType.Set,
            params: params
        });
    }
    /**
     * Applies all queued operations to the active route, and then returns the set of updated query parameters.
     */
    getQueryParams() {
        return this.queueQueryOp({ type: QueryParamCommandType.Nop }).then(() => {
            let obs;
            let complete = false;
            const result = new Promise(resolve => {
                obs = this.route.queryParams.subscribe(p => {
                    // Cloning the params is necessary, because otherwise client code cannot assign/remove properties on the instance
                    // (An "object is not extensible" error is thrown by the framework)
                    p = TypeHelper.clone(p);
                    complete = true;
                    if (obs) {
                        obs.unsubscribe();
                    }
                    resolve(p);
                });
            });
            if (complete && obs) {
                obs.unsubscribe();
            }
            return result;
        });
    }
    queueQueryOp(cmd) {
        this._paramQueue.push(cmd);
        if (this._pending == undefined) {
            this._pending = new PendingRoute();
        }
        setTimeout(pending => {
            if (this._pending === pending) {
                this._pending = undefined;
                this.processQueue(pending);
            }
        }, 0, this._pending);
        return this._pending.promise;
    }
    processQueue(pending) {
        if (this._paramQueue.length === 0) {
            pending.resolve(true);
        }
        else {
            let params = Object.assign({}, this.route.snapshot.queryParams);
            while (this._paramQueue.length > 0) {
                const next = this._paramQueue.shift();
                switch (next.type) {
                    case QueryParamCommandType.Add:
                        params = Object.assign(Object.assign({}, params), next.params);
                        break;
                    case QueryParamCommandType.Remove:
                        const keys = next.params.keys;
                        keys.forEach(k => {
                            delete params[k];
                        });
                        break;
                    case QueryParamCommandType.Set:
                        params = next.params;
                        break;
                    case QueryParamCommandType.Clear:
                        params = {};
                        break;
                }
            }
            this.router
                .navigate([], {
                relativeTo: this.route,
                queryParams: params
            })
                .then(success => {
                pending.resolve(success);
            });
        }
    }
}
MigrationHelper.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: MigrationHelper, deps: [{ token: i1$4.Router }, { token: i1$4.ActivatedRoute }], target: i0.ɵɵFactoryTarget.Injectable });
MigrationHelper.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: MigrationHelper });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: MigrationHelper, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$4.Router }, { type: i1$4.ActivatedRoute }]; } });

class DialogComponent {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
    }
}
DialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: DialogComponent, deps: [{ token: i1$5.MatDialogRef }, { token: MAT_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component });
DialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: DialogComponent, selector: "lib-dialog", ngImport: i0, template: "<h1 mat-dialog-title *ngIf=\"data.title\">{{ data.title }}</h1>\n<div mat-dialog-content>\n  {{ data.message }}\n</div>\n<div mat-dialog-actions align=\"end\">\n  <button\n    *ngFor=\"let action of data.actions\"\n    mat-button\n    [mat-dialog-close]=\"action.value\"\n  >\n    {{ action.label }}\n  </button>\n</div>\n", dependencies: [{ kind: "component", type: i2.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i1$5.MatDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["aria-label", "type", "mat-dialog-close", "matDialogClose"], exportAs: ["matDialogClose"] }, { kind: "directive", type: i1$5.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1$5.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i1$5.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: DialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-dialog', template: "<h1 mat-dialog-title *ngIf=\"data.title\">{{ data.title }}</h1>\n<div mat-dialog-content>\n  {{ data.message }}\n</div>\n<div mat-dialog-actions align=\"end\">\n  <button\n    *ngFor=\"let action of data.actions\"\n    mat-button\n    [mat-dialog-close]=\"action.value\"\n  >\n    {{ action.label }}\n  </button>\n</div>\n" }]
        }], ctorParameters: function () {
        return [{ type: i1$5.MatDialogRef }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [MAT_DIALOG_DATA]
                    }] }];
    } });

class DialogService {
    constructor(dialog) {
        this.dialog = dialog;
    }
    open(options) {
        const { width } = options, data = __rest(options, ["width"]);
        const dialogRef = this.dialog.open(DialogComponent, {
            width: width || '400px',
            data,
        });
        return dialogRef.afterClosed();
    }
    confirm(message) {
        return __awaiter(this, void 0, void 0, function* () {
            const actions = [{ label: 'Cancel' }, { label: 'Confirm', value: true }];
            return this.open({ message, actions }).pipe(map(Boolean)).toPromise();
        });
    }
}
DialogService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: DialogService, deps: [{ token: i1$5.MatDialog }], target: i0.ɵɵFactoryTarget.Injectable });
DialogService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: DialogService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: DialogService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$5.MatDialog }]; } });

class MaterialModule {
}
MaterialModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: MaterialModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
MaterialModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.2", ngImport: i0, type: MaterialModule, exports: [MatStepperModule,
        MatListModule,
        MatButtonModule,
        MatRadioModule,
        MatSlideToggleModule,
        MatCheckboxModule,
        MatToolbarModule,
        MatIconModule,
        MatCardModule,
        MatMenuModule,
        MatSidenavModule,
        MatSelectModule,
        MatTableModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatInputModule,
        MatSortModule,
        MatTooltipModule,
        MatSnackBarModule,
        MatNativeDateModule,
        MatMomentDateModule,
        MatAutocompleteModule,
        MatChipsModule,
        MatTabsModule,
        MatTreeModule,
        MatDialogModule] });
MaterialModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: MaterialModule, imports: [MatStepperModule,
        MatListModule,
        MatButtonModule,
        MatRadioModule,
        MatSlideToggleModule,
        MatCheckboxModule,
        MatToolbarModule,
        MatIconModule,
        MatCardModule,
        MatMenuModule,
        MatSidenavModule,
        MatSelectModule,
        MatTableModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatInputModule,
        MatSortModule,
        MatTooltipModule,
        MatSnackBarModule,
        MatNativeDateModule,
        MatMomentDateModule,
        MatAutocompleteModule,
        MatChipsModule,
        MatTabsModule,
        MatTreeModule,
        MatDialogModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: MaterialModule, decorators: [{
            type: NgModule,
            args: [{
                    exports: [
                        MatStepperModule,
                        MatListModule,
                        MatButtonModule,
                        MatRadioModule,
                        MatSlideToggleModule,
                        MatCheckboxModule,
                        MatToolbarModule,
                        MatIconModule,
                        MatCardModule,
                        MatMenuModule,
                        MatSidenavModule,
                        MatSelectModule,
                        MatTableModule,
                        MatPaginatorModule,
                        MatProgressBarModule,
                        MatProgressSpinnerModule,
                        MatInputModule,
                        MatSortModule,
                        MatTooltipModule,
                        MatSnackBarModule,
                        MatNativeDateModule,
                        MatMomentDateModule,
                        MatAutocompleteModule,
                        MatChipsModule,
                        MatTabsModule,
                        MatTreeModule,
                        MatDialogModule,
                    ],
                }]
        }] });

const ValidationReference = {
    maxFileSize100MB: 104857600,
    onlyIntegersRegex: /^[-+]?\d+$/,
    hasDecimalsRegex: /^(\d+\.?\d{0,9}|\.\d{1,9})$/,
    specialCharactersRegex: /[`~!@#$%^&*()+={}\/\\\[\]|:";'<>?,]/,
    contactNumberRegex: /^[0-9\()+.\s]{8,20}$/,
    emailRegex: /^\w+([\.-]?\w+)+@\w+([\.:]?\w+)+(\.[a-zA-Z0-9]{2,3})+$/
};

const MAX_PIN_LENGTH = 4;
function integerValidator(control) {
    return ValidationReference.onlyIntegersRegex.test(control.value) ||
        !control.value
        ? null
        : { integer: true };
}
function decimalValidator(control) {
    return ValidationReference.hasDecimalsRegex.test(control.value) ||
        !control.value
        ? null
        : { decimal: true };
}
function specialCharactersValidator(control) {
    return ValidationReference.specialCharactersRegex.test(control.value) ||
        !control.value
        ? { pattern: true }
        : null;
}
function contactNumberValidator(control) {
    return ValidationReference.contactNumberRegex.test(control.value) ||
        !control.value
        ? null
        : { 'contact-number': true };
}
function emailValidator(control) {
    return ValidationReference.emailRegex.test(control.value) || !control.value
        ? null
        : { email: true };
}
function pinValidator(ctrl) {
    let value = ctrl.value;
    if (value == undefined)
        value = '';
    const maxLength = MAX_PIN_LENGTH;
    const containsOnlyDigits = ValidationReference.onlyIntegersRegex.test(value);
    const matchesLength = value.length === maxLength;
    return !value || (containsOnlyDigits && matchesLength) ? null : { pin: true };
}
function maxLengthQuillValidator(_ctrl, field) {
    let isValid = true;
    const to = field.templateOptions;
    const maxLength = to.richTextOptions.maxLength;
    if (!maxLength)
        return null;
    const ctrlLength = get(to, 'control.editor.quillEditor.container.innerText.length');
    if (ctrlLength != undefined) {
        isValid = ctrlLength <= maxLength;
    }
    return isValid ? null : { 'max-length-quill': true };
}
function fileUploadValidator({ value }) {
    if (!value)
        return null;
    const fileList = Array.from(value);
    const fileExistsThatExceedsMax = fileList.some((file) => file.size > ValidationReference.maxFileSize100MB);
    return fileExistsThatExceedsMax ? { fileUpload: true } : null;
}
function autocompleteValidator(options) {
    return function ({ value }) {
        if (!value) {
            return null;
        }
        const derivedValue = typeof value === 'string' ? value : value.value;
        const optionExists = !!options.find((option) => option.value === derivedValue);
        return optionExists ? null : { autocomplete: true };
    };
}
// Messages
function integerValidatorMessage(error, field) {
    return error && `"${field.formControl.value}" is not a valid integer`;
}
function maxlengthValidationMessage(error, field) {
    return error && formatMaxLength(field, field.templateOptions.maxLength);
}
function maxlengthValidationMessageQuill(error, field) {
    const maxLength = field.templateOptions.richTextOptions.maxLength;
    return error && formatMaxLength(field, maxLength);
}
function decimalValidatorMessage(error, field) {
    return error && `"${field.formControl.value}" is not a valid decimal`;
}
function contactNumberValidatorMessage(error, field) {
    return error && `"${field.formControl.value}" is not a valid contact number`;
}
function emailValidatorMessage(error, field) {
    return error && `"${field.formControl.value}" is not a valid email`;
}
function notUniqueValidatorMessage(error, field) {
    return error && `"${field.formControl.value}" is already in use`;
}
function fileUploadValidatorMessage(error, field) {
    return error && `"${field.formControl.value}" exceeds the maximum file size`;
}
function autocompleteValidatorMessage(error, field) {
    return (error &&
        `"${field.formControl.value}" is not a valid ${field.templateOptions.label}`);
}
function pinValidatorMessage(error, field) {
    const maxLength = MAX_PIN_LENGTH;
    return error && `${field.templateOptions.label} must be ${maxLength} digits`;
}
function minDatePickerValidatorMessage(error, field) {
    return (error && `${field.templateOptions.label} must be after the minimum date`);
}
function maxDatePickerValidatorMessage(error, field) {
    return (error && `${field.templateOptions.label} must be before the maximum date`);
}
function patternValidatorMessage(error, field) {
    return (error &&
        `${field.templateOptions.label} is restricted to alphanumeric, hyphen, space, and underscore characters`);
}
function singleActiveDateValidatorMessage(error) {
    return error && 'Location in use at this time';
}
function fieldValidatorMessage(error) {
    return error ? error : 'field Validation failed';
}
function formatMaxLength(field, maxLength) {
    return `${field.templateOptions.label} cannot exceed ${maxLength} characters in length`;
}

class FormlyFormFlexLayoutComponent extends FormlyForm {
}
FormlyFormFlexLayoutComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: FormlyFormFlexLayoutComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
FormlyFormFlexLayoutComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: FormlyFormFlexLayoutComponent, selector: "app-kup-formly-form-flex", usesInheritance: true, ngImport: i0, template: `
    <div
      fxLayout="row wrap"
      fxLayoutAlign="center"
      fxLayoutGap="40px"
      class="content"
      fxLayout="row"
      fxLayout.sm="column"
      fxFlexFill
    >
      <formly-field
        *ngFor="let field of fields"
        [fxFlex]="field.templateOptions.fxFlex"
        [fxFlex.sm]="field.templateOptions.fxFlexSm"
        [field]="field"
        [ngClass]="field.className"
      >
      </formly-field>
    </div>

    <ng-content></ng-content>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2$1.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i2$1.DefaultLayoutGapDirective, selector: "  [fxLayoutGap], [fxLayoutGap.xs], [fxLayoutGap.sm], [fxLayoutGap.md],  [fxLayoutGap.lg], [fxLayoutGap.xl], [fxLayoutGap.lt-sm], [fxLayoutGap.lt-md],  [fxLayoutGap.lt-lg], [fxLayoutGap.lt-xl], [fxLayoutGap.gt-xs], [fxLayoutGap.gt-sm],  [fxLayoutGap.gt-md], [fxLayoutGap.gt-lg]", inputs: ["fxLayoutGap", "fxLayoutGap.xs", "fxLayoutGap.sm", "fxLayoutGap.md", "fxLayoutGap.lg", "fxLayoutGap.xl", "fxLayoutGap.lt-sm", "fxLayoutGap.lt-md", "fxLayoutGap.lt-lg", "fxLayoutGap.lt-xl", "fxLayoutGap.gt-xs", "fxLayoutGap.gt-sm", "fxLayoutGap.gt-md", "fxLayoutGap.gt-lg"] }, { kind: "directive", type: i2$1.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "directive", type: i2$1.FlexFillDirective, selector: "[fxFill], [fxFlexFill]" }, { kind: "directive", type: i2$1.DefaultFlexDirective, selector: "  [fxFlex], [fxFlex.xs], [fxFlex.sm], [fxFlex.md],  [fxFlex.lg], [fxFlex.xl], [fxFlex.lt-sm], [fxFlex.lt-md],  [fxFlex.lt-lg], [fxFlex.lt-xl], [fxFlex.gt-xs], [fxFlex.gt-sm],  [fxFlex.gt-md], [fxFlex.gt-lg]", inputs: ["fxFlex", "fxFlex.xs", "fxFlex.sm", "fxFlex.md", "fxFlex.lg", "fxFlex.xl", "fxFlex.lt-sm", "fxFlex.lt-md", "fxFlex.lt-lg", "fxFlex.lt-xl", "fxFlex.gt-xs", "fxFlex.gt-sm", "fxFlex.gt-md", "fxFlex.gt-lg"] }, { kind: "directive", type: i3$1.DefaultClassDirective, selector: "  [ngClass], [ngClass.xs], [ngClass.sm], [ngClass.md], [ngClass.lg], [ngClass.xl],  [ngClass.lt-sm], [ngClass.lt-md], [ngClass.lt-lg], [ngClass.lt-xl],  [ngClass.gt-xs], [ngClass.gt-sm], [ngClass.gt-md], [ngClass.gt-lg]", inputs: ["ngClass", "ngClass.xs", "ngClass.sm", "ngClass.md", "ngClass.lg", "ngClass.xl", "ngClass.lt-sm", "ngClass.lt-md", "ngClass.lt-lg", "ngClass.lt-xl", "ngClass.gt-xs", "ngClass.gt-sm", "ngClass.gt-md", "ngClass.gt-lg"] }, { kind: "component", type: i1$6.FormlyField, selector: "formly-field", inputs: ["model", "form", "options", "field"], outputs: ["modelChange"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: FormlyFormFlexLayoutComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-kup-formly-form-flex',
                    template: `
    <div
      fxLayout="row wrap"
      fxLayoutAlign="center"
      fxLayoutGap="40px"
      class="content"
      fxLayout="row"
      fxLayout.sm="column"
      fxFlexFill
    >
      <formly-field
        *ngFor="let field of fields"
        [fxFlex]="field.templateOptions.fxFlex"
        [fxFlex.sm]="field.templateOptions.fxFlexSm"
        [field]="field"
        [ngClass]="field.className"
      >
      </formly-field>
    </div>

    <ng-content></ng-content>
  `,
                }]
        }] });

class AutocompleteTypeComponent extends FieldType {
    ngOnInit() {
        super.ngOnInit();
        this._setFilteredOptions(this.to);
    }
    displayFn(value) {
        const options = this.options;
        return value ? options.find((o) => o.value === value).viewValue : undefined;
    }
    _setFilteredOptions(templateOptions) {
        const { filter, options } = templateOptions;
        this.filteredOptions = this.formControl.valueChanges.pipe(startWith(''), map((value) => (typeof value === 'string' ? value : value.label)), map((label) => filter
            ? filter(label)
            : this._defaultFilter(label, options)));
    }
    _defaultFilter(label, options) {
        return options.filter((option) => option.label.toLowerCase().indexOf(label.toLowerCase()) === 0);
    }
}
AutocompleteTypeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AutocompleteTypeComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
AutocompleteTypeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: AutocompleteTypeComponent, selector: "app-formly-autocomplete-type", viewQueries: [{ propertyName: "formFieldControl", first: true, predicate: MatInput, descendants: true }], usesInheritance: true, ngImport: i0, template: `
    <input
      matInput
      [matAutocomplete]="auto"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [placeholder]="to.placeholder"
    />
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
      <mat-option
        *ngFor="let option of filteredOptions | async"
        [value]="option.value"
      >
        {{ option.label }}
      </mat-option>
    </mat-autocomplete>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: i2$2.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { kind: "directive", type: i3$2.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i4$1.MatAutocomplete, selector: "mat-autocomplete", inputs: ["disableRipple"], exportAs: ["matAutocomplete"] }, { kind: "directive", type: i4$1.MatAutocompleteTrigger, selector: "input[matAutocomplete], textarea[matAutocomplete]", exportAs: ["matAutocompleteTrigger"] }, { kind: "directive", type: i2$3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$3.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$6.FormlyAttributes, selector: "[formlyAttributes]", inputs: ["formlyAttributes", "id"] }, { kind: "pipe", type: i1$3.AsyncPipe, name: "async" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AutocompleteTypeComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-formly-autocomplete-type',
                    template: `
    <input
      matInput
      [matAutocomplete]="auto"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [placeholder]="to.placeholder"
    />
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
      <mat-option
        *ngFor="let option of filteredOptions | async"
        [value]="option.value"
      >
        {{ option.label }}
      </mat-option>
    </mat-autocomplete>
  `,
                }]
        }], propDecorators: { formFieldControl: [{
                type: ViewChild,
                args: [MatInput]
            }] } });

class ButtonTypeComponent extends FieldType {
    onClick($event) {
        if (this.to.click) {
            this.to.click($event);
        }
    }
}
ButtonTypeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ButtonTypeComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
ButtonTypeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: ButtonTypeComponent, selector: "app-formly-field-button", usesInheritance: true, ngImport: i0, template: `
    <div>
      <button
        mat-flat-button
        [type]="to.type"
        [color]="to.color"
        [disabled]="to.disabled"
        [matTooltip]="to.tooltip ? to.tooltip : to.text"
        (click)="onClick($event)"
      >
        <mat-icon *ngIf="to.icon">{{ to.icon }}</mat-icon>
        {{ to.text }}
      </button>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i4.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ButtonTypeComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-formly-field-button',
                    template: `
    <div>
      <button
        mat-flat-button
        [type]="to.type"
        [color]="to.color"
        [disabled]="to.disabled"
        [matTooltip]="to.tooltip ? to.tooltip : to.text"
        (click)="onClick($event)"
      >
        <mat-icon *ngIf="to.icon">{{ to.icon }}</mat-icon>
        {{ to.text }}
      </button>
    </div>
  `,
                }]
        }] });

class DateTimePickerComponent extends FieldType {
    constructor() {
        super();
        this.hour = '0';
        this.minute = '0';
        this.hourOptions = [];
        this.minuteOptions = [];
        for (let i = 0; i < 24; i++) {
            this.hourOptions.push({
                value: i.toString(),
                label: FormatHelper.formatTimeUnit(i),
            });
        }
        for (let i = 0; i < 60; i++) {
            this.minuteOptions.push({
                value: i.toString(),
                label: FormatHelper.formatTimeUnit(i),
            });
        }
    }
    ngOnInit() {
        setTimeout(() => {
            this.updateControls();
        }, 500);
    }
    pickerChange() {
        this.updateModel();
        this.to.custom.change(this._value);
    }
    hourChange(args) {
        this.hour = args.srcElement.value;
        this.updateModel();
        this.to.custom.change(this._value);
    }
    minuteChange(args) {
        this.minute = args.srcElement.value;
        this.updateModel();
        this.to.custom.change(this._value);
    }
    updateModel() {
        const d = this.picker.value ? this.picker.value.toDate() : undefined;
        if (d) {
            d.setMilliseconds(0);
            d.setHours(parseInt(this.hour));
            d.setMinutes(parseInt(this.minute));
        }
        this._value = d;
        this.formControl.setValue(d);
        this.formControl.markAsDirty();
        this.formControl.markAsTouched();
    }
    updateControls() {
        const keyString = this.field.key;
        let d;
        const v = this.form.value[keyString];
        if (typeof v === 'object') {
            d = v;
        }
        else if (typeof v === 'string' && v !== '') {
            d = new Date(v);
        }
        else {
            d = undefined;
        }
        if (d != undefined) {
            this.hour = d.getHours().toString();
            this.minute = d.getMinutes().toString();
            this._value = d;
        }
        this.picker.value = d;
    }
    onChange(value) {
        if (this.to.custom.change != undefined) {
            this.to.custom.change(value);
        }
    }
}
DateTimePickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: DateTimePickerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DateTimePickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: DateTimePickerComponent, selector: "app-datetimepicker-field", viewQueries: [{ propertyName: "picker", first: true, predicate: MatDatepickerInput, descendants: true }], usesInheritance: true, ngImport: i0, template: "<div class=\"datetime-wrapper\">\r\n  <input matInput [matDatepicker]=\"picker\" [id]=\"id\" (dateChange)=\"pickerChange()\">\r\n  <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\r\n  <mat-datepicker #picker></mat-datepicker>\r\n  <div class=\"time-comp\">\r\n    <select [value]=\"hour\" (change)=\"hourChange($event)\">\r\n      <option *ngFor=\"let h of hourOptions\" [value]=\"h.value\">{{h.label}}</option>\r\n    </select>\r\n    <span>:</span>\r\n    <select [value]=\"minute\" (change)=\"minuteChange($event)\">\r\n      <option *ngFor=\"let m of minuteOptions\" [value]=\"m.value\">{{m.label}}</option>\r\n    </select>\r\n  </div>\r\n</div>", styles: [".datetime-wrapper{display:inline-flex;vertical-align:middle;padding:0 5px 0 15px;border:solid 1px rgba(0,0,0,.1);border-radius:3px}.datetime-wrapper input{max-width:90px}.datetime-wrapper .time-comp{display:inline-block}.datetime-wrapper .time-comp select{border:none;border-bottom:dashed 1px rgba(0,0,0,.1);padding:0 8px;margin:10px 2px 0}\n"], dependencies: [{ kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2$4.MatSuffix, selector: "[matSuffix]" }, { kind: "directive", type: i3$2.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i4$2.MatDatepicker, selector: "mat-datepicker", exportAs: ["matDatepicker"] }, { kind: "directive", type: i4$2.MatDatepickerInput, selector: "input[matDatepicker]", inputs: ["matDatepicker", "min", "max", "matDatepickerFilter"], exportAs: ["matDatepickerInput"] }, { kind: "component", type: i4$2.MatDatepickerToggle, selector: "mat-datepicker-toggle", inputs: ["for", "tabIndex", "aria-label", "disabled", "disableRipple"], exportAs: ["matDatepickerToggle"] }, { kind: "directive", type: i2$3.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i2$3.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: DateTimePickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-datetimepicker-field', template: "<div class=\"datetime-wrapper\">\r\n  <input matInput [matDatepicker]=\"picker\" [id]=\"id\" (dateChange)=\"pickerChange()\">\r\n  <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\r\n  <mat-datepicker #picker></mat-datepicker>\r\n  <div class=\"time-comp\">\r\n    <select [value]=\"hour\" (change)=\"hourChange($event)\">\r\n      <option *ngFor=\"let h of hourOptions\" [value]=\"h.value\">{{h.label}}</option>\r\n    </select>\r\n    <span>:</span>\r\n    <select [value]=\"minute\" (change)=\"minuteChange($event)\">\r\n      <option *ngFor=\"let m of minuteOptions\" [value]=\"m.value\">{{m.label}}</option>\r\n    </select>\r\n  </div>\r\n</div>", styles: [".datetime-wrapper{display:inline-flex;vertical-align:middle;padding:0 5px 0 15px;border:solid 1px rgba(0,0,0,.1);border-radius:3px}.datetime-wrapper input{max-width:90px}.datetime-wrapper .time-comp{display:inline-block}.datetime-wrapper .time-comp select{border:none;border-bottom:dashed 1px rgba(0,0,0,.1);padding:0 8px;margin:10px 2px 0}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { picker: [{
                type: ViewChild,
                args: [MatDatepickerInput]
            }] } });

class FileUploadWrapperComponent extends FieldWrapper {
}
FileUploadWrapperComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: FileUploadWrapperComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
FileUploadWrapperComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: FileUploadWrapperComponent, selector: "app-file-upload-wrapper", viewQueries: [{ propertyName: "fieldComponent", first: true, predicate: ["fieldComponent"], descendants: true, read: ViewContainerRef }], usesInheritance: true, ngImport: i0, template: `
    <div>
      <ng-container #fieldComponent></ng-container>
      <mat-error [id]="null">
        <formly-validation-message [field]="field"></formly-validation-message>
      </mat-error>
      <mat-hint *ngIf="to.description" [id]="null">{{
        to.description
      }}</mat-hint>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$4.MatError, selector: "mat-error", inputs: ["id"] }, { kind: "directive", type: i2$4.MatHint, selector: "mat-hint", inputs: ["align", "id"] }, { kind: "component", type: i1$6.ɵc, selector: "formly-validation-message", inputs: ["field"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: FileUploadWrapperComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-file-upload-wrapper',
                    template: `
    <div>
      <ng-container #fieldComponent></ng-container>
      <mat-error [id]="null">
        <formly-validation-message [field]="field"></formly-validation-message>
      </mat-error>
      <mat-hint *ngIf="to.description" [id]="null">{{
        to.description
      }}</mat-hint>
    </div>
  `,
                }]
        }], propDecorators: { fieldComponent: [{
                type: ViewChild,
                args: ['fieldComponent', { read: ViewContainerRef }]
            }] } });

// https://github.com/angular/angular/issues/7341
class FileValueAccessorDirective {
    constructor() {
        this.onChange = _ => { };
        this.onTouched = () => { };
    }
    writeValue() { }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
}
FileValueAccessorDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: FileValueAccessorDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FileValueAccessorDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.2", type: FileValueAccessorDirective, selector: "input[type=file]", host: { listeners: { "change": "onChange($event.target.files)", "blur": "onTouched()" } }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FileValueAccessorDirective,
            multi: true
        }
    ], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: FileValueAccessorDirective, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line
                    selector: 'input[type=file]',
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: FileValueAccessorDirective,
                            multi: true
                        }
                    ]
                }]
        }], propDecorators: { onChange: [{
                type: HostListener,
                args: ['change', ['$event.target.files']]
            }], onTouched: [{
                type: HostListener,
                args: ['blur']
            }] } });

class FileUploadComponent extends FieldType {
    get fileList() {
        const files = this.formControl.value;
        return files && files.length > 0 ? files : [];
    }
    onChange() {
        const fileList = this.formControl.value;
        const fileListArray = Array.from(fileList);
        this.formControl.setValue(fileListArray);
    }
}
FileUploadComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: FileUploadComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
FileUploadComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: FileUploadComponent, selector: "app-file-upload-field", usesInheritance: true, ngImport: i0, template: `
    <div>
      <input
        [id]="id"
        type="file"
        [formControl]="formControl"
        [formlyAttributes]="field"
        class="file-upload-input"
        (change)="onChange()"
        #fileInput
      />
      <button mat-raised-button (click)="fileInput.click()">
        Choose a File
      </button>
      <ul *ngIf="fileList.length > 0" class="file-list">
        <li *ngFor="let file of fileList">
          <mat-icon>insert_drive_file</mat-icon> {{ file.name }}
        </li>
      </ul>
    </div>
  `, isInline: true, styles: [".file-list{list-style:none;padding-left:20px;margin-bottom:0}.file-upload-input{visibility:hidden;height:0;width:0}li{display:inline-flex;align-items:center}mat-icon{margin-right:8px}\n"], dependencies: [{ kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i2$3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$3.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$6.FormlyAttributes, selector: "[formlyAttributes]", inputs: ["formlyAttributes", "id"] }, { kind: "directive", type: FileValueAccessorDirective, selector: "input[type=file]" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: FileUploadComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-file-upload-field', template: `
    <div>
      <input
        [id]="id"
        type="file"
        [formControl]="formControl"
        [formlyAttributes]="field"
        class="file-upload-input"
        (change)="onChange()"
        #fileInput
      />
      <button mat-raised-button (click)="fileInput.click()">
        Choose a File
      </button>
      <ul *ngIf="fileList.length > 0" class="file-list">
        <li *ngFor="let file of fileList">
          <mat-icon>insert_drive_file</mat-icon> {{ file.name }}
        </li>
      </ul>
    </div>
  `, styles: [".file-list{list-style:none;padding-left:20px;margin-bottom:0}.file-upload-input{visibility:hidden;height:0;width:0}li{display:inline-flex;align-items:center}mat-icon{margin-right:8px}\n"] }]
        }] });

class HtmlTypeComponent extends FieldType {
    constructor() {
        super(...arguments);
        this.value = this.formControl.value || '';
    }
}
HtmlTypeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: HtmlTypeComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
HtmlTypeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: HtmlTypeComponent, selector: "app-html-type", usesInheritance: true, ngImport: i0, template: ` <div class="html-type" [innerHtml]="value"></div> `, isInline: true, styles: [".html-type{padding-bottom:1.25em;white-space:pre-line}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: HtmlTypeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-html-type', template: ` <div class="html-type" [innerHtml]="value"></div> `, styles: [".html-type{padding-bottom:1.25em;white-space:pre-line}\n"] }]
        }] });

class InfoFieldComponent extends FieldType {
    constructor() {
        super(...arguments);
        this._type = 'info';
    }
    get type() {
        return this._type;
    }
    get text() {
        return this._textFn ? this._textFn() : '';
    }
    ngOnInit() {
        if (this.to.custom == undefined)
            return;
        switch (typeof this.to.custom.text) {
            case 'function':
                this._textFn = this.to.custom.text;
                break;
            case 'string':
                this._textFn = () => this.to.custom.text;
                break;
        }
        if (this.to.custom.type != undefined) {
            this._type = this.to.custom.type;
        }
    }
}
InfoFieldComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: InfoFieldComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
InfoFieldComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: InfoFieldComponent, selector: "app-info-field", usesInheritance: true, ngImport: i0, template: "<div class=\"info-type-{{type}}\">\r\n    <div [ngSwitch]=\"type\">\r\n        <mat-icon *ngSwitchCase=\"'warn'\">warning</mat-icon>\r\n        <mat-icon *ngSwitchCase=\"'error'\">error</mat-icon>\r\n        <mat-icon *ngSwitchDefault>info</mat-icon>\r\n        <span>{{text}}</span>\r\n    </div>\r\n</div>", styles: ["div{border:1px solid cornflowerblue;border-radius:3px;display:inline-flex;vertical-align:middle;width:100%;color:#00000061}div div{border:none;padding:8px}div div span{margin-top:2px;padding-left:8px}div mat-icon{color:#6495ed}div.info-type-error{border-color:red}div.info-type-error mat-icon{color:red}div.info-type-warn{border-color:orange}div.info-type-warn mat-icon{color:orange}\n"], dependencies: [{ kind: "directive", type: i1$3.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1$3.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1$3.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "component", type: i3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: InfoFieldComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-info-field', template: "<div class=\"info-type-{{type}}\">\r\n    <div [ngSwitch]=\"type\">\r\n        <mat-icon *ngSwitchCase=\"'warn'\">warning</mat-icon>\r\n        <mat-icon *ngSwitchCase=\"'error'\">error</mat-icon>\r\n        <mat-icon *ngSwitchDefault>info</mat-icon>\r\n        <span>{{text}}</span>\r\n    </div>\r\n</div>", styles: ["div{border:1px solid cornflowerblue;border-radius:3px;display:inline-flex;vertical-align:middle;width:100%;color:#00000061}div div{border:none;padding:8px}div div span{margin-top:2px;padding-left:8px}div mat-icon{color:#6495ed}div.info-type-error{border-color:red}div.info-type-error mat-icon{color:red}div.info-type-warn{border-color:orange}div.info-type-warn mat-icon{color:orange}\n"] }]
        }] });

// Repository and Documentation: https://github.com/ng-select/ng-select
class NgSelectTypeComponent extends FieldType {
    constructor() {
        super(...arguments);
        this._disposables = new Disposables();
    }
    get labelProp() {
        return this.to.bindLabel || 'label';
    }
    get valueProp() {
        return this.to.bindValue || 'value';
    }
    get clearable() {
        return this.to.clearable !== undefined ? this.to.clearable : true;
    }
    get options$() {
        if (isObservable(this.to.options)) {
            let val;
            this._disposables.addSubscription(this.to.options.subscribe((res) => {
                val = res;
            }));
            return val;
        }
        if (Array.isArray(this.to.options)) {
            return this.to.options;
        }
    }
    ngAfterViewInit() {
        this.subscribeToValueChange();
        if (this.to.isTypeahead || this.to.onSearch) {
            const interval = this.to.debounceTime ? this.to.debounceTime : 500;
            this._search = new Subject();
            this._disposables.addSubscription(this._search.pipe(debounceTime(interval)).subscribe((filter) => {
                const checkAvailable = !filter.includes('`') && !filter.includes('^');
                if (this.to.onSearch && checkAvailable) {
                    this.to.onSearch(filter);
                }
                if (this.to.provider && checkAvailable) {
                    this.updateList(this.to.provider, filter);
                }
            }));
        }
        if (this.to.deselectMode === 'change') {
            this._disposables.subscribeTo(this.to.options, (_options) => {
                this.control.selectedItems.forEach((item) => {
                    this.control.unselect(item);
                });
            });
        }
        else if (this.to.deselectMode === 'missing' &&
            this.to.options &&
            !Array.isArray(this.to.options)) {
            this._disposables.subscribeTo(this.to.options, (options) => {
                const toRemove = [];
                this.control.selectedItems.forEach((item) => {
                    if (options.findIndex((cmp) => cmp[this.valueProp] === item.value[this.valueProp]) < 0) {
                        toRemove.push(item);
                    }
                });
                toRemove.forEach((target) => {
                    this.control.unselect(target);
                });
            });
        }
    }
    ngOnDestroy() {
        this._disposables.dispose();
    }
    onSearch(filter) {
        if (this._search) {
            this._search.next(filter !== undefined ? filter.term : '');
        }
    }
    onClear() {
        if (this.to.onClear) {
            this.to.onClear();
        }
        if (this.to.provider) {
            this.updateList(this.to.provider);
        }
    }
    onAdd(item) {
        if (this.to.onAdd) {
            this.to.onAdd(item);
        }
    }
    onRemove(item) {
        if (this.to.onRemove) {
            this.to.onRemove(item.value);
        }
        if (this.to.provider) {
            this.updateList(this.to.provider);
        }
    }
    onChange(item) {
        if (this.to.onChange) {
            this.to.onChange(item);
        }
    }
    subscribeToValueChange() {
        this._disposables.addSubscription(this.formControl.valueChanges.subscribe((value) => this.to.ngSelectChange ? this.to.ngSelectChange(value) : null));
    }
    updateList(dropdown, term = '') {
        if (dropdown) {
            dropdown.refresh(term);
        }
    }
}
NgSelectTypeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: NgSelectTypeComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
NgSelectTypeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: NgSelectTypeComponent, selector: "app-ng-select-type", viewQueries: [{ propertyName: "control", first: true, predicate: NgSelectComponent, descendants: true }], usesInheritance: true, ngImport: i0, template: `
    <ng-select
      [ngClass]="{
        'ng-select-required': to.required,
        'remove-bottom-padding': to.description
      }"
      [items]="options$"
      [bindLabel]="labelProp"
      [bindValue]="valueProp"
      [multiple]="to.multiple"
      [addTag]="to.addTag"
      [loading]="to.loading"
      [clearable]="clearable"
      (clear)="onClear()"
      [typeahead]="to.typeahead"
      [placeholder]="to.label"
      [formControl]="formControl"
      (search)="onSearch($event)"
      (add)="onAdd($event)"
      (remove)="onRemove($event)"
      (change)="onChange($event)"
    >
    </ng-select>
    <small *ngIf="to.description" [id]="null"
      ><i>{{ to.description }}</i></small
    >
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$5.NgSelectComponent, selector: "ng-select", inputs: ["bindLabel", "bindValue", "markFirst", "placeholder", "notFoundText", "typeToSearchText", "addTagText", "loadingText", "clearAllText", "appearance", "dropdownPosition", "appendTo", "loading", "closeOnSelect", "hideSelected", "selectOnTab", "openOnEnter", "maxSelectedItems", "groupBy", "groupValue", "bufferAmount", "virtualScroll", "selectableGroup", "selectableGroupAsModel", "searchFn", "trackByFn", "clearOnBackspace", "labelForId", "inputAttrs", "tabIndex", "readonly", "searchWhileComposing", "minTermLength", "editableSearchTerm", "keyDownFn", "typeahead", "multiple", "addTag", "searchable", "clearable", "isOpen", "items", "compareWith", "clearSearchOnAdd"], outputs: ["blur", "focus", "change", "open", "close", "search", "clear", "add", "remove", "scroll", "scrollToEnd"] }, { kind: "directive", type: i2$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$3.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i3$1.DefaultClassDirective, selector: "  [ngClass], [ngClass.xs], [ngClass.sm], [ngClass.md], [ngClass.lg], [ngClass.xl],  [ngClass.lt-sm], [ngClass.lt-md], [ngClass.lt-lg], [ngClass.lt-xl],  [ngClass.gt-xs], [ngClass.gt-sm], [ngClass.gt-md], [ngClass.gt-lg]", inputs: ["ngClass", "ngClass.xs", "ngClass.sm", "ngClass.md", "ngClass.lg", "ngClass.xl", "ngClass.lt-sm", "ngClass.lt-md", "ngClass.lt-lg", "ngClass.lt-xl", "ngClass.gt-xs", "ngClass.gt-sm", "ngClass.gt-md", "ngClass.gt-lg"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: NgSelectTypeComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-ng-select-type',
                    template: `
    <ng-select
      [ngClass]="{
        'ng-select-required': to.required,
        'remove-bottom-padding': to.description
      }"
      [items]="options$"
      [bindLabel]="labelProp"
      [bindValue]="valueProp"
      [multiple]="to.multiple"
      [addTag]="to.addTag"
      [loading]="to.loading"
      [clearable]="clearable"
      (clear)="onClear()"
      [typeahead]="to.typeahead"
      [placeholder]="to.label"
      [formControl]="formControl"
      (search)="onSearch($event)"
      (add)="onAdd($event)"
      (remove)="onRemove($event)"
      (change)="onChange($event)"
    >
    </ng-select>
    <small *ngIf="to.description" [id]="null"
      ><i>{{ to.description }}</i></small
    >
  `,
                }]
        }], propDecorators: { control: [{
                type: ViewChild,
                args: [NgSelectComponent]
            }] } });

class RepeatTypeComponent extends FieldArrayType {
    constructor(builder) {
        super(builder);
    }
}
RepeatTypeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: RepeatTypeComponent, deps: [{ token: i1$6.FormlyFormBuilder }], target: i0.ɵɵFactoryTarget.Component });
RepeatTypeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: RepeatTypeComponent, selector: "formly-repeat-section", usesInheritance: true, ngImport: i0, template: `
    <div *ngFor="let field of field.fieldGroup; let i = index;">
      <formly-group
        [field]="field"
        [options]="options"
        [form]="formControl">
        <div class="col-sm-2 d-flex align-items-center">
          <button class="btn btn-danger" type="button" (click)="remove(i)">Remove</button>
        </div>
      </formly-group>
    </div>
    <div style="margin:30px 0;">
      <button class="btn btn-primary" type="button" (click)="add()">{{ field.fieldArray.templateOptions.btnText }}</button>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: i1$6.ɵb, selector: "formly-group" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: RepeatTypeComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'formly-repeat-section',
                    template: `
    <div *ngFor="let field of field.fieldGroup; let i = index;">
      <formly-group
        [field]="field"
        [options]="options"
        [form]="formControl">
        <div class="col-sm-2 d-flex align-items-center">
          <button class="btn btn-danger" type="button" (click)="remove(i)">Remove</button>
        </div>
      </formly-group>
    </div>
    <div style="margin:30px 0;">
      <button class="btn btn-primary" type="button" (click)="add()">{{ field.fieldArray.templateOptions.btnText }}</button>
    </div>
  `
                }]
        }], ctorParameters: function () { return [{ type: i1$6.FormlyFormBuilder }]; } });

class NewRepeatTypeComponent extends FieldArrayType {
    constructor(builder) {
        super(builder);
    }
    ngOnInit() {
        this.add();
    }
    get canAdd() {
        return;
    }
    get isDisabled() {
        const isDisabled = this.field.templateOptions.repeatDisabled
            ? this.field.templateOptions.repeatDisabled
            : false;
        return isDisabled;
    }
}
NewRepeatTypeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: NewRepeatTypeComponent, deps: [{ token: i1$6.FormlyFormBuilder }], target: i0.ɵɵFactoryTarget.Component });
NewRepeatTypeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: NewRepeatTypeComponent, selector: "app-formly-new-repeat-section", usesInheritance: true, ngImport: i0, template: `
    <fieldset [disabled]="isDisabled">
      <div
        *ngFor="let field of field.fieldGroup; let i = index"
        class="ext-ref-form"
      >
        <formly-field
          [form]="form"
          [model]="model"
          [options]="options"
          [field]="field"
        ></formly-field>
        <button *ngIf="model.length > 1" mat-button (click)="remove(i)">
          <mat-icon>delete</mat-icon>
        </button>
        <button mat-button *ngIf="i === model.length - 1" (click)="add()">
          <mat-icon>add_circle</mat-icon>
        </button>
      </div>
    </fieldset>
  `, isInline: true, styles: ["button{margin:5px}\n", ".ext-ref-form{border:black 1px solid;padding:15px;margin:10px}\n"], dependencies: [{ kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i1$6.FormlyField, selector: "formly-field", inputs: ["model", "form", "options", "field"], outputs: ["modelChange"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: NewRepeatTypeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-formly-new-repeat-section', template: `
    <fieldset [disabled]="isDisabled">
      <div
        *ngFor="let field of field.fieldGroup; let i = index"
        class="ext-ref-form"
      >
        <formly-field
          [form]="form"
          [model]="model"
          [options]="options"
          [field]="field"
        ></formly-field>
        <button *ngIf="model.length > 1" mat-button (click)="remove(i)">
          <mat-icon>delete</mat-icon>
        </button>
        <button mat-button *ngIf="i === model.length - 1" (click)="add()">
          <mat-icon>add_circle</mat-icon>
        </button>
      </div>
    </fieldset>
  `, styles: ["button{margin:5px}\n", ".ext-ref-form{border:black 1px solid;padding:15px;margin:10px}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$6.FormlyFormBuilder }]; } });

class TagInputComponent extends FieldType {
    constructor() {
        super(...arguments);
        this.separatorKeysCodes = [ENTER, COMMA, TAB];
        this.taglist = [];
    }
    ngOnInit() {
        this.taglist = this.formControl.value;
    }
    ngAfterViewInit() {
        this.formControl.setValue(this.taglist);
        this.input.value = '';
    }
    onAdd({ value }) {
        const newValue = value.trim();
        if (!newValue)
            return undefined;
        this.taglist = [
            ...this._filterNonExistingValues(this.taglist, value),
            newValue,
        ];
        this.clearField();
    }
    onRemoved(value) {
        this.taglist = [...this._filterNonExistingValues(this.taglist, value)];
        this.formControl.setValue(this.taglist);
        this.formControl.markAsDirty();
        this.input.value = '';
        this.clearField();
    }
    clearField() {
        this.formControl.setValue(this.taglist);
        this.formControl.markAsDirty();
        this.input.value = '';
    }
    _filterNonExistingValues(taglist, value) {
        return taglist === null ? [] : taglist.filter((v) => v !== value);
    }
    drop(event) {
        if (this.formControl.disabled)
            return;
        const taglistCopy = [...this.taglist];
        moveItemInArray(taglistCopy, event.previousIndex, event.currentIndex);
        this.formControl.setValue(taglistCopy);
        this.formControl.markAsDirty();
        this.taglist = this.formControl.value;
    }
}
TagInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: TagInputComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
TagInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: TagInputComponent, selector: "app-tag-input-type", viewQueries: [{ propertyName: "input", first: true, predicate: MatInput, descendants: true }], usesInheritance: true, ngImport: i0, template: `
    <mat-chip-list
      cdkDropList
      cdkDropListOrientation="horizontal"
      (cdkDropListDropped)="drop($event)"
      #chipList
    >
      <mat-chip
        cdkDrag
        *ngFor="let tag of taglist; let i = index"
        [cdkDragDisabled]="to.disabled"
        [removable]="!to.disabled"
        (removed)="onRemoved(tag)"
      >
        {{ tag }}
        <mat-icon
          matChipRemove
          *ngIf="!to.disabled"
          svgIcon="cancel_black"
        ></mat-icon>
      </mat-chip>
      <input
        matInput
        [placeholder]="to.placeholder"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="onAdd($event)"
      />
    </mat-chip-list>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i3$2.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i4$3.MatChipList, selector: "mat-chip-list", inputs: ["role", "aria-describedby", "errorStateMatcher", "multiple", "compareWith", "value", "required", "placeholder", "disabled", "aria-orientation", "selectable", "tabIndex"], outputs: ["change", "valueChange"], exportAs: ["matChipList"] }, { kind: "directive", type: i4$3.MatChip, selector: "mat-basic-chip, [mat-basic-chip], mat-chip, [mat-chip]", inputs: ["color", "disableRipple", "tabIndex", "role", "selected", "value", "selectable", "disabled", "removable"], outputs: ["selectionChange", "destroyed", "removed"], exportAs: ["matChip"] }, { kind: "directive", type: i4$3.MatChipInput, selector: "input[matChipInputFor]", inputs: ["matChipInputFor", "matChipInputAddOnBlur", "matChipInputSeparatorKeyCodes", "placeholder", "id", "disabled"], outputs: ["matChipInputTokenEnd"], exportAs: ["matChipInput", "matChipInputFor"] }, { kind: "directive", type: i4$3.MatChipRemove, selector: "[matChipRemove]" }, { kind: "directive", type: i5.CdkDropList, selector: "[cdkDropList], cdk-drop-list", inputs: ["cdkDropListConnectedTo", "cdkDropListData", "cdkDropListOrientation", "id", "cdkDropListLockAxis", "cdkDropListDisabled", "cdkDropListSortingDisabled", "cdkDropListEnterPredicate", "cdkDropListSortPredicate", "cdkDropListAutoScrollDisabled", "cdkDropListAutoScrollStep"], outputs: ["cdkDropListDropped", "cdkDropListEntered", "cdkDropListExited", "cdkDropListSorted"], exportAs: ["cdkDropList"] }, { kind: "directive", type: i5.CdkDrag, selector: "[cdkDrag]", inputs: ["cdkDragData", "cdkDragLockAxis", "cdkDragRootElement", "cdkDragBoundary", "cdkDragStartDelay", "cdkDragFreeDragPosition", "cdkDragDisabled", "cdkDragConstrainPosition", "cdkDragPreviewClass", "cdkDragPreviewContainer"], outputs: ["cdkDragStarted", "cdkDragReleased", "cdkDragEnded", "cdkDragEntered", "cdkDragExited", "cdkDragDropped", "cdkDragMoved"], exportAs: ["cdkDrag"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: TagInputComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-tag-input-type',
                    template: `
    <mat-chip-list
      cdkDropList
      cdkDropListOrientation="horizontal"
      (cdkDropListDropped)="drop($event)"
      #chipList
    >
      <mat-chip
        cdkDrag
        *ngFor="let tag of taglist; let i = index"
        [cdkDragDisabled]="to.disabled"
        [removable]="!to.disabled"
        (removed)="onRemoved(tag)"
      >
        {{ tag }}
        <mat-icon
          matChipRemove
          *ngIf="!to.disabled"
          svgIcon="cancel_black"
        ></mat-icon>
      </mat-chip>
      <input
        matInput
        [placeholder]="to.placeholder"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="onAdd($event)"
      />
    </mat-chip-list>
  `,
                }]
        }], propDecorators: { input: [{
                type: ViewChild,
                args: [MatInput]
            }] } });

const QuillToolbarConfig = {
    toolbar: {
        container: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ size: ['small', false, 'large'] }],
            ['link'],
            ['clean']
        ]
    }
};
class TextEditorComponent extends FieldType {
    constructor() {
        super();
        this.change = new EventEmitter();
    }
    get minLength() {
        const o = this.getCustomOptions();
        return o ? o.minLength : undefined;
    }
    get maxLength() {
        const o = this.getCustomOptions();
        return o ? o.maxLength : undefined;
    }
    get readOnly() {
        const o = this.getCustomOptions();
        return o ? o.disabled : this.to.disabled;
    }
    get quillToolBar() {
        return !this.readOnly ? QuillToolbarConfig : { toolbar: false };
    }
    ngOnInit() {
        super.ngOnInit();
        this.to.control = this;
    }
    onChange(eventValue) {
        this.change.emit(eventValue);
    }
    getCustomOptions() {
        return this.to.richTextOptions;
    }
}
TextEditorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: TextEditorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TextEditorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: TextEditorComponent, selector: "app-text-editor", outputs: { change: "change" }, viewQueries: [{ propertyName: "editor", first: true, predicate: QuillEditorComponent, descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: `
    <quill-editor
      theme="snow"
      [formControl]="formControl"
      [modules]="quillToolBar"
      [minLength]="minLength"
      [readOnly]="readOnly"
      [maxLength]="maxLength"
      placeholder="Add text..."
    ></quill-editor>
  `, isInline: true, dependencies: [{ kind: "component", type: i1$7.QuillEditorComponent, selector: "quill-editor" }, { kind: "directive", type: i2$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$3.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: TextEditorComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-text-editor',
                    template: `
    <quill-editor
      theme="snow"
      [formControl]="formControl"
      [modules]="quillToolBar"
      [minLength]="minLength"
      [readOnly]="readOnly"
      [maxLength]="maxLength"
      placeholder="Add text..."
    ></quill-editor>
  `
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { editor: [{
                type: ViewChild,
                args: [QuillEditorComponent, { static: true }]
            }], change: [{
                type: Output
            }] } });

class FakeUploadComponent extends FieldType {
    onClick() {
        document.getElementById('realFileUpload').click();
    }
    onChange() { }
}
FakeUploadComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: FakeUploadComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
FakeUploadComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: FakeUploadComponent, selector: "app-fake-upload-field", usesInheritance: true, ngImport: i0, template: `
    <div>
      <button
        (click)="onClick()"
        [id]="id"
        type="file"
        [formControl]="formControl"
        [formlyAttributes]="field"
        (change)="onChange()"
        ngDefaultControl
        [name]="id"
        mat-stroked-button
      >
        Choose File
      </button>
      <input
        type="text"
        [value]="to.data.filename"
        class="fake-file-upload-input"
        (change)="onChange()"
      />
    </div>
  `, isInline: true, styles: [".fake-file-upload-input{padding:0;margin:0;border:none}\n"], dependencies: [{ kind: "component", type: i2.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i2$3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$3.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$6.FormlyAttributes, selector: "[formlyAttributes]", inputs: ["formlyAttributes", "id"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: FakeUploadComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-fake-upload-field', template: `
    <div>
      <button
        (click)="onClick()"
        [id]="id"
        type="file"
        [formControl]="formControl"
        [formlyAttributes]="field"
        (change)="onChange()"
        ngDefaultControl
        [name]="id"
        mat-stroked-button
      >
        Choose File
      </button>
      <input
        type="text"
        [value]="to.data.filename"
        class="fake-file-upload-input"
        (change)="onChange()"
      />
    </div>
  `, styles: [".fake-file-upload-input{padding:0;margin:0;border:none}\n"] }]
        }] });

class AppFormlyModule {
}
AppFormlyModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AppFormlyModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AppFormlyModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.2", ngImport: i0, type: AppFormlyModule, declarations: [InfoFieldComponent,
        DateTimePickerComponent,
        AutocompleteTypeComponent,
        NgSelectTypeComponent,
        FileUploadComponent,
        FileUploadWrapperComponent,
        FileValueAccessorDirective,
        HtmlTypeComponent,
        TagInputComponent,
        RepeatTypeComponent,
        NewRepeatTypeComponent,
        ButtonTypeComponent,
        TextEditorComponent,
        FakeUploadComponent,
        FormlyFormFlexLayoutComponent], imports: [CommonModule,
        MaterialModule,
        MatDatepickerModule,
        NgSelectModule,
        DragDropModule, i1$7.QuillModule, FormsModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        FormlyMatDatepickerModule,
        FormlyMaterialModule, i1$6.FormlyModule], exports: [NgSelectModule,
        DragDropModule,
        QuillModule,
        FormsModule,
        ReactiveFormsModule,
        FormlyModule,
        FormlyMaterialModule,
        FlexLayoutModule,
        FormlyFormFlexLayoutComponent] });
AppFormlyModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AppFormlyModule, imports: [CommonModule,
        MaterialModule,
        MatDatepickerModule,
        NgSelectModule,
        DragDropModule,
        QuillModule.forRoot(),
        FormsModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        FormlyMatDatepickerModule,
        FormlyMaterialModule,
        FormlyModule.forRoot({
            types: [
                {
                    name: 'infofield',
                    component: InfoFieldComponent,
                },
                {
                    name: 'datetimepicker',
                    component: DateTimePickerComponent,
                    wrappers: ['form-field'],
                },
                {
                    name: 'autocomplete',
                    component: AutocompleteTypeComponent,
                    wrappers: ['form-field'],
                },
                {
                    name: 'file-upload',
                    component: FileUploadComponent,
                    wrappers: ['form-field'],
                },
                {
                    name: 'fake-upload',
                    component: FakeUploadComponent,
                    wrappers: ['form-field'],
                },
                {
                    name: 'html',
                    component: HtmlTypeComponent,
                    wrappers: ['form-field'],
                },
                { name: 'ng-select', component: NgSelectTypeComponent },
                {
                    name: 'tag-input',
                    component: TagInputComponent,
                    wrappers: ['form-field'],
                },
                { name: 'repeat', component: RepeatTypeComponent },
                { name: 'new-repeat', component: NewRepeatTypeComponent },
                {
                    name: 'button',
                    component: ButtonTypeComponent,
                    defaultOptions: {
                        templateOptions: {
                            type: 'button',
                        },
                    },
                },
                {
                    name: 'text-editor',
                    component: TextEditorComponent,
                    wrappers: ['form-field'],
                },
            ],
            validators: [
                { name: 'integer', validation: integerValidator },
                { name: 'decimal', validation: decimalValidator },
                {
                    name: 'contact-number',
                    validation: contactNumberValidator,
                },
                { name: 'email', validation: emailValidator },
                { name: 'file-upload', validation: fileUploadValidator },
                { name: 'pin', validation: pinValidator },
                {
                    name: 'safe-input',
                    validation: specialCharactersValidator,
                },
                {
                    name: 'max-length-quill',
                    validation: maxLengthQuillValidator,
                },
            ],
            validationMessages: [
                {
                    name: 'file-upload',
                    message: fileUploadValidatorMessage,
                },
                { name: 'required', message: 'this field is required' },
                {
                    name: 'maxlength',
                    message: maxlengthValidationMessage,
                },
                {
                    name: 'max-length-quill',
                    message: maxlengthValidationMessageQuill,
                },
                { name: 'integer', message: integerValidatorMessage },
                { name: 'decimal', message: decimalValidatorMessage },
                {
                    name: 'contact-number',
                    message: contactNumberValidatorMessage,
                },
                { name: 'email', message: emailValidatorMessage },
                {
                    name: 'not-unique',
                    message: notUniqueValidatorMessage,
                },
                {
                    name: 'autocomplete',
                    message: autocompleteValidatorMessage,
                },
                {
                    name: 'pin',
                    message: pinValidatorMessage,
                },
                {
                    name: 'matDatepickerMin',
                    message: minDatePickerValidatorMessage,
                },
                {
                    name: 'matDatepickerMax',
                    message: maxDatePickerValidatorMessage,
                },
                {
                    name: 'pattern',
                    message: patternValidatorMessage,
                },
                {
                    name: 'single-active-date',
                    message: singleActiveDateValidatorMessage,
                },
                {
                    name: 'field-validation-error',
                    message: fieldValidatorMessage,
                },
            ],
            wrappers: [
                { name: 'file-upload-wrapper', component: FileUploadWrapperComponent },
            ],
        }), NgSelectModule,
        DragDropModule,
        QuillModule,
        FormsModule,
        ReactiveFormsModule,
        FormlyModule,
        FormlyMaterialModule,
        FlexLayoutModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AppFormlyModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MaterialModule,
                        MatDatepickerModule,
                        NgSelectModule,
                        DragDropModule,
                        QuillModule.forRoot(),
                        FormsModule,
                        ReactiveFormsModule,
                        FlexLayoutModule,
                        FormlyMatDatepickerModule,
                        FormlyMaterialModule,
                        FormlyModule.forRoot({
                            types: [
                                {
                                    name: 'infofield',
                                    component: InfoFieldComponent,
                                },
                                {
                                    name: 'datetimepicker',
                                    component: DateTimePickerComponent,
                                    wrappers: ['form-field'],
                                },
                                {
                                    name: 'autocomplete',
                                    component: AutocompleteTypeComponent,
                                    wrappers: ['form-field'],
                                },
                                {
                                    name: 'file-upload',
                                    component: FileUploadComponent,
                                    wrappers: ['form-field'],
                                },
                                {
                                    name: 'fake-upload',
                                    component: FakeUploadComponent,
                                    wrappers: ['form-field'],
                                },
                                {
                                    name: 'html',
                                    component: HtmlTypeComponent,
                                    wrappers: ['form-field'],
                                },
                                { name: 'ng-select', component: NgSelectTypeComponent },
                                {
                                    name: 'tag-input',
                                    component: TagInputComponent,
                                    wrappers: ['form-field'],
                                },
                                { name: 'repeat', component: RepeatTypeComponent },
                                { name: 'new-repeat', component: NewRepeatTypeComponent },
                                {
                                    name: 'button',
                                    component: ButtonTypeComponent,
                                    defaultOptions: {
                                        templateOptions: {
                                            type: 'button',
                                        },
                                    },
                                },
                                {
                                    name: 'text-editor',
                                    component: TextEditorComponent,
                                    wrappers: ['form-field'],
                                },
                            ],
                            validators: [
                                { name: 'integer', validation: integerValidator },
                                { name: 'decimal', validation: decimalValidator },
                                {
                                    name: 'contact-number',
                                    validation: contactNumberValidator,
                                },
                                { name: 'email', validation: emailValidator },
                                { name: 'file-upload', validation: fileUploadValidator },
                                { name: 'pin', validation: pinValidator },
                                {
                                    name: 'safe-input',
                                    validation: specialCharactersValidator,
                                },
                                {
                                    name: 'max-length-quill',
                                    validation: maxLengthQuillValidator,
                                },
                            ],
                            validationMessages: [
                                {
                                    name: 'file-upload',
                                    message: fileUploadValidatorMessage,
                                },
                                { name: 'required', message: 'this field is required' },
                                {
                                    name: 'maxlength',
                                    message: maxlengthValidationMessage,
                                },
                                {
                                    name: 'max-length-quill',
                                    message: maxlengthValidationMessageQuill,
                                },
                                { name: 'integer', message: integerValidatorMessage },
                                { name: 'decimal', message: decimalValidatorMessage },
                                {
                                    name: 'contact-number',
                                    message: contactNumberValidatorMessage,
                                },
                                { name: 'email', message: emailValidatorMessage },
                                {
                                    name: 'not-unique',
                                    message: notUniqueValidatorMessage,
                                },
                                {
                                    name: 'autocomplete',
                                    message: autocompleteValidatorMessage,
                                },
                                {
                                    name: 'pin',
                                    message: pinValidatorMessage,
                                },
                                {
                                    name: 'matDatepickerMin',
                                    message: minDatePickerValidatorMessage,
                                },
                                {
                                    name: 'matDatepickerMax',
                                    message: maxDatePickerValidatorMessage,
                                },
                                {
                                    name: 'pattern',
                                    message: patternValidatorMessage,
                                },
                                {
                                    name: 'single-active-date',
                                    message: singleActiveDateValidatorMessage,
                                },
                                {
                                    name: 'field-validation-error',
                                    message: fieldValidatorMessage,
                                },
                            ],
                            wrappers: [
                                { name: 'file-upload-wrapper', component: FileUploadWrapperComponent },
                            ],
                        }),
                    ],
                    exports: [
                        NgSelectModule,
                        DragDropModule,
                        QuillModule,
                        FormsModule,
                        ReactiveFormsModule,
                        FormlyModule,
                        FormlyMaterialModule,
                        FlexLayoutModule,
                        FormlyFormFlexLayoutComponent,
                    ],
                    declarations: [
                        InfoFieldComponent,
                        DateTimePickerComponent,
                        AutocompleteTypeComponent,
                        NgSelectTypeComponent,
                        FileUploadComponent,
                        FileUploadWrapperComponent,
                        FileValueAccessorDirective,
                        HtmlTypeComponent,
                        TagInputComponent,
                        RepeatTypeComponent,
                        NewRepeatTypeComponent,
                        ButtonTypeComponent,
                        TextEditorComponent,
                        FakeUploadComponent,
                        FormlyFormFlexLayoutComponent,
                    ],
                }]
        }] });

class FormActionEventArgs {
    constructor(eventType, value) {
        this.eventType = eventType;
        this.value = value;
    }
}

var FormActionEventType;
(function (FormActionEventType) {
    FormActionEventType["Cancel"] = "CANCEL";
    FormActionEventType["Create"] = "CREATE";
    FormActionEventType["Clone"] = "CLONE";
    FormActionEventType["Update"] = "UPDATE";
    FormActionEventType["Delete"] = "DELETE";
    FormActionEventType["Edit"] = "EDIT";
})(FormActionEventType || (FormActionEventType = {}));

var StandardFormStateFlags;
(function (StandardFormStateFlags) {
    StandardFormStateFlags[StandardFormStateFlags["Never"] = 0] = "Never";
    StandardFormStateFlags[StandardFormStateFlags["Busy"] = 1] = "Busy";
    StandardFormStateFlags[StandardFormStateFlags["Loading"] = 2] = "Loading";
    // tslint:disable-next-line: no-bitwise
    StandardFormStateFlags[StandardFormStateFlags["BusyOrLoading"] = 3] = "BusyOrLoading";
    StandardFormStateFlags[StandardFormStateFlags["Pristine"] = 4] = "Pristine";
    StandardFormStateFlags[StandardFormStateFlags["Dirty"] = 8] = "Dirty";
    StandardFormStateFlags[StandardFormStateFlags["Invalid"] = 16] = "Invalid";
})(StandardFormStateFlags || (StandardFormStateFlags = {}));

/**
 * The arguments passed to a standard form event.
 */
class StandardFormEventArgs {
    constructor(controller, model) {
        this.controller = controller;
        this.model = model;
    }
    /**
     * Returns true if the active form is in a valid state, otherwise returns false.
     */
    get isValid() {
        return this.controller.isValid;
    }
    /**
     * Returns true if the active form is in a dirty state, otherwise returns false.
     */
    get isDirty() {
        return this.controller.isDirty;
    }
    /**
     * Returns true if the active form is in a pristine state, otherwise returns false.
     */
    get isPristine() {
        return this.controller.isPristine;
    }
    /**
     * Sets the valid state for the active form.
     */
    setValidState(isValid) {
        this.controller.setValidState(isValid);
    }
    /**
     * For standard forms, resets the form valid state for the entire feature.
     * This includes the default form states (`default` and `default-pristine`), and any other client contexts.
     *
     * For modal forms, resets the modal form valid state.
     *
     * This method is typically invoked after a successful save.
     */
    resetValidState() {
        this.controller.resetValidState();
    }
    /**
     * Applies a validation error to the specified form control.
     */
    setFormError(controlName, errors, opts) {
        this.controller.setFormError(controlName, errors, opts);
    }
    /**
     * Applies a validation error to the specified form control.
     */
    setFormValidationError(errors, opts) {
        errors.map((x) => {
            this.controller.setFormError(x.field, { 'field-validation-error': x.message }, opts);
        });
    }
}
/**
 * The arguments passed to a standard form action event.
 */
class StandardFormActionEventArgs extends StandardFormEventArgs {
    constructor(controller, model, eventType) {
        super(controller, model);
        this.eventType = eventType;
    }
}

class KeySet {
    constructor() {
        this._keys = {};
        this._count = 0;
    }
    get count() {
        return this._count;
    }
    apply(key, set) {
        return set === true ? this.set(key) : this.remove(key);
    }
    set(key) {
        if (key == undefined) {
            throw new Error(ExceptionMessageFormatter.argumentNull('key'));
        }
        const result = !this.containsKey(key);
        if (result) {
            this._keys[key] = undefined;
            this._count++;
        }
        return result;
    }
    remove(key) {
        const result = this.containsKey(key);
        if (result) {
            delete this._keys[key];
            this._count--;
        }
        return result;
    }
    clear() {
        if (this.count > 0) {
            this._keys = {};
            this._count = 0;
        }
    }
    containsKey(key) {
        if (key == undefined) {
            throw new Error(ExceptionMessageFormatter.argumentNull('key'));
        }
        return this._keys.hasOwnProperty(key);
    }
    getKeys() {
        return Object.keys(this._keys);
    }
}

var StateActions;
(function (StateActions) {
    StateActions["getState"] = "getState";
    StateActions["setState"] = "setState";
    StateActions["removeState"] = "removeState";
    StateActions["clearForm"] = "clearForm";
})(StateActions || (StateActions = {}));
class FormViewComponent {
    constructor() {
        this._readOnly = false;
        this._canSave = false;
        this._disableStateManager = false;
        this._model = {};
        this.form = new FormGroup({});
        this.inline = false;
        this.globalStateReset = false;
        this.evalStateInterceptor = (resolver) => this.evalState(resolver);
    }
    get model() {
        return this._model;
    }
    set model(value) {
        if (value == undefined) {
            value = {};
        }
        this._model = value;
    }
    get readOnly() {
        return this._readOnly;
    }
    set readOnly(value) {
        value = value === true;
        if (value === this._readOnly)
            return;
        this._readOnly = value;
        this.applyReadOnly();
    }
    /**
     * When set to `true`, causes the `FormViewComponent` to exclude its form state from the `GlobalStateManager` form state dictionary.
     * This prevents this instance's form state from being detected by components descending from `AutoCanDeactivate`,
     * the consequence of which is that its state will not be detected by `DiscardChangesGuard`.
     */
    get disableStateManager() {
        return this._disableStateManager;
    }
    set disableStateManager(value) {
        this._disableStateManager = value === true;
        if (this._disableStateManager) {
            this.deleteManagedState();
        }
    }
    get isValid() {
        return this.stateHelper.manageState(StateActions.getState, {
            formKey: this.validationKey,
        });
    }
    get hasChanges() {
        return this.form.dirty;
    }
    get isBusy() {
        return this.busyState.isBusy;
    }
    get isLoaded() {
        return this.busyState.loadingState === LoadingState.Loaded;
    }
    get canSave() {
        return this._canSave;
    }
    get activeFields() {
        if (this._activeFields == undefined) {
            this._activeFields =
                typeof this.fields === 'function' ? this.fields() : this.fields;
            if (this._activeFields != undefined) {
                this._activeFields.forEach((f) => {
                    if (f.templateOptions.disabled === true) {
                        if (this._persistentReadOnly == undefined) {
                            this._persistentReadOnly = new KeySet();
                        }
                        const keyString = f.key;
                        this._persistentReadOnly.set(keyString);
                    }
                });
                if (this.readOnly) {
                    this.applyReadOnly();
                }
            }
        }
        return this._activeFields;
    }
    get controller() {
        return this._controller;
    }
    ngOnInit() {
        this.createController();
        this.stateHelper.manageState(StateActions.setState, {
            formKey: this.validationKey,
            isValid: true,
        });
        if (this.busyState == undefined) {
            this.busyState = new ManualBusyState();
        }
        this.busyState.busyState$.subscribe(() => {
            this.updateCanSave();
        });
        // TODO: Modal busy overlay to cover entire UI screen. Optional busy-state message.
        // this.busyState.busyState$.subscribe((isBusy: boolean) => {
        // });
    }
    ngOnDestroy() {
        this.deleteManagedState();
    }
    applyReadOnly() {
        if (this._activeFields == undefined || this._activeFields.length === 0) {
            return;
        }
        this._activeFields.forEach((f) => {
            const keyString = f.key;
            f.templateOptions.disabled =
                this.readOnly ||
                    (this._persistentReadOnly &&
                        this._persistentReadOnly.containsKey(keyString));
        });
    }
    evalState(resolver) {
        if (resolver == undefined)
            return undefined;
        const f = this.deriveStateFlags();
        let result;
        if (typeof resolver === 'function') {
            result = resolver(f, this.model);
        }
        else {
            // tslint:disable-next-line: no-bitwise
            result = (f & resolver) !== StandardFormStateFlags.Never;
        }
        return result === true ? result : undefined;
    }
    createController() {
        if (this.validationKey == undefined) {
            throw new Error('No form validationKey has been assigned.');
        }
        const that = this;
        this._pristineKey = this.validationKey + '-pristine';
        this._controller = {
            get isValid() {
                return that.disableStateManager
                    ? that.form.valid
                    : this.stateHelper.manageState(StateActions.getState, {
                        formKey: that.validationKey,
                    });
            },
            get isDirty() {
                return that.form.dirty;
            },
            get isPristine() {
                return that.form.pristine;
            },
            setValidState: (isValid) => {
                if (!this.disableStateManager) {
                    this.stateHelper.manageState(StateActions.setState, {
                        formKey: that.validationKey,
                        isValid: isValid,
                    });
                }
                if (isValid) {
                    that.form.markAsPristine();
                }
                else {
                    that.form.markAsDirty();
                }
                this.updateCanSave();
            },
            resetValidState: () => {
                if (!this.disableStateManager) {
                    if (this.globalStateReset === true) {
                        this.stateHelper.manageState(StateActions.clearForm, {
                            formKey: that.validationKey,
                        });
                    }
                    else {
                        this.stateHelper.manageState(StateActions.setState, {
                            formKey: that.validationKey,
                            isValid: true,
                        });
                        this.stateHelper.manageState(StateActions.setState, {
                            formKey: that._pristineKey,
                            isValid: true,
                        });
                    }
                }
                that.form.markAsPristine();
                that.updateCanSave();
            },
            setFormError: (controlName, errors, opts) => {
                that.lookupControl(controlName).setErrors(errors, opts);
                that.updateCanSave();
            },
            patchValue: (controlName, value) => {
                that.lookupControl(controlName).patchValue(value);
            },
        };
        this.form.statusChanges.subscribe(() => {
            if (!this.disableStateManager) {
                this.stateHelper.manageState(StateActions.setState, {
                    formKey: that._pristineKey,
                    isValid: that.form.pristine === true,
                });
            }
            that.updateCanSave();
        });
    }
    lookupControl(controlName) {
        const ctrl = this.form.controls[controlName];
        if (ctrl == undefined) {
            throw new Error(`[FormViewComponent] No form control named "${controlName}" exists.`);
        }
        return ctrl;
    }
    updateCanSave() {
        setTimeout(() => {
            this._canSave = !this.isBusy && this.form.dirty && this.form.valid;
        });
    }
    deriveStateFlags() {
        let f = StandardFormStateFlags.Never;
        if (this.form.dirty) {
            // tslint:disable-next-line: no-bitwise
            f |= StandardFormStateFlags.Dirty;
        }
        if (this.form.pristine) {
            // tslint:disable-next-line: no-bitwise
            f |= StandardFormStateFlags.Pristine;
        }
        if (this.form.invalid) {
            // tslint:disable-next-line: no-bitwise
            f |= StandardFormStateFlags.Invalid;
        }
        if (this.isBusy) {
            // tslint:disable-next-line: no-bitwise
            f |= StandardFormStateFlags.Busy;
        }
        if (this.busyState.loadingState !== LoadingState.Loaded) {
            // tslint:disable-next-line: no-bitwise
            f |= StandardFormStateFlags.Loading;
        }
        return f;
    }
    deleteManagedState() {
        this.stateHelper.manageState(StateActions.removeState, {
            formKey: this.validationKey,
        });
        this.stateHelper.manageState(StateActions.removeState, {
            formKey: this._pristineKey,
        });
    }
}
FormViewComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: FormViewComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FormViewComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: FormViewComponent, selector: "app-form-view", inputs: { inline: "inline", globalStateReset: "globalStateReset", validationKey: "validationKey", busyState: "busyState", fields: "fields", stateHelper: "stateHelper", model: "model", readOnly: "readOnly", disableStateManager: "disableStateManager" }, ngImport: i0, template: "<form [formGroup]=\"form\" *ngIf=\"isLoaded\">\r\n    <formly-form *ngIf=\"!inline\" [form]=\"form\" [fields]=\"activeFields\" [model]=\"model\">\r\n    </formly-form>\r\n    <app-kup-formly-form-flex *ngIf=\"inline\" [form]=\"form\" [fields]=\"activeFields\" [model]=\"model\">\r\n    </app-kup-formly-form-flex>\r\n    <ng-content select=[bottom-content]></ng-content>\r\n</form>\r\n", styles: [".bottom-button-panel{margin-top:15px}\n"], dependencies: [{ kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$3.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i1$6.FormlyForm, selector: "formly-form", inputs: ["model", "fields", "options", "form"], outputs: ["modelChange"] }, { kind: "component", type: FormlyFormFlexLayoutComponent, selector: "app-kup-formly-form-flex" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: FormViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-form-view', template: "<form [formGroup]=\"form\" *ngIf=\"isLoaded\">\r\n    <formly-form *ngIf=\"!inline\" [form]=\"form\" [fields]=\"activeFields\" [model]=\"model\">\r\n    </formly-form>\r\n    <app-kup-formly-form-flex *ngIf=\"inline\" [form]=\"form\" [fields]=\"activeFields\" [model]=\"model\">\r\n    </app-kup-formly-form-flex>\r\n    <ng-content select=[bottom-content]></ng-content>\r\n</form>\r\n", styles: [".bottom-button-panel{margin-top:15px}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { inline: [{
                type: Input
            }], globalStateReset: [{
                type: Input
            }], validationKey: [{
                type: Input
            }], busyState: [{
                type: Input
            }], fields: [{
                type: Input
            }], stateHelper: [{
                type: Input
            }], model: [{
                type: Input
            }], readOnly: [{
                type: Input
            }], disableStateManager: [{
                type: Input
            }] } });

class AppTextPipe {
    constructor(service) {
        this.service = service;
    }
    transform(value) {
        return this.service.getText(value);
    }
}
AppTextPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AppTextPipe, deps: [{ token: AppTextService }], target: i0.ɵɵFactoryTarget.Pipe });
AppTextPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.1.2", ngImport: i0, type: AppTextPipe, name: "appText" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AppTextPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'appText' }]
        }], ctorParameters: function () { return [{ type: AppTextService }]; } });

class StandardViewComponent {
    constructor(route, textService) {
        this.route = route;
        this.textService = textService;
        /**
         * Determines whether or not a cancel button will be displayed. The default value is `false`.
         */
        this.canCancel = false;
        /**
         * Determines whether or not a back button will be displayed. The default value is `false`.
         */
        this.canGoBack = false;
        /**
         * Determines whether or a create/new button will be displayed. The default value is `false`.
         */
        this.disableCreate = false;
        /**
         * Determines whether or a create/new button will be disabled. The default value is `false`.
         */
        this.canCreate = false;
        /**
         * Determines whether or not an export button will be displayed. The default value is `false`.
         */
        this.canExport = false;
        /**
         * The event which is raised when a user clicks a back button.
         */
        this.backClick = new EventEmitter();
        /**
         * The event which is raised when a user clicks a cancel button.
         */
        this.cancelClick = new EventEmitter();
        /**
         * The event which is raised when a user clicks a create button.
         */
        this.createClick = new EventEmitter();
        /**
         * The event which is raised when a user clicks an export button.
         */
        this.exportClick = new EventEmitter();
    }
    /**
     * Returns the active title text for this instance.
     */
    get activeTitle() {
        return this._activeTitle;
    }
    /**
     * Used internally by the component.
     * Returns `true` if this instance is in a state where its content should be rendered, otherwise returns `false`.
     */
    get showContent() {
        return this.busyState.loadingState === LoadingState.Loaded;
    }
    ngOnInit() {
        if (this.busyState == undefined) {
            this.busyState = new ManualBusyState();
        }
        this.busyState.loadingState$.subscribe(() => {
            this.setActiveTitle();
        });
        if (this.createTooltip == undefined) {
            this.createTooltip = '@tooltip.create';
        }
        this.createTooltip = this.textService.resolveText(this.createTooltip);
        // TODO: Modal busy overlay to cover entire UI screen? Optional busy-state message.
        // this.busyState.busyState$.subscribe((isBusy: boolean) => {
        // });
    }
    ngOnChanges(changes) {
        if (changes.viewTitle &&
            changes.viewTitle.currentValue !== this._activeTitle) {
            this.setActiveTitle();
        }
    }
    /**
     * Used internally by the component.
     */
    onBackClick() {
        this.backClick.emit();
    }
    /**
     * Used internally by the component.
     */
    onCancelClick() {
        this.cancelClick.emit();
    }
    /**
     * Used internally by the component.
     */
    onCreateClick() {
        this.createClick.emit();
    }
    /**
     * Used internally by the component.
     */
    onExportClick() {
        this.exportClick.emit();
    }
    setActiveTitle() {
        if (!TypeHelper.isStringNullOrEmpty(this.viewTitle)) {
            this._activeTitle = this.textService.resolveText(this.viewTitle);
        }
        else {
            const snapshot = this.route.snapshot;
            if (snapshot != undefined &&
                !TypeHelper.isStringNullOrEmpty(snapshot.data.title)) {
                this._activeTitle = snapshot.data.title;
            }
            else {
                switch (this.busyState.loadingState) {
                    case LoadingState.Loading:
                        this._activeTitle = 'Loading page content...';
                        break;
                    case LoadingState.Failed:
                        this._activeTitle = 'An error ocurred loading the page content.';
                        break;
                    case LoadingState.Loaded:
                        this._activeTitle = FormatHelper.formatRoutePath(this.route);
                        break;
                    default:
                        this._activeTitle = 'Initialising page...';
                        break;
                }
            }
        }
    }
}
StandardViewComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: StandardViewComponent, deps: [{ token: i1$4.ActivatedRoute }, { token: AppTextService }], target: i0.ɵɵFactoryTarget.Component });
StandardViewComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: StandardViewComponent, selector: "app-standard-view", inputs: { busyState: "busyState", viewTitle: "viewTitle", subTitle: "subTitle", buttons: "buttons", canCancel: "canCancel", canGoBack: "canGoBack", disableCreate: "disableCreate", canCreate: "canCreate", canExport: "canExport", createTooltip: "createTooltip", cssClass: "cssClass", clickInterceptor: "clickInterceptor", evalStateInterceptor: "evalStateInterceptor" }, outputs: { backClick: "backClick", cancelClick: "cancelClick", createClick: "createClick", exportClick: "exportClick" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"standard-view\">\n  <div [class]=\"cssClass\">\n    <div fxLayout=\"row\" fxLayoutAlign=\"center center\">\n      <div fxFlex=\"50%\">\n        <h1 class=\"view-title\">\n          {{ activeTitle }}\n        </h1>\n        <h4 *ngIf=\"subTitle\">{{ subTitle }}</h4>\n      </div>\n      <div fxFlex=\"50%\" align=\"right\">\n        <ul class=\"o-list-inline\">\n          <li class=\"o-list-inline__item\" *ngIf=\"canGoBack\">\n            <button type=\"button\" mat-mini-fab color=\"warn\" (click)=\"onBackClick()\" [disabled]=\"busyState.isBusy\"\n              matTooltip=\"{{ 'tooltip.back' | appText }}\">\n              <mat-icon class=\"mat-18\">arrow_back</mat-icon>\n            </button>\n          </li>\n\n          <li class=\"o-list-inline__item\" *ngIf=\"canCancel\">\n            <button type=\"button\" mat-mini-fab color=\"warn\" (click)=\"onCancelClick()\" [disabled]=\"busyState.isBusy\"\n              matTooltip=\"{{ 'tooltip.discard' | appText }}\">\n              <mat-icon class=\"mat-18\">clear</mat-icon>\n            </button>\n          </li>\n\n          <ng-content select=\"[leading-list-items]\"></ng-content>\n\n          <app-button-group class=\"o-list-inline__item\" [busyState]=\"busyState\" [buttons]=\"buttons\"\n            [clickInterceptor]=\"clickInterceptor\" [evalStateInterceptor]=\"evalStateInterceptor\">\n          </app-button-group>\n\n          <ng-content select=\"[trailing-list-items]\"></ng-content>\n          <li class=\"o-list-inline__item\" *ngIf=\"canCreate\">\n            <button mat-mini-fab color=\"primary\" [disabled]=\"disableCreate\" [matTooltip]=\"createTooltip\"\n              (click)=\"onCreateClick()\">\n              <mat-icon class=\"mat-18\">add</mat-icon>\n            </button>\n          </li>\n          <li class=\"o-list-inline__item\" *ngIf=\"canExport\">\n            <button mat-mini-fab color=\"primary\" id=\"genotypes_export_button\" (click)=\"onExportClick()\"\n              matTooltip=\"{{ 'tooltip.export' | appText }}\">\n              <mat-icon class=\"mat-18\" svgIcon=\"file_export_white\"></mat-icon>\n            </button>\n          </li>\n        </ul>\n      </div>\n    </div>\n    <app-busystate-wrapper [state]=\"busyState\">\n      <div *ngIf=\"showContent\">\n        <ng-content></ng-content>\n      </div>\n    </app-busystate-wrapper>\n  </div>\n</div>", styles: [".standard-view{margin-bottom:15px}.view-title{font-size:24px;font-weight:500}.sub-view .view-title{font-size:18px}\n"], dependencies: [{ kind: "component", type: i2.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i4.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$1.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i2$1.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "directive", type: i2$1.DefaultFlexDirective, selector: "  [fxFlex], [fxFlex.xs], [fxFlex.sm], [fxFlex.md],  [fxFlex.lg], [fxFlex.xl], [fxFlex.lt-sm], [fxFlex.lt-md],  [fxFlex.lt-lg], [fxFlex.lt-xl], [fxFlex.gt-xs], [fxFlex.gt-sm],  [fxFlex.gt-md], [fxFlex.gt-lg]", inputs: ["fxFlex", "fxFlex.xs", "fxFlex.sm", "fxFlex.md", "fxFlex.lg", "fxFlex.xl", "fxFlex.lt-sm", "fxFlex.lt-md", "fxFlex.lt-lg", "fxFlex.lt-xl", "fxFlex.gt-xs", "fxFlex.gt-sm", "fxFlex.gt-md", "fxFlex.gt-lg"] }, { kind: "component", type: BusyStateWrapperComponent, selector: "app-busystate-wrapper", inputs: ["state", "suppressLoading", "suppressBusy"] }, { kind: "component", type: ButtonGroupComponent, selector: "app-button-group", inputs: ["busyState", "buttons", "clickInterceptor", "evalStateInterceptor"] }, { kind: "pipe", type: AppTextPipe, name: "appText" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: StandardViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-standard-view', template: "<div class=\"standard-view\">\n  <div [class]=\"cssClass\">\n    <div fxLayout=\"row\" fxLayoutAlign=\"center center\">\n      <div fxFlex=\"50%\">\n        <h1 class=\"view-title\">\n          {{ activeTitle }}\n        </h1>\n        <h4 *ngIf=\"subTitle\">{{ subTitle }}</h4>\n      </div>\n      <div fxFlex=\"50%\" align=\"right\">\n        <ul class=\"o-list-inline\">\n          <li class=\"o-list-inline__item\" *ngIf=\"canGoBack\">\n            <button type=\"button\" mat-mini-fab color=\"warn\" (click)=\"onBackClick()\" [disabled]=\"busyState.isBusy\"\n              matTooltip=\"{{ 'tooltip.back' | appText }}\">\n              <mat-icon class=\"mat-18\">arrow_back</mat-icon>\n            </button>\n          </li>\n\n          <li class=\"o-list-inline__item\" *ngIf=\"canCancel\">\n            <button type=\"button\" mat-mini-fab color=\"warn\" (click)=\"onCancelClick()\" [disabled]=\"busyState.isBusy\"\n              matTooltip=\"{{ 'tooltip.discard' | appText }}\">\n              <mat-icon class=\"mat-18\">clear</mat-icon>\n            </button>\n          </li>\n\n          <ng-content select=\"[leading-list-items]\"></ng-content>\n\n          <app-button-group class=\"o-list-inline__item\" [busyState]=\"busyState\" [buttons]=\"buttons\"\n            [clickInterceptor]=\"clickInterceptor\" [evalStateInterceptor]=\"evalStateInterceptor\">\n          </app-button-group>\n\n          <ng-content select=\"[trailing-list-items]\"></ng-content>\n          <li class=\"o-list-inline__item\" *ngIf=\"canCreate\">\n            <button mat-mini-fab color=\"primary\" [disabled]=\"disableCreate\" [matTooltip]=\"createTooltip\"\n              (click)=\"onCreateClick()\">\n              <mat-icon class=\"mat-18\">add</mat-icon>\n            </button>\n          </li>\n          <li class=\"o-list-inline__item\" *ngIf=\"canExport\">\n            <button mat-mini-fab color=\"primary\" id=\"genotypes_export_button\" (click)=\"onExportClick()\"\n              matTooltip=\"{{ 'tooltip.export' | appText }}\">\n              <mat-icon class=\"mat-18\" svgIcon=\"file_export_white\"></mat-icon>\n            </button>\n          </li>\n        </ul>\n      </div>\n    </div>\n    <app-busystate-wrapper [state]=\"busyState\">\n      <div *ngIf=\"showContent\">\n        <ng-content></ng-content>\n      </div>\n    </app-busystate-wrapper>\n  </div>\n</div>", styles: [".standard-view{margin-bottom:15px}.view-title{font-size:24px;font-weight:500}.sub-view .view-title{font-size:18px}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$4.ActivatedRoute }, { type: AppTextService }]; }, propDecorators: { busyState: [{
                type: Input
            }], viewTitle: [{
                type: Input
            }], subTitle: [{
                type: Input
            }], buttons: [{
                type: Input
            }], canCancel: [{
                type: Input
            }], canGoBack: [{
                type: Input
            }], disableCreate: [{
                type: Input
            }], canCreate: [{
                type: Input
            }], canExport: [{
                type: Input
            }], createTooltip: [{
                type: Input
            }], cssClass: [{
                type: Input
            }], clickInterceptor: [{
                type: Input
            }], evalStateInterceptor: [{
                type: Input
            }], backClick: [{
                type: Output
            }], cancelClick: [{
                type: Output
            }], createClick: [{
                type: Output
            }], exportClick: [{
                type: Output
            }] } });

class StandardFormComponent {
    constructor(textService) {
        this.textService = textService;
        /**
         * Determines whether or not the form is rendered in inline mode. The default value is `false`.
         */
        this.inline = false;
        /**
         * Determines whether or not the form is in read-only mode. The default value is `false`.
         */
        this.readOnly = false;
        /**
         * Determines whether or not the form is in create mode. The default value is `true`.
         */
        this.createMode = false;
        /**
         * Determines whether or not a save button will be displayed. The default value is `true`.
         */
        this.canSave = true;
        /**
         * Determines whether or not a cancel button will be displayed. The default value is `true`.
         */
        this.canCancel = true;
        /**
         * When set to `true`, causes the `StandardFormComponent` to exclude its form state from the `GlobalStateManager` form state dictionary.
         * This prevents this instance's form state from being detected by components descending from `AutoCanDeactivate`,
         * the consequence of which is that its state will not be detected by `DiscardChangesGuard`.
         *
         * @todo: modular components currently cannot support a global state in the way it has been designed,
         * so we will need to manually handle form state until this can e refactored
         */
        this.disableStateManager = false;
        /**
         * The event which is raised when a user-initiated standard action occurs.
         */
        this.standardAction = new EventEmitter();
        /**
         * The event which is raised when a user clicks a cancel button.
         */
        this.cancelClick = new EventEmitter();
        /**
         * The event which is raised when a user clicks a save button.
         */
        this.saveClick = new EventEmitter();
        /**
         * Used internally by the component.
         */
        this.clickInterceptor = (b) => this.onButtonClick(b);
    }
    /**
     * The `FormlyFieldConfig` items which define the form.
     * These may be assigned either as an array of type `FormlyFieldConfig`, or
     * (if construction needs to be delayed until the OnInit lifecycle event) as a function that returns
     * an an array of type `FormlyFieldConfig`.
     */
    get fields() {
        return this.formView.fields;
    }
    set fields(value) {
        this.formView.fields = value;
    }
    /**
     * The model that the form is bound to.
     */
    get model() {
        return this.formView.model;
    }
    set model(value) {
        this.formView.model = value;
    }
    /**
     * The `BusyStateProvider` implementation that this instance interacts with.
     */
    get busyState() {
        return this.formView.busyState;
    }
    set busyState(value) {
        this.formView.busyState = value;
    }
    /**
     * Returns `true` if this instance's `BusyStateProvider` is in the busy state, otherwise returns `false`.
     */
    get isBusy() {
        return this.busyState.isBusy;
    }
    /**
     * Returns `true` if this instance is in state where the user cannot initiate a save operation, otherwise returns `false`.
     */
    get disableSave() {
        return !this.formView.canSave;
    }
    /**
     * Returns `true` if this instance's top cancel button should be displayed, otherwise returns `false`.
     */
    get allowTopCancel() {
        return !this.createMode && this.canCancel;
    }
    /**
     * Returns `true` if this instance's bottom cancel button should be displayed, otherwise returns `false`.
     */
    get allowBottomCancel() {
        return this.createMode && this.canCancel;
    }
    /**
     * Returns the active create button text for this instance.
     */
    get activeCreateButtonText() {
        if (this.createButtonText == undefined) {
            this.createButtonText = this.textService.getText('button.create');
        }
        else if (this.textService.isKeyToken(this.createButtonText)) {
            this.createButtonText = this.textService.resolveText(this.createButtonText);
        }
        return this.createButtonText;
    }
    /**
     * Returns the `StandardFormController` this instance.
     */
    get controller() {
        return this.formView.controller;
    }
    /**
     * Used internally by the component.
     */
    onSaveClick() {
        this.saveClick.emit(new StandardFormEventArgs(this.formView.controller, this.model));
        this.onActionEvent(this.createMode ? FormActionEventType.Create : FormActionEventType.Update);
    }
    /**
     * Used internally by the component.
     */
    onCancelClick() {
        this.cancelClick.emit(new StandardFormEventArgs(this.formView.controller, this.model));
        this.onActionEvent(FormActionEventType.Cancel);
    }
    /**
     * Used internally by the component.
     */
    onButtonClick(b) {
        if (b.click != undefined) {
            b.click(new StandardFormEventArgs(this.formView.controller, this.model));
        }
    }
    onActionEvent(eventType) {
        this.standardAction.emit(new StandardFormActionEventArgs(this.formView.controller, this.model, eventType));
    }
}
StandardFormComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: StandardFormComponent, deps: [{ token: AppTextService }], target: i0.ɵɵFactoryTarget.Component });
StandardFormComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: StandardFormComponent, selector: "app-standard-form", inputs: { stateHelper: "stateHelper", viewTitle: "viewTitle", subTitle: "subTitle", topButtons: "topButtons", inline: "inline", readOnly: "readOnly", createMode: "createMode", canSave: "canSave", canCancel: "canCancel", disableStateManager: "disableStateManager", createButtonText: "createButtonText", fields: "fields", model: "model", busyState: "busyState" }, outputs: { standardAction: "standardAction", cancelClick: "cancelClick", saveClick: "saveClick" }, viewQueries: [{ propertyName: "formView", first: true, predicate: ["formView"], descendants: true, static: true }], ngImport: i0, template: "<app-standard-view cssClass='standard-form-view' [viewTitle]=\"viewTitle\"  [subTitle]=\"subTitle\" [busyState]=\"busyState\" [buttons]=\"topButtons\"\r\n    [clickInterceptor]=\"clickInterceptor\" [evalStateInterceptor]=\"formView.evalStateInterceptor\"\r\n    [canCancel]=\"allowTopCancel\" (cancelClick)=\"onCancelClick()\">\r\n\r\n    <span trailing-list-items class=\"o-list-inline__item\" *ngIf=\"canSave && !createMode\">\r\n        <li class=\"o-list-inline__item\">\r\n            <button type=\"button\" mat-mini-fab color=\"primary\" [disabled]=\"disableSave\" (click)=\"onSaveClick()\"\r\n                matTooltip=\"{{'tooltip.save' | appText}}\">\r\n                <mat-icon svgIcon=\"save_white\"></mat-icon>\r\n            </button>\r\n        </li>\r\n    </span>\r\n    <div class=\"nested-content\">\r\n        <ng-content select=\"[above-form]\"></ng-content>\r\n        <app-form-view\r\n          #formView\r\n          validationKey=\"default\"\r\n          [stateHelper]=\"stateHelper\"\r\n          [inline]=\"inline\"\r\n          [readOnly]=\"readOnly\"\r\n          [fields]=\"fields\"\r\n          [busyState]=\"busyState\"\r\n          [model]=\"model\"\r\n          [globalStateReset]=\"true\"\r\n          [disableStateManager]=\"disableStateManager\"\r\n        >\r\n            <div *ngIf=\"createMode\" bottom-content class=\"bottom-button-panel\">\r\n                <button *ngIf=\"canSave\" type=\"submit\" mat-raised-button color=\"primary\" [disabled]=\"disableSave\"\r\n                    (click)=\"onSaveClick()\">{{activeCreateButtonText}}</button>\r\n                <button *ngIf=\"allowBottomCancel\" type=\"button\" mat-raised-button color=\"warn\" [disabled]=\"isBusy\" class=\"discard-button\"\r\n                    (click)=\"onCancelClick()\">{{'button.discard' | appText}}</button>\r\n            </div>\r\n        </app-form-view>\r\n        <ng-content select=\"[below-form]\"></ng-content>\r\n    </div>\r\n</app-standard-view>\r\n", styles: [".standard-form-view .nested-content .view-title{font-size:18px}.standard-form-view .bottom-button-panel{margin-top:15px}\n"], dependencies: [{ kind: "component", type: i2.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i4.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: FormViewComponent, selector: "app-form-view", inputs: ["inline", "globalStateReset", "validationKey", "busyState", "fields", "stateHelper", "model", "readOnly", "disableStateManager"] }, { kind: "component", type: StandardViewComponent, selector: "app-standard-view", inputs: ["busyState", "viewTitle", "subTitle", "buttons", "canCancel", "canGoBack", "disableCreate", "canCreate", "canExport", "createTooltip", "cssClass", "clickInterceptor", "evalStateInterceptor"], outputs: ["backClick", "cancelClick", "createClick", "exportClick"] }, { kind: "pipe", type: AppTextPipe, name: "appText" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: StandardFormComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-standard-form', encapsulation: ViewEncapsulation.None, template: "<app-standard-view cssClass='standard-form-view' [viewTitle]=\"viewTitle\"  [subTitle]=\"subTitle\" [busyState]=\"busyState\" [buttons]=\"topButtons\"\r\n    [clickInterceptor]=\"clickInterceptor\" [evalStateInterceptor]=\"formView.evalStateInterceptor\"\r\n    [canCancel]=\"allowTopCancel\" (cancelClick)=\"onCancelClick()\">\r\n\r\n    <span trailing-list-items class=\"o-list-inline__item\" *ngIf=\"canSave && !createMode\">\r\n        <li class=\"o-list-inline__item\">\r\n            <button type=\"button\" mat-mini-fab color=\"primary\" [disabled]=\"disableSave\" (click)=\"onSaveClick()\"\r\n                matTooltip=\"{{'tooltip.save' | appText}}\">\r\n                <mat-icon svgIcon=\"save_white\"></mat-icon>\r\n            </button>\r\n        </li>\r\n    </span>\r\n    <div class=\"nested-content\">\r\n        <ng-content select=\"[above-form]\"></ng-content>\r\n        <app-form-view\r\n          #formView\r\n          validationKey=\"default\"\r\n          [stateHelper]=\"stateHelper\"\r\n          [inline]=\"inline\"\r\n          [readOnly]=\"readOnly\"\r\n          [fields]=\"fields\"\r\n          [busyState]=\"busyState\"\r\n          [model]=\"model\"\r\n          [globalStateReset]=\"true\"\r\n          [disableStateManager]=\"disableStateManager\"\r\n        >\r\n            <div *ngIf=\"createMode\" bottom-content class=\"bottom-button-panel\">\r\n                <button *ngIf=\"canSave\" type=\"submit\" mat-raised-button color=\"primary\" [disabled]=\"disableSave\"\r\n                    (click)=\"onSaveClick()\">{{activeCreateButtonText}}</button>\r\n                <button *ngIf=\"allowBottomCancel\" type=\"button\" mat-raised-button color=\"warn\" [disabled]=\"isBusy\" class=\"discard-button\"\r\n                    (click)=\"onCancelClick()\">{{'button.discard' | appText}}</button>\r\n            </div>\r\n        </app-form-view>\r\n        <ng-content select=\"[below-form]\"></ng-content>\r\n    </div>\r\n</app-standard-view>\r\n", styles: [".standard-form-view .nested-content .view-title{font-size:18px}.standard-form-view .bottom-button-panel{margin-top:15px}\n"] }]
        }], ctorParameters: function () { return [{ type: AppTextService }]; }, propDecorators: { formView: [{
                type: ViewChild,
                args: ['formView', { static: true }]
            }], stateHelper: [{
                type: Input
            }], viewTitle: [{
                type: Input
            }], subTitle: [{
                type: Input
            }], topButtons: [{
                type: Input
            }], inline: [{
                type: Input
            }], readOnly: [{
                type: Input
            }], createMode: [{
                type: Input
            }], canSave: [{
                type: Input
            }], canCancel: [{
                type: Input
            }], disableStateManager: [{
                type: Input
            }], createButtonText: [{
                type: Input
            }], standardAction: [{
                type: Output
            }], cancelClick: [{
                type: Output
            }], saveClick: [{
                type: Output
            }], fields: [{
                type: Input
            }], model: [{
                type: Input
            }], busyState: [{
                type: Input
            }] } });

class StandardHeaderComponent {
}
StandardHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: StandardHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
StandardHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: StandardHeaderComponent, selector: "app-standard-header", ngImport: i0, template: "<div fxLayout=\"row\" fxLayoutAlign=\"center center\">\r\n    <div fxFlex=\"50%\">\r\n        <ng-content select=\"[leading-content]\"></ng-content>\r\n    </div>\r\n    <div fxFlex=\"50%\" align=\"right\">\r\n        <ng-content select=\"[trailing-content]\"></ng-content>\r\n    </div>\r\n</div>", styles: [""], dependencies: [{ kind: "directive", type: i2$1.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i2$1.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "directive", type: i2$1.DefaultFlexDirective, selector: "  [fxFlex], [fxFlex.xs], [fxFlex.sm], [fxFlex.md],  [fxFlex.lg], [fxFlex.xl], [fxFlex.lt-sm], [fxFlex.lt-md],  [fxFlex.lt-lg], [fxFlex.lt-xl], [fxFlex.gt-xs], [fxFlex.gt-sm],  [fxFlex.gt-md], [fxFlex.gt-lg]", inputs: ["fxFlex", "fxFlex.xs", "fxFlex.sm", "fxFlex.md", "fxFlex.lg", "fxFlex.xl", "fxFlex.lt-sm", "fxFlex.lt-md", "fxFlex.lt-lg", "fxFlex.lt-xl", "fxFlex.gt-xs", "fxFlex.gt-sm", "fxFlex.gt-md", "fxFlex.gt-lg"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: StandardHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-standard-header', template: "<div fxLayout=\"row\" fxLayoutAlign=\"center center\">\r\n    <div fxFlex=\"50%\">\r\n        <ng-content select=\"[leading-content]\"></ng-content>\r\n    </div>\r\n    <div fxFlex=\"50%\" align=\"right\">\r\n        <ng-content select=\"[trailing-content]\"></ng-content>\r\n    </div>\r\n</div>" }]
        }] });

/**
 * Accepts a value an attempts to resolve display name text from it.
 * The pipe accepts an input value as either a literal string or an object, and optionally a property name.
 * If the input value is a non-empty string, it will be be returned as the display text.
 * If the input value is an object, the pipe will attempt to resolve the display text from the property name.
 * If no expicit property name is passed to the pipe, then `'name'` is used.
 * If no display text can be resolved, then a placeholder is returned.
 */
class NamePlaceholderPipe {
    transform(value, propertyName) {
        const placeHolder = '...';
        if (typeof value === 'string') {
            value = TypeHelper.sanitizeString(value, placeHolder);
        }
        else if (value !== undefined) {
            value = value[propertyName === undefined ? 'name' : propertyName];
        }
        return value !== undefined ? value : placeHolder;
    }
}
NamePlaceholderPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: NamePlaceholderPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
NamePlaceholderPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.1.2", ngImport: i0, type: NamePlaceholderPipe, name: "namePlaceholder" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: NamePlaceholderPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'namePlaceholder'
                }]
        }] });

class StringFormatPipe {
    transform(value, ...args) {
        return FormatHelper.string(value, ...args);
    }
}
StringFormatPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: StringFormatPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
StringFormatPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.1.2", ngImport: i0, type: StringFormatPipe, name: "stringFormat" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: StringFormatPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'stringFormat'
                }]
        }] });

class StriphtmlPipe {
    transform(value, ...args) {
        return value && value.replace(/(<([^>]+)>)/gi, '');
    }
}
StriphtmlPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: StriphtmlPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
StriphtmlPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.1.2", ngImport: i0, type: StriphtmlPipe, name: "striphtml" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: StriphtmlPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'striphtml',
                }]
        }] });

var SnackbarStatusClasses;
(function (SnackbarStatusClasses) {
    SnackbarStatusClasses["default"] = "kup-snackbar";
    SnackbarStatusClasses["success"] = "kup-snackbar-success";
    SnackbarStatusClasses["warn"] = "kup-snackbar-warn";
    SnackbarStatusClasses["error"] = "kup-snackbar-error";
})(SnackbarStatusClasses || (SnackbarStatusClasses = {}));
const defaults = {
    duration: 4000,
    panelClass: [SnackbarStatusClasses.default],
};
class Logger {
    constructor(snackBar) {
        this.snackBar = snackBar;
    }
    success(value, action, onAction) {
        const options = Object.assign(Object.assign({}, defaults), { panelClass: [SnackbarStatusClasses.success] });
        const ref = this.snackBar.open(value, action || 'Success', options);
        ref.onAction().subscribe(() => {
            if (onAction) {
                onAction();
            }
        });
    }
    error(value, ...rest) {
        console.log(value, ...rest);
        const options = Object.assign(Object.assign({}, defaults), { panelClass: [SnackbarStatusClasses.error] });
        this.snackBar.open(value || 'An error occurred', 'See the console for more details', options);
    }
    warn(value, ...rest) {
        console.warn(value, ...rest);
        const options = Object.assign(Object.assign({}, defaults), { panelClass: [SnackbarStatusClasses.warn] });
        this.snackBar.open(value, 'Try Again', options);
    }
}
Logger.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: Logger, deps: [{ token: i1.MatSnackBar }], target: i0.ɵɵFactoryTarget.Injectable });
Logger.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: Logger });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: Logger, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.MatSnackBar }]; } });

const defaultKupIcons = [
    { name: 'biomaterial', file: 'biomaterial.svg' },
    { name: 'biomaterial_white', file: 'biomaterial_white.svg' },
    { name: 'cancel_white', file: 'cancel_white.svg' },
    { name: 'cancel_black', file: 'cancel_black.svg' },
    { name: 'clone_entity', file: 'clone_entity.svg' },
    { name: 'clone_entity_white', file: 'clone_entity_white.svg' },
    { name: 'complete_with_errors', file: 'complete_with_errors.svg' },
    { name: 'complete', file: 'complete.svg' },
    { name: 'delete', file: 'delete.svg' },
    { name: 'factors_child', file: 'factors_child.svg' },
    { name: 'factors_parent', file: 'factors_parent.svg' },
    { name: 'fatal_error', file: 'fatal_error.svg' },
    { name: 'file', file: 'file.svg' },
    { name: 'file_export', file: 'file_export.svg' },
    { name: 'file_export_white', file: 'file_export_white.svg' },
    { name: 'file_import', file: 'file_import.svg' },
    { name: 'genotypes', file: 'genotypes.svg' },
    { name: 'home', file: 'home.svg' },
    { name: 'logout', file: 'logout.svg' },
    { name: 'methods', file: 'methods.svg' },
    { name: 'factor_keywords', file: 'factor_keywords.svg' },
    { name: 'observations', file: 'observations.svg' },
    { name: 'processes', file: 'processes.svg' },
    { name: 'processing', file: 'processing.svg' },
    { name: 'reports', file: 'reports.svg' },
    { name: 'save_white', file: 'save_white.svg' },
    { name: 'save_black', file: 'save_black.svg' },
    { name: 'scales', file: 'scales.svg' },
    { name: 'seasons', file: 'seasons.svg' },
    { name: 'sites', file: 'sites.svg' },
    { name: 'tasks', file: 'tasks.svg' },
    { name: 'traits', file: 'traits.svg' },
    { name: 'trials', file: 'trials.svg' },
    { name: 'trials_white', file: 'trials_white.svg' },
    { name: 'user_preferences', file: 'user_preferences.svg' },
    { name: 'warning', file: 'warning.svg' },
    { name: 'observations_report', file: 'observations_report.svg' },
];

class KupIconsService {
    constructor(matIconRegistry, domSanitizer, config) {
        this.matIconRegistry = matIconRegistry;
        this.domSanitizer = domSanitizer;
        this.config = config;
        this.registerIcons();
    }
    registerIcons() {
        const customIcons = (this.config.icons || []).map((x) => typeof x === 'object' ? x : { name: x, file: `${x}.svg` });
        const defaultIcons = defaultKupIcons.map((x) => typeof x === 'object' ? x : { name: x, file: `${x}.svg` });
        // merge custom and default icons
        const iconsToRegister = Object.assign(Object.assign({}, defaultIcons.reduce((acc, x) => (Object.assign(Object.assign({}, acc), { [x.name]: x })), {})), customIcons.reduce((acc, x) => (Object.assign(Object.assign({}, acc), { [x.name]: x })), {}));
        // register icons
        const iconsDir = this.config.iconsDir || 'assets/icons';
        Object.values(iconsToRegister).forEach((icon) => {
            this.matIconRegistry.addSvgIcon(icon.name, this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconsDir}/${icon.file}`));
        });
    }
}
KupIconsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: KupIconsService, deps: [{ token: i3.MatIconRegistry }, { token: i2$6.DomSanitizer }, { token: KUP_CORE_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable });
KupIconsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: KupIconsService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: KupIconsService, decorators: [{
            type: Injectable
        }], ctorParameters: function () {
        return [{ type: i3.MatIconRegistry }, { type: i2$6.DomSanitizer }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [KUP_CORE_CONFIG]
                    }] }];
    } });

class FileHelperService {
    constructor() { }
    downloadCSVFromBlob(filename, blob) {
        if (this.isInternetExplorer()) {
            window.navigator.msSaveOrOpenBlob(blob, this.formatFilename(filename));
        }
        else {
            const url = window.URL.createObjectURL(blob);
            this.activateAnchor(url, this.formatFilename(filename));
        }
    }
    downloadJSONFromBlob(filename, blob) {
        if (this.isInternetExplorer()) {
            window.navigator.msSaveOrOpenBlob(blob, this.formatFilename(filename, 'json'));
        }
        else {
            const url = window.URL.createObjectURL(blob);
            this.activateAnchor(url, this.formatFilename(filename, 'json'));
        }
    }
    downloadCSVFromUrl(filename, url) {
        this.activateAnchor(url, filename);
    }
    activateAnchor(url, fileName) {
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = fileName;
        // Firefox requires the anchor element to be added to the document.
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
            // Removing the anchor element from the document too early can result in the download not being saved by Firefox.
            document.body.removeChild(a);
        }, 1000);
    }
    formatFilename(filename, fileType) {
        const downloadDate = moment().format('DD/MM/YYYY');
        return fileType
            ? `${filename}_${downloadDate}.${fileType}`
            : `${filename}_${downloadDate}.csv`;
    }
    isInternetExplorer() {
        return (window.navigator != undefined &&
            typeof window.navigator.msSaveOrOpenBlob === 'function');
    }
}
FileHelperService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: FileHelperService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
FileHelperService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: FileHelperService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: FileHelperService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });

class SimpleFormViewComponent {
    constructor() {
        // tslint:disable: variable-name
        this._readOnly = false;
        this._canSave = false;
        this._disableStateManager = false;
        this._model = {};
        this.inline = false;
        this.evalStateInterceptor = (resolver) => this.evalState(resolver);
    }
    get model() {
        return this._model;
    }
    set model(value) {
        if (value === undefined) {
            value = {};
        }
        this._model = value;
    }
    get readOnly() {
        return this._readOnly;
    }
    set readOnly(value) {
        value = value === true;
        if (value === this._readOnly) {
            return;
        }
        this._readOnly = value;
        this.applyReadOnly();
    }
    get hasChanges() {
        return this.form.dirty;
    }
    get isBusy() {
        return this.busyState.isBusy;
    }
    get isLoaded() {
        return this.busyState.loadingState === LoadingState.Loaded;
    }
    get canSave() {
        return this._canSave;
    }
    get activeFields() {
        if (this._activeFields === undefined) {
            this._activeFields =
                typeof this.fields === 'function' ? this.fields() : this.fields;
            if (this._activeFields !== undefined) {
                this._activeFields.forEach((f) => {
                    if (f.templateOptions.disabled === true) {
                        if (this._persistentReadOnly === undefined) {
                            this._persistentReadOnly = new KeySet();
                        }
                        const keyString = f.key;
                        this._persistentReadOnly.set(keyString);
                    }
                });
                if (this.readOnly) {
                    this.applyReadOnly();
                }
            }
        }
        return this._activeFields;
    }
    get controller() {
        return this._controller;
    }
    ngOnInit() {
        this.createController();
        if (this.busyState === undefined) {
            this.busyState = new ManualBusyState();
        }
        this.busyState.busyState$.subscribe(() => {
            this.updateCanSave();
        });
    }
    ngOnDestroy() {
        this.deleteManagedState();
    }
    applyReadOnly() {
        if (this._activeFields === undefined || this._activeFields.length === 0) {
            return;
        }
        this._activeFields.forEach((f) => {
            const keyString = f.key;
            f.templateOptions.disabled =
                this.readOnly ||
                    (this._persistentReadOnly &&
                        this._persistentReadOnly.containsKey(keyString));
        });
    }
    evalState(resolver) {
        if (resolver === undefined) {
            return undefined;
        }
        const f = this.deriveStateFlags();
        let result;
        if (typeof resolver === 'function') {
            result = resolver(f, this.model);
        }
        else {
            // tslint:disable-next-line: no-bitwise
            result = (f & resolver) !== StandardFormStateFlags.Never;
        }
        return result === true ? result : undefined;
    }
    createController() {
        if (this.validationKey === undefined) {
            throw new Error('No form validationKey has been assigned.');
        }
        const that = this;
        this._pristineKey = this.validationKey + '-pristine';
        this._controller = {
            get isValid() {
                return that.form.valid;
            },
            get isDirty() {
                return that.form.dirty;
            },
            get isPristine() {
                return that.form.pristine;
            },
            setValidState: (isValid) => {
                if (isValid) {
                    that.form.markAsPristine();
                }
                else {
                    that.form.markAsDirty();
                }
                this.updateCanSave();
            },
            resetValidState: () => {
                that.form.markAsPristine();
                that.updateCanSave();
            },
            setFormError: (controlName, errors, opts) => {
                that.lookupControl(controlName).setErrors(errors, opts);
                that.updateCanSave();
            },
            patchValue: (controlName, value) => {
                that.lookupControl(controlName).patchValue(value);
            },
        };
        this.form.statusChanges.subscribe(() => {
            that.updateCanSave();
        });
    }
    lookupControl(controlName) {
        const ctrl = this.form.controls[controlName];
        if (ctrl === undefined) {
            throw new Error(`[FormViewComponent] No form control named "${controlName}" exists.`);
        }
        return ctrl;
    }
    updateCanSave() {
        setTimeout(() => {
            this._canSave = !this.isBusy && this.form.dirty && this.form.valid;
        });
    }
    deriveStateFlags() {
        let f = StandardFormStateFlags.Never;
        if (this.form.dirty) {
            // tslint:disable-next-line: no-bitwise
            f |= StandardFormStateFlags.Dirty;
        }
        if (this.form.pristine) {
            // tslint:disable-next-line: no-bitwise
            f |= StandardFormStateFlags.Pristine;
        }
        if (this.form.invalid) {
            // tslint:disable-next-line: no-bitwise
            f |= StandardFormStateFlags.Invalid;
        }
        if (this.isBusy) {
            // tslint:disable-next-line: no-bitwise
            f |= StandardFormStateFlags.Busy;
        }
        if (this.busyState.loadingState !== LoadingState.Loaded) {
            // tslint:disable-next-line: no-bitwise
            f |= StandardFormStateFlags.Loading;
        }
        return f;
    }
    deleteManagedState() { }
}
SimpleFormViewComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: SimpleFormViewComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SimpleFormViewComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: SimpleFormViewComponent, selector: "app-simple-form-view", inputs: { inline: "inline", validationKey: "validationKey", busyState: "busyState", fields: "fields", form: "form", model: "model", readOnly: "readOnly" }, ngImport: i0, template: "<form [formGroup]=\"form\" *ngIf=\"isLoaded\">\n  <formly-form\n    *ngIf=\"!inline\"\n    [form]=\"form\"\n    [fields]=\"activeFields\"\n    [model]=\"model\"\n  ></formly-form>\n  <ng-content select=\"[bottom-content]\"></ng-content>\n</form>\n", styles: [".bottom-button-panel{margin-top:15px}\n"], dependencies: [{ kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$3.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i1$6.FormlyForm, selector: "formly-form", inputs: ["model", "fields", "options", "form"], outputs: ["modelChange"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: SimpleFormViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-simple-form-view', template: "<form [formGroup]=\"form\" *ngIf=\"isLoaded\">\n  <formly-form\n    *ngIf=\"!inline\"\n    [form]=\"form\"\n    [fields]=\"activeFields\"\n    [model]=\"model\"\n  ></formly-form>\n  <ng-content select=\"[bottom-content]\"></ng-content>\n</form>\n", styles: [".bottom-button-panel{margin-top:15px}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { inline: [{
                type: Input
            }], validationKey: [{
                type: Input
            }], busyState: [{
                type: Input
            }], fields: [{
                type: Input
            }], form: [{
                type: Input
            }], model: [{
                type: Input
            }], readOnly: [{
                type: Input
            }] } });

class SimpleStandardFormComponent {
    constructor() {
        /**
         * Declares any non-default top buttons that the form should render.
         */
        this.topButtons = [];
        /**
         * Determines whether or not the form is rendered in inline mode. The default value is `false`.
         */
        this.inline = false;
        /**
         * Determines whether or not the form is in read-only mode. The default value is `false`.
         */
        this.readOnly = false;
        /**
         * Determines whether or not the form is in create mode. The default value is `true`.
         */
        this.createMode = false;
        /**
         * Determines whether or not a save button will be displayed. The default value is `true`.
         */
        this.canSave = true;
        /**
         * Determines whether or not a cancel button will be displayed. The default value is `true`.
         */
        this.canCancel = true;
        /**
         * When set to `true`, causes the `StandardFormComponent` to exclude its form state from the `GlobalStateManager` form state dictionary.
         * This prevents this instance's form state from being detected by components descending from `AutoCanDeactivate`,
         * the consequence of which is that its state will not be detected by `DiscardChangesGuard`.
         *
         * @todo: modular components currently cannot support a global state in the way it has been designed,
         * so we will need to manually handle form state until this can e refactored
         */
        this.disableStateManager = false;
        /**
         * The event which is raised when a user-initiated standard action occurs.
         */
        this.standardAction = new EventEmitter();
        /**
         * The event which is raised when a user clicks a cancel button.
         */
        this.cancelClick = new EventEmitter();
        /**
         * The event which is raised when a user clicks a save button.
         */
        this.saveClick = new EventEmitter();
        /**
         * Used internally by the component.
         */
        this.clickInterceptor = (b) => this.onButtonClick(b);
    }
    /**
     * The `FormlyFieldConfig` items which define the form.
     * These may be assigned either as an array of type `FormlyFieldConfig`, or
     * (if construction needs to be delayed until the OnInit lifecycle event) as a function that returns
     * an an array of type `FormlyFieldConfig`.
     */
    get fields() {
        return this.formView.fields;
    }
    set fields(value) {
        this.formView.fields = value;
    }
    get form() {
        return this.formView.form;
    }
    set form(value) {
        this.formView.form = value;
    }
    /**
     * The model that the form is bound to.
     */
    get model() {
        return this.formView.model;
    }
    set model(value) {
        this.formView.model = value;
    }
    /**
     * The `BusyStateProvider` implementation that this instance interacts with.
     */
    get busyState() {
        return this.formView.busyState;
    }
    set busyState(value) {
        this.formView.busyState = value;
    }
    /**
     * Returns `true` if this instance's `BusyStateProvider` is in the busy state, otherwise returns `false`.
     */
    get isBusy() {
        return this.busyState.isBusy;
    }
    /**
     * Used internally by the component.
     */
    onSaveClick() {
        this.saveClick.emit(new StandardFormEventArgs(this.formView.controller, this.model));
        this.onActionEvent(this.createMode ? FormActionEventType.Create : FormActionEventType.Update);
    }
    /**
     * Used internally by the component.
     */
    onCancelClick() {
        this.cancelClick.emit(new StandardFormEventArgs(this.formView.controller, this.model));
        this.onActionEvent(FormActionEventType.Cancel);
    }
    /**
     * Used internally by the component.
     */
    onButtonClick(b) {
        if (b.click !== undefined) {
            b.click(new StandardFormEventArgs(this.formView.controller, this.model));
        }
    }
    onActionEvent(eventType) {
        this.standardAction.emit(new StandardFormActionEventArgs(this.formView.controller, this.model, eventType));
    }
}
SimpleStandardFormComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: SimpleStandardFormComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SimpleStandardFormComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: SimpleStandardFormComponent, selector: "app-simple-standard-form", inputs: { viewTitle: "viewTitle", subTitle: "subTitle", topButtons: "topButtons", inline: "inline", readOnly: "readOnly", createMode: "createMode", canSave: "canSave", canCancel: "canCancel", disableStateManager: "disableStateManager", createButtonText: "createButtonText", fields: "fields", form: "form", model: "model", busyState: "busyState" }, outputs: { standardAction: "standardAction", cancelClick: "cancelClick", saveClick: "saveClick" }, viewQueries: [{ propertyName: "formView", first: true, predicate: ["formView"], descendants: true, static: true }], ngImport: i0, template: "<div class=\"nested-content\">\n  <ng-content select=\"[above-form]\"></ng-content>\n  <app-simple-form-view\n    #formView\n    validationKey=\"default\"\n    [inline]=\"inline\"\n    [readOnly]=\"readOnly\"\n    [fields]=\"fields\"\n    [busyState]=\"busyState\"\n    [model]=\"model\"\n    [form]=\"form\"\n  >\n  </app-simple-form-view>\n  <ng-content select=\"[below-form]\"></ng-content>\n</div>\n", styles: [".standard-form-view .nested-content .view-title{font-size:18px}.standard-form-view .bottom-button-panel{margin-top:15px}\n"], dependencies: [{ kind: "component", type: SimpleFormViewComponent, selector: "app-simple-form-view", inputs: ["inline", "validationKey", "busyState", "fields", "form", "model", "readOnly"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: SimpleStandardFormComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-simple-standard-form', encapsulation: ViewEncapsulation.None, template: "<div class=\"nested-content\">\n  <ng-content select=\"[above-form]\"></ng-content>\n  <app-simple-form-view\n    #formView\n    validationKey=\"default\"\n    [inline]=\"inline\"\n    [readOnly]=\"readOnly\"\n    [fields]=\"fields\"\n    [busyState]=\"busyState\"\n    [model]=\"model\"\n    [form]=\"form\"\n  >\n  </app-simple-form-view>\n  <ng-content select=\"[below-form]\"></ng-content>\n</div>\n", styles: [".standard-form-view .nested-content .view-title{font-size:18px}.standard-form-view .bottom-button-panel{margin-top:15px}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { formView: [{
                type: ViewChild,
                args: ['formView', { static: true }]
            }], viewTitle: [{
                type: Input
            }], subTitle: [{
                type: Input
            }], topButtons: [{
                type: Input
            }], inline: [{
                type: Input
            }], readOnly: [{
                type: Input
            }], createMode: [{
                type: Input
            }], canSave: [{
                type: Input
            }], canCancel: [{
                type: Input
            }], disableStateManager: [{
                type: Input
            }], createButtonText: [{
                type: Input
            }], standardAction: [{
                type: Output
            }], cancelClick: [{
                type: Output
            }], saveClick: [{
                type: Output
            }], fields: [{
                type: Input
            }], form: [{
                type: Input
            }], model: [{
                type: Input
            }], busyState: [{
                type: Input
            }] } });

/**
 * Represents a datasource for a `DropdownProvider`.
 */
// @dynamic
class DropdownDatasource {
    /**
     * Converts an input array to a `DropdownItem` array using the specified fields.
     */
    static fieldMap(src, labelField, valueField) {
        if (src == undefined) {
            throw new Error(ExceptionMessageFormatter.argumentNull('src'));
        }
        if (labelField == undefined) {
            throw new Error(ExceptionMessageFormatter.argumentNull('labelField'));
        }
        if (valueField == undefined) {
            valueField = labelField;
        }
        return src.map(fieldMapFunction(labelField, valueField));
    }
    /**
     * Asynchronously maps an array which is the subject of an `Observable` to a `DropdownItem` array using the specified fields.
     */
    static fieldMapAsync(src, labelField, valueField) {
        if (src == undefined) {
            throw new Error(ExceptionMessageFormatter.argumentNull('src'));
        }
        if (labelField == undefined) {
            throw new Error(ExceptionMessageFormatter.argumentNull('labelField'));
        }
        if (valueField == undefined) {
            valueField = labelField;
        }
        return src.pipe(map((input) => input.map(fieldMapFunction(labelField, valueField))));
    }
    /**
     * Maps an object to a `DropdownItem` array by treating it as a key/value collection.
     */
    static keymap(src, mode = 'key') {
        if (src == undefined) {
            throw new Error(ExceptionMessageFormatter.argumentNull('src'));
        }
        return keymapFunction(src, mode);
    }
    /**
     * Asynchronously maps the subject of an `Observable` to a `DropdownItem` array by treating it as a key/value collection.
     */
    static keymapAsync(src, mode = 'key') {
        if (src == undefined) {
            throw new Error(ExceptionMessageFormatter.argumentNull('src'));
        }
        return src.pipe(map((input) => keymapFunction(input, mode)));
    }
    /**
     * Converts an input array to a `DropdownItem` array using one of the pre-defined `DropdownAutomap` functions.
     */
    static automap(src, automap) {
        if (src == undefined) {
            throw new Error(ExceptionMessageFormatter.argumentNull('src'));
        }
        if (automap == undefined) {
            throw new Error(ExceptionMessageFormatter.argumentNull('automap'));
        }
        return src.map(resolveMapFn(automap));
    }
    /**
     * Asynchronously maps an array which is the subject of an `Observable` to a  `DropdownItem`
     * array using one of the pre-defined `DropdownAutomap` functions.
     */
    static automapAsync(src, automap) {
        if (src == undefined) {
            throw new Error(ExceptionMessageFormatter.argumentNull('src'));
        }
        if (automap == undefined) {
            throw new Error(ExceptionMessageFormatter.argumentNull('automap'));
        }
        return src.pipe(map((input) => input.map(resolveMapFn(automap))));
    }
    /**
     * Converts an input item to a `DropdownItem` item using one of the pre-defined `DropdownAutomap` functions.
     */
    static automapItem(src, automap) {
        if (src == undefined) {
            throw new Error(ExceptionMessageFormatter.argumentNull('src'));
        }
        if (automap == undefined) {
            throw new Error(ExceptionMessageFormatter.argumentNull('automap'));
        }
        return resolveMapFn(automap)(src);
    }
    /**
     * Resolves the `DropdownMapFunction` for the specified `DropdownAutomap`.
     */
    static getAutomapFunction(automap) {
        return resolveMapFn(automap);
    }
    /**
     * Creates a `DropdownDatasource` that maintains a fixed internal `DropdownItem` collection.
     * Any filtering is performed on the static internal collection.
     */
    static createStatic(src, options) {
        if (src == undefined) {
            throw new Error(ExceptionMessageFormatter.argumentNull('src'));
        }
        return new SimpleDropdownDatasource(staticQueryFn(src, options));
    }
    /**
     * Creates a `DropdownDatasource` that maintains a fixed internal `DropdownItem` collection which is
     * derived by converting an input entity array to an array of `DropDownItem` using the specified map function.
     * Any filtering is performed on the static internal collection.
     */
    static createMapStatic(src, mapFn, options) {
        if (src == undefined) {
            throw new Error(ExceptionMessageFormatter.argumentNull('src'));
        }
        const mFn = resolveMapFn(mapFn);
        if (Array.isArray(src)) {
            return new SimpleDropdownDatasource(staticQueryFn(src.map(mFn), options));
        }
        return new SimpleDropdownDatasource(staticQueryFn(reduceSrc(src, mFn), options));
    }
    /**
     * Creates a `DropdownDatasource` that utilises a query function to manage a dynamic `DropdownItem` collection which is
     * derived by converting the query result to an array of `DropDownItem` using the specified map function.
     * Filtering is performed on the remote dataset by the query function.
     */
    static createMapDynamic(query, mapFn) {
        if (query == undefined) {
            throw new Error(ExceptionMessageFormatter.argumentNull('query'));
        }
        const mFn = resolveMapFn(mapFn);
        const fn = (filter) => {
            return new Promise((resolve, reject) => {
                Disposables.global.subscribeReplayOnce(reduceSrc(query(filter), mFn), (items) => {
                    resolve(items);
                }, (error) => {
                    reject(error);
                });
            });
        };
        return new SimpleDropdownDatasource(fn);
    }
}
class SimpleDropdownDatasource extends DropdownDatasource {
    constructor(queryFn) {
        super();
        this.queryFn = queryFn;
        if (queryFn == undefined) {
            throw new Error(ExceptionMessageFormatter.argumentNull('queryFn'));
        }
    }
}
function reduceSrc(src, mapFn) {
    return src.pipe(map((result) => {
        if (Array.isArray(result))
            return result.map(mapFn);
        if (result.isOk)
            return result.result.map(mapFn);
        throw result.errorFrom();
    }));
}
function staticQueryFn(src, options) {
    if (src == undefined) {
        throw new Error(ExceptionMessageFormatter.argumentNull('src'));
    }
    const fn = Array.isArray(src)
        ? (filter = undefined) => {
            return filterFunction(src, filter);
        }
        : (filter) => __awaiter(this, void 0, void 0, function* () {
            const promise = new Promise((resolve, reject) => {
                try {
                    Disposables.global.subscribeReplayOnce(src, (items) => {
                        applyOptions(items, options);
                        resolve(items);
                    });
                }
                catch (e) {
                    reject(e);
                }
            });
            const items = yield promise;
            return yield filterFunction(items, filter);
        });
    return fn;
}
function filterFunction(src, filter = 'undefined') {
    return Promise.resolve(src.filter((item) => item.label.indexOf(filter) >= 0));
}
function resolveMapFn(mapFn) {
    if (typeof mapFn === 'function')
        return mapFn;
    if (typeof mapFn !== 'string') {
        throw new Error(ExceptionMessageFormatter.argument('mapFn'));
    }
    switch (mapFn) {
        case 'uuid':
            return (item) => ({ value: item.uuid, label: item.name });
        case 'name':
            return (item) => ({ value: item.name, label: item.name });
        case 'string':
            return (item) => {
                if (item == undefined) {
                    item = '';
                }
                else if (typeof item === 'object' && item.toString) {
                    item = item.toString();
                }
                return { value: item, label: item };
            };
        case 'name|*':
            return (item) => {
                if (item == undefined) {
                    item = '';
                }
                else {
                    const idx = item.lastIndexOf('|');
                    if (idx >= 0) {
                        item = item.substr(0, idx);
                    }
                }
                return { value: item, label: item };
            };
        case 'name|uuid':
            return (item) => {
                let value = '';
                let label = '';
                if (item != undefined) {
                    const idx = item.lastIndexOf('|');
                    if (idx >= 0) {
                        label = item.substr(0, idx);
                        value = item.substr(idx + 1, item.length);
                    }
                }
                return { value: value, label: label };
            };
        case 'name|string':
            return (item) => {
                if (!item || typeof item !== 'string')
                    return {
                        value: '',
                        label: '',
                    };
                const [label = ''] = item.split('|');
                return { label, value: item };
            };
        case 'link':
            return (item) => ({
                value: item._links.self.href,
                label: item.name,
            });
        default:
            throw new Error(ExceptionMessageFormatter.argument('mapFn'));
    }
}
function applyOptions(items, options) {
    if (options != undefined && options.addEmpty === true) {
        items.unshift({
            label: options.emptyLabel ? options.emptyLabel : 'None',
            value: options.emptyValue,
        });
    }
}
function keymapFunction(src, mode) {
    const result = [];
    Object.keys(src).forEach((key) => {
        const value = src[key];
        const hasValue = !TypeHelper.isStringNullOrEmpty(value);
        if (!hasValue && mode === 'skip')
            return;
        result.push({
            value: key,
            label: hasValue ? value : key,
        });
    });
    return result;
}
function fieldMapFunction(labelField, valueField) {
    return (src) => {
        const r = { value: src[valueField], label: src[labelField] };
        return r;
    };
}

/**
 * A convenience class that exposes the result of an asynchronous operation as an Observable.
 * Only the most recently initiated operation will cause the observable to emit.
 */
class ObservableOperation {
    /**
     *
     * @param queryFn The query function to be performed whenever the refresh method is invoked.
     * @param initialState The initial state of the Observable.
     */
    constructor(queryFn, initialState) {
        this._version = 0;
        this._datasource =
            typeof queryFn === 'function' ? { queryFn: queryFn } : queryFn;
        this._subject = new BehaviorSubject(initialState);
        this.data$ = this._subject.asObservable();
    }
    /**
     * Initiates a new query and raises the Observable event if the result is not stale (a result is stale if the originating query completes
     * after one or more subsequent queries have completed).
     * Returns an asynchronous result of true if the query completes without becoming stale, otherwise returns a result of false.
     * @param args The arguments to pass to the query function.
     */
    refresh(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const current = ++this._version;
            const result = yield this._datasource.queryFn(args);
            const isFresh = this._version === current;
            if (isFresh) {
                this.onBeforeEmit(result);
                this._subject.next(result);
            }
            return Promise.resolve(isFresh);
        });
    }
    get data() {
        return this._subject.value;
    }
    /**
     * Invoked by the refresh method after a fresh query result has been received but before the Observable event is raised.
     * @param _data The query result data.
     */
    onBeforeEmit(_data) { }
}

class DropdownProvider extends ObservableOperation {
    /**
     *
     * @param dataSource The query function to be performed whenever the refresh method is invoked.
     * @param initialState The initial state of the Observable.
     */
    constructor(dataSource) {
        super(typeof dataSource === 'function' ? dataSource : dataSource.queryFn, []);
    }
    /**
     * Creates a `DropdownProvider` instance from a `DropdownInput`
     * (or uses the passed-in instance if `src` is already a `DropdownProvider`),
     * and (unless explictly suppressed) invokes its `refresh` method.
     * @param src
     */
    static resolve(src, options) {
        if (Array.isArray(src)) {
            src = new DropdownProvider(DropdownDatasource.createStatic(src));
        }
        else if (isObservable(src)) {
            // src = createFromOptions(src, options);
            src = new DropdownProvider(DropdownDatasource.createStatic(src));
        }
        else if (!(src instanceof DropdownProvider)) {
            if (src instanceof DropdownDatasource ||
                typeof src.queryFn === 'function') {
                src = new DropdownProvider(src);
            }
            else {
                throw new Error(ExceptionMessageFormatter.argument('src'));
            }
        }
        if (!(options != undefined && options.suppressRefresh)) {
            src.refresh('');
        }
        return src;
    }
}

class PrinterDropdownProvider extends DropdownProvider {
    constructor(service) {
        super(DropdownDatasource.createMapDynamic(() => {
            const params = `size=${defaultExportPageSize}`;
            const obs = service
                .apiService({
                action: 'GETLIST',
                endpoint: 'printers',
            }, null, null, `?${params}`)
                .pipe(map((res) => res.result._embedded.printers));
            return obs;
        }, 'uuid'));
    }
}

class LabelTemplateDropdownProvider extends DropdownProvider {
    constructor(service) {
        super(DropdownDatasource.createMapDynamic(() => {
            const params = `size=${defaultExportPageSize}`;
            const obs = service
                .apiService({
                action: 'GETLIST',
                endpoint: 'labelTemplates',
            }, null, null, `?${params}`)
                .pipe(map((res) => res.result._embedded.labelTemplates));
            return obs;
        }, 'uuid'));
    }
}

class PrintLabelsModalComponent {
    constructor(dialogRef, data, printService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.printService = printService;
        this.model = {};
        this.options = {};
        this.form = new FormGroup({});
    }
    ngOnInit() {
        if (this.data.preSelectedField) {
            this.model[this.data.preSelectedField] = this.data.id;
        }
        const printers = new PrinterDropdownProvider(this.printService);
        const templates = new LabelTemplateDropdownProvider(this.printService);
        this.fields = [
            {
                key: 'labelTemplateId',
                id: 'field_template_id',
                type: 'ng-select',
                templateOptions: {
                    label: 'Template',
                    required: true,
                    options: DropdownProvider.resolve(templates, {
                        suppressRefresh: false,
                    }).data$,
                },
            },
            {
                key: 'printerId',
                id: 'filter_printer_id',
                type: 'ng-select',
                templateOptions: {
                    label: 'Select Printer',
                    required: true,
                    options: DropdownProvider.resolve(printers, {
                        suppressRefresh: false,
                    }).data$,
                },
            },
        ];
        this.data.fields.forEach((field) => {
            this.fields.unshift(field);
        });
    }
    onClose(model) {
        this.dialogRef.close(model);
    }
}
PrintLabelsModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: PrintLabelsModalComponent, deps: [{ token: i1$5.MatDialogRef }, { token: MAT_DIALOG_DATA }, { token: PapiService }], target: i0.ɵɵFactoryTarget.Component });
PrintLabelsModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: PrintLabelsModalComponent, selector: "app-print-labels-modal", ngImport: i0, template: "<h1 mat-dialog-title>Print Labels</h1>\n\n<div mat-dialog-content>\n  <formly-form [form]=\"form\" [fields]=\"fields\" [options]=\"options\" [model]=\"model\"></formly-form>\n</div>\n<div mat-dialog-actions>\n  <button mat-button mat-raised-button color=\"warn\" (click)=\"onClose(null)\">Cancel</button>\n  <button type=\"submit\" class=\"btn-ok\" (click)=\"onClose(model)\" mat-raised-button color=\"primary\"\n    [disabled]=\"form.invalid\">Ok</button>\n</div>", styles: [".btn-ok{margin-left:auto!important}\n"], dependencies: [{ kind: "component", type: i2.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i1$5.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1$5.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i1$5.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "component", type: i1$6.FormlyForm, selector: "formly-form", inputs: ["model", "fields", "options", "form"], outputs: ["modelChange"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: PrintLabelsModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-print-labels-modal', template: "<h1 mat-dialog-title>Print Labels</h1>\n\n<div mat-dialog-content>\n  <formly-form [form]=\"form\" [fields]=\"fields\" [options]=\"options\" [model]=\"model\"></formly-form>\n</div>\n<div mat-dialog-actions>\n  <button mat-button mat-raised-button color=\"warn\" (click)=\"onClose(null)\">Cancel</button>\n  <button type=\"submit\" class=\"btn-ok\" (click)=\"onClose(model)\" mat-raised-button color=\"primary\"\n    [disabled]=\"form.invalid\">Ok</button>\n</div>", styles: [".btn-ok{margin-left:auto!important}\n"] }]
        }], ctorParameters: function () {
        return [{ type: i1$5.MatDialogRef }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [MAT_DIALOG_DATA]
                    }] }, { type: PapiService }];
    } });

/**
 *  NPM kup dependancies
 */
class KupCoreModule {
    constructor(iconsService) {
        this.iconsService = iconsService;
        this.iconsService.registerIcons();
    }
    static forRoot(options) {
        return {
            ngModule: KupCoreModule,
            providers: [
                {
                    provide: KUP_CORE_CONFIG,
                    useFactory: options.useFactory,
                    deps: options.deps,
                },
            ],
        };
    }
}
KupCoreModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: KupCoreModule, deps: [{ token: KupIconsService }], target: i0.ɵɵFactoryTarget.NgModule });
KupCoreModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.2", ngImport: i0, type: KupCoreModule, declarations: [BusyStateWrapperComponent,
        ButtonGroupComponent,
        // FormlyFormFlexLayoutComponent,
        FormViewComponent,
        StandardHeaderComponent,
        StandardViewComponent,
        StandardFormComponent,
        SimpleStandardFormComponent,
        AppTextPipe,
        NamePlaceholderPipe,
        StringFormatPipe,
        StriphtmlPipe,
        // SimpleTableComponent,
        DialogComponent,
        SimpleFormViewComponent,
        PrintLabelsModalComponent], imports: [MaterialModule,
        CommonModule,
        DragDropModule,
        AppFormlyModule,
        SweetAlert2Module,
        KupAuthModule], exports: [CommonModule,
        DragDropModule,
        FormViewComponent,
        StandardHeaderComponent,
        StandardViewComponent,
        StandardFormComponent,
        SimpleStandardFormComponent,
        BusyStateWrapperComponent,
        ButtonGroupComponent,
        // FormlyFormFlexLayoutComponent,
        AppTextPipe,
        NamePlaceholderPipe,
        StringFormatPipe,
        StriphtmlPipe,
        MaterialModule,
        AppFormlyModule,
        // SimpleTableComponent,
        DialogComponent,
        PrintLabelsModalComponent] });
KupCoreModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: KupCoreModule, providers: [
        Logger,
        MigrationHelper,
        KupSnackBarService,
        DialogService,
        KupIconsService,
        FileHelperService,
    ], imports: [MaterialModule,
        CommonModule,
        DragDropModule,
        AppFormlyModule,
        SweetAlert2Module,
        KupAuthModule, CommonModule,
        DragDropModule,
        MaterialModule,
        AppFormlyModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: KupCoreModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        BusyStateWrapperComponent,
                        ButtonGroupComponent,
                        // FormlyFormFlexLayoutComponent,
                        FormViewComponent,
                        StandardHeaderComponent,
                        StandardViewComponent,
                        StandardFormComponent,
                        SimpleStandardFormComponent,
                        AppTextPipe,
                        NamePlaceholderPipe,
                        StringFormatPipe,
                        StriphtmlPipe,
                        // SimpleTableComponent,
                        DialogComponent,
                        SimpleFormViewComponent,
                        PrintLabelsModalComponent,
                    ],
                    entryComponents: [DialogComponent, PrintLabelsModalComponent],
                    imports: [
                        MaterialModule,
                        CommonModule,
                        DragDropModule,
                        AppFormlyModule,
                        SweetAlert2Module,
                        KupAuthModule,
                    ],
                    exports: [
                        CommonModule,
                        DragDropModule,
                        FormViewComponent,
                        StandardHeaderComponent,
                        StandardViewComponent,
                        StandardFormComponent,
                        SimpleStandardFormComponent,
                        BusyStateWrapperComponent,
                        ButtonGroupComponent,
                        // FormlyFormFlexLayoutComponent,
                        AppTextPipe,
                        NamePlaceholderPipe,
                        StringFormatPipe,
                        StriphtmlPipe,
                        MaterialModule,
                        AppFormlyModule,
                        // SimpleTableComponent,
                        DialogComponent,
                        PrintLabelsModalComponent,
                    ],
                    providers: [
                        Logger,
                        MigrationHelper,
                        KupSnackBarService,
                        DialogService,
                        KupIconsService,
                        FileHelperService,
                    ],
                }]
        }], ctorParameters: function () { return [{ type: KupIconsService }]; } });

class ConfigProvider {
    constructor() {
        this.config = {};
    }
    setConfig(newConfig) {
        this.config = newConfig;
        return this.config;
    }
    getConfig() {
        return this.config;
    }
}
ConfigProvider.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ConfigProvider, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ConfigProvider.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ConfigProvider });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ConfigProvider, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });

/**
 * Intended to lookup a text resource
 */
var EntityTypeKey;
(function (EntityTypeKey) {
    EntityTypeKey["GenericData"] = "entity-type.generic-data";
    EntityTypeKey["BiomaterialCollection"] = "entity-type.biomaterial-collection";
    EntityTypeKey["Cane"] = "entity-type.cane";
    EntityTypeKey["Plant"] = "entity-type.plant";
    EntityTypeKey["Fruit"] = "entity-type.fruit";
    EntityTypeKey["Scion"] = "entity-type.scion";
    EntityTypeKey["Sample"] = "entity-type.sample";
    EntityTypeKey["ObservationValue"] = "entity-type.observation-value";
    EntityTypeKey["Trial"] = "entity-type.trial";
    EntityTypeKey["TrialPermission"] = "entity-type.trial-permission";
    EntityTypeKey["TrialSeason"] = "entity-type.trial-season";
    EntityTypeKey["TrialTask"] = "entity-type.trial-task";
    EntityTypeKey["TrialNote"] = "entity-type.trial-note";
    EntityTypeKey["TrialObservation"] = "entity-type.trial-observation";
    EntityTypeKey["Genotype"] = "entity-type.genotype";
    EntityTypeKey["GenotypeLabelAssignment"] = "entity-type.genotype-label-assignment";
    EntityTypeKey["Site"] = "entity-type.site";
    EntityTypeKey["Season"] = "entity-type.season";
    EntityTypeKey["Scale"] = "entity-type.scale";
    EntityTypeKey["Process"] = "entity-type.process";
    EntityTypeKey["FactorKeyword"] = "entity-type.factor-keyword";
    EntityTypeKey["Trait"] = "entity-type.trait";
    EntityTypeKey["Factor"] = "entity-type.factor";
    EntityTypeKey["ImportType"] = "entity-type.import-type";
    EntityTypeKey["Import"] = "entity-type.import";
    EntityTypeKey["Method"] = "entity-type.method";
    EntityTypeKey["TrialTreatment"] = "entity-type.treatment";
    EntityTypeKey["UserPreferences"] = "entity-type.user-prefs";
    EntityTypeKey["OperationsPlan"] = "entity-type.operations-plan";
    EntityTypeKey["OperationsPlanTask"] = "entity-type.operations-plan-task";
    EntityTypeKey["OperationsPlanTrialAssociation"] = "entity-type.operations-plan-trial-assoc";
    EntityTypeKey["TaskObservation"] = "entity-type.task-observation";
    EntityTypeKey["SeasonOperationsPlan"] = "entity-type.season-operations-plan";
    EntityTypeKey["User"] = "entity-type.user";
    EntityTypeKey["UserData"] = "entity-type.user-data";
    EntityTypeKey["UserGroup"] = "entity-type.user-group";
    EntityTypeKey["QueryFilter"] = "entity-type.query-filter";
    EntityTypeKey["RemoteProcess"] = "entity-type.remote-proc";
    EntityTypeKey["Task"] = "entity-type.task";
    EntityTypeKey["Observation"] = "entity-type.observation";
    EntityTypeKey["Tag"] = "entity-type.tag";
    EntityTypeKey["RequestBiomaterial"] = "entity-type.request-biomaterial";
    EntityTypeKey["Batch"] = "entity-type.batch";
    EntityTypeKey["Programme"] = "entity-type.programme";
})(EntityTypeKey || (EntityTypeKey = {}));

var FilterFieldFlags;
(function (FilterFieldFlags) {
    FilterFieldFlags[FilterFieldFlags["None"] = 0] = "None";
    /**
     * Indicates that the field supports multiple values.
     */
    FilterFieldFlags[FilterFieldFlags["MultiValue"] = 1] = "MultiValue";
})(FilterFieldFlags || (FilterFieldFlags = {}));
class FilterField {
    constructor(key, path, options) {
        this.key = key;
        this.path = path;
        if (options) {
            this.flags = options.flags;
            this.defaultValue = options.defaultValue;
            this.isStickyDefault = options.stickyDefault;
            this.selectorGroup = options.selectorGroup;
        }
    }
    static create(key, flags, defaultValue) {
        return new FilterField(key, key.split('.'), {
            flags: flags,
            defaultValue: defaultValue,
        });
    }
    static createWithOptions(key, options) {
        return new FilterField(key, key.split('.'), options);
    }
    get multiValue() {
        return (
        // tslint:disable-next-line: no-bitwise
        (this.flags & FilterFieldFlags.MultiValue) === FilterFieldFlags.MultiValue);
    }
}

var FilterFieldName;
(function (FilterFieldName) {
    FilterFieldName["Site"] = "location.siteName";
    FilterFieldName["SiteCode"] = "location.siteCode";
    FilterFieldName["SiteId"] = "location.siteId";
    FilterFieldName["Block"] = "location.block";
    FilterFieldName["Row"] = "location.row";
    FilterFieldName["Location"] = "location.name";
    FilterFieldName["CreationMethod"] = "creationMethod.name";
    FilterFieldName["Collection"] = "collection.name";
    FilterFieldName["CollectionId"] = "collection.id";
    FilterFieldName["CaneWoodType"] = "cane.woodType";
    FilterFieldName["CaneActiveStatus"] = "cane.activeStatus";
    FilterFieldName["CaneName"] = "cane.name";
    FilterFieldName["CaneGenotypeId"] = "scion.genotypeId";
    FilterFieldName["CaneGenotypeLabel"] = "scion.genotypeLabel";
    FilterFieldName["CaneSex"] = "scion.genotypeSex";
    FilterFieldName["FruitName"] = "fruit.name";
    FilterFieldName["FruitActiveStatus"] = "fruit.activeStatus";
    FilterFieldName["FruitGenotypeLabel"] = "fruit.genotypeLabel";
    FilterFieldName["FruitGenotypeId"] = "fruit.genotypeId";
    FilterFieldName["FruitSex"] = "fruit.genotypeSex";
    FilterFieldName["ScionSex"] = "scion.genotypeSex";
    FilterFieldName["ScionGenotype"] = "scion.genotypeName";
    FilterFieldName["ScionGenotypeId"] = "scion.genotypeId";
    FilterFieldName["ScionGenotypeLabel"] = "scion.genotypeLabel";
    FilterFieldName["ScionActiveStatus"] = "scion.activeStatus";
    FilterFieldName["ScionName"] = "scion.name";
    FilterFieldName["ScionGraftYear"] = "scion.startYear";
    FilterFieldName["PlantSex"] = "plant.genotypeSex";
    FilterFieldName["PlantGenotype"] = "plant.genotypeName";
    FilterFieldName["PlantGenotypeId"] = "plant.genotypeId";
    FilterFieldName["PlantGenotypeLabel"] = "plant.genotypeLabel";
    FilterFieldName["PlantActiveStatus"] = "plant.activeStatus";
    FilterFieldName["PlantName"] = "plant.name";
    FilterFieldName["PlantActiveScionCount"] = "plant.activeScionCount";
    FilterFieldName["TrialName"] = "trial.name";
    FilterFieldName["TrialSite"] = "trial.siteId";
    FilterFieldName["TrialContact"] = "trial.contact";
    FilterFieldName["TrialActiveStatus"] = "trial.activeStatus";
    FilterFieldName["TrialPermission"] = "permissionType";
    FilterFieldName["GenotypeName"] = "genotype.name";
    FilterFieldName["GenotypeSex"] = "genotype.sex";
    FilterFieldName["GenotypeLabel"] = "genotype.label";
    FilterFieldName["GenotypePloidy"] = "genotype.ploidy";
    FilterFieldName["TaxonName"] = "taxon.name";
    FilterFieldName["GenotypeCreationMethod"] = "creationMethod.name";
    FilterFieldName["BiomaterialName"] = "biomaterialName";
    FilterFieldName["Biomaterial"] = "biomaterial.name";
    FilterFieldName["Trial"] = "trialName";
    FilterFieldName["Trait"] = "traitName";
    FilterFieldName["Method"] = "methodName";
    FilterFieldName["Scale"] = "scaleName";
    FilterFieldName["Process"] = "processName";
    FilterFieldName["Season"] = "seasonName";
    FilterFieldName["Hidden"] = "showRecords";
    FilterFieldName["NeedsChecking"] = "needsChecking";
    FilterFieldName["User"] = "username";
    FilterFieldName["ObservationName"] = "observation.name";
    FilterFieldName["ObservationCode"] = "observation.code";
    FilterFieldName["Tags"] = "tag.id";
    FilterFieldName["Traits"] = "trait.id";
    FilterFieldName["Methods"] = "method.id";
    FilterFieldName["Scales"] = "scale.id";
    FilterFieldName["processes"] = "process.id";
    FilterFieldName["BiomaterialCollectionContact"] = "biomaterialCollection.contact";
    FilterFieldName["BiomaterialCollectionName"] = "biomaterialCollection.name";
    FilterFieldName["BiomaterialBatchName"] = "biomaterialBatch.name";
    FilterFieldName["BatchBiomaterialName"] = "batchBiomaterial.name";
    FilterFieldName["BatchContact"] = "biomaterialBatch.contact";
    FilterFieldName["RequestName"] = "name";
    FilterFieldName["PrimaryContact"] = "primaryContact";
    FilterFieldName["RequestType"] = "type.id";
    FilterFieldName["SiteContact"] = "siteContact";
    FilterFieldName["Status"] = "status";
})(FilterFieldName || (FilterFieldName = {}));

class BiomaterialFilterDefinition {
    static getFields() {
        return [
            BiomaterialFilterDefinition.Site,
            BiomaterialFilterDefinition.Block,
            BiomaterialFilterDefinition.Row,
            BiomaterialFilterDefinition.Woodtype,
            BiomaterialFilterDefinition.Sex,
            BiomaterialFilterDefinition.Genotype,
            BiomaterialFilterDefinition.GenotypeLabel,
            BiomaterialFilterDefinition.ActiveStatus,
            BiomaterialFilterDefinition.Name,
            BiomaterialFilterDefinition.Collection,
            BiomaterialFilterDefinition.CreationMethod,
        ];
    }
}
BiomaterialFilterDefinition.Site = FilterField.createWithOptions(FilterFieldName.SiteCode, {
    flags: FilterFieldFlags.MultiValue,
});
BiomaterialFilterDefinition.Block = FilterField.createWithOptions(FilterFieldName.Block, {
    flags: FilterFieldFlags.MultiValue,
});
BiomaterialFilterDefinition.Row = FilterField.createWithOptions(FilterFieldName.Row, {
    flags: FilterFieldFlags.MultiValue,
});
BiomaterialFilterDefinition.Woodtype = FilterField.createWithOptions(FilterFieldName.CaneWoodType);
BiomaterialFilterDefinition.Sex = FilterField.createWithOptions(FilterFieldName.ScionSex, {
    flags: FilterFieldFlags.MultiValue,
});
BiomaterialFilterDefinition.Genotype = FilterField.createWithOptions(FilterFieldName.ScionGenotype, {
    flags: FilterFieldFlags.MultiValue,
});
BiomaterialFilterDefinition.GenotypeLabel = FilterField.createWithOptions(FilterFieldName.ScionGenotypeLabel, {
    flags: FilterFieldFlags.MultiValue,
});
BiomaterialFilterDefinition.ActiveStatus = FilterField.createWithOptions(FilterFieldName.CaneActiveStatus);
BiomaterialFilterDefinition.Name = FilterField.create(FilterFieldName.CaneName);
BiomaterialFilterDefinition.Collection = FilterField.createWithOptions(FilterFieldName.Collection, {
    flags: FilterFieldFlags.MultiValue,
});
BiomaterialFilterDefinition.CreationMethod = FilterField.createWithOptions(FilterFieldName.CreationMethod, {
    flags: FilterFieldFlags.MultiValue,
});

/**
 * Defines constants used to describe filter fields and filter selector groups throughout the application.
 */
var FilterFieldLabel;
(function (FilterFieldLabel) {
    FilterFieldLabel["Name"] = "Name";
    FilterFieldLabel["Location"] = "Location";
    FilterFieldLabel["WoodType"] = "Wood Type";
    FilterFieldLabel["Sex"] = "Sex";
    FilterFieldLabel["Genotype"] = "Genotype";
    FilterFieldLabel["GenotypeLabel"] = "Genotype Label";
    FilterFieldLabel["GenotypeCreationMethod"] = "Genotype Creation Method";
    FilterFieldLabel["Taxon"] = "Taxon";
    FilterFieldLabel["Ploidy"] = "Ploidy";
    FilterFieldLabel["ActiveStatus"] = "Active Status";
    FilterFieldLabel["BiomaterialCollection"] = "Biomaterial Collection";
    FilterFieldLabel["CreationMethod"] = "Creation Method";
    FilterFieldLabel["Site"] = "Site";
    FilterFieldLabel["Block"] = "Block";
    FilterFieldLabel["Row"] = "Row";
    FilterFieldLabel["ActiveScionCount"] = "Active Scion Count";
    FilterFieldLabel["StartYear"] = "Start Year";
    FilterFieldLabel["GraftYear"] = "Graft Year";
    FilterFieldLabel["BiomaterialName"] = "Biomaterial Name";
    FilterFieldLabel["Trial"] = "Trial";
    FilterFieldLabel["Observation"] = "Observation";
    FilterFieldLabel["Trait"] = "Trait";
    FilterFieldLabel["Method"] = "Method";
    FilterFieldLabel["Scale"] = "Scale";
    FilterFieldLabel["Process"] = "Process";
    FilterFieldLabel["Season"] = "Season";
    FilterFieldLabel["User"] = "User";
    FilterFieldLabel["NeedsChecking"] = "Needs Checking";
    FilterFieldLabel["Hidden"] = "Hidden";
    FilterFieldLabel["Contact"] = "Contact";
    FilterFieldLabel["Permissions"] = "My Permissions";
    FilterFieldLabel["ShortCode"] = "Short Code";
    FilterFieldLabel["Tags"] = "Tags";
    FilterFieldLabel["PimaryContact"] = "Primary Contact";
    FilterFieldLabel["RequestType"] = "Request Type";
    FilterFieldLabel["SiteContact"] = "Site Contact";
    FilterFieldLabel["Status"] = "Status";
})(FilterFieldLabel || (FilterFieldLabel = {}));

class GenotypeFilterDefinition {
    static getFields() {
        return [
            GenotypeFilterDefinition.Sex,
            GenotypeFilterDefinition.GenotypeLabel,
            GenotypeFilterDefinition.Name,
            GenotypeFilterDefinition.Taxon,
            GenotypeFilterDefinition.CreationMethod,
            GenotypeFilterDefinition.GenotypePloidy,
        ];
    }
}
GenotypeFilterDefinition.Sex = FilterField.createWithOptions(FilterFieldName.GenotypeSex, {
    flags: FilterFieldFlags.MultiValue,
    selectorGroup: FilterFieldLabel.Sex,
});
GenotypeFilterDefinition.GenotypeLabel = FilterField.createWithOptions(FilterFieldName.GenotypeLabel, {
    flags: FilterFieldFlags.MultiValue,
    selectorGroup: FilterFieldLabel.GenotypeLabel,
});
GenotypeFilterDefinition.Name = FilterField.create(FilterFieldName.GenotypeName);
GenotypeFilterDefinition.Taxon = FilterField.createWithOptions(FilterFieldName.TaxonName, {
    flags: FilterFieldFlags.MultiValue,
    selectorGroup: FilterFieldLabel.Taxon,
});
GenotypeFilterDefinition.CreationMethod = FilterField.createWithOptions(FilterFieldName.GenotypeCreationMethod, {
    flags: FilterFieldFlags.MultiValue,
    selectorGroup: FilterFieldLabel.GenotypeCreationMethod,
});
GenotypeFilterDefinition.GenotypePloidy = FilterField.createWithOptions(FilterFieldName.GenotypePloidy, {
    flags: FilterFieldFlags.MultiValue,
    selectorGroup: FilterFieldLabel.Ploidy,
});

var ObservationDataType$2;
(function (ObservationDataType) {
    ObservationDataType["TEXT"] = "TEXT";
    ObservationDataType["INTEGER"] = "INTEGER";
    ObservationDataType["DECIMAL"] = "DECIMAL";
    ObservationDataType["BOOLEAN"] = "BOOLEAN";
    ObservationDataType["DATETIME"] = "DATETIME";
    ObservationDataType["PICKLIST"] = "PICKLIST";
})(ObservationDataType$2 || (ObservationDataType$2 = {}));

var ObservationDataType$1;
(function (ObservationDataType) {
    ObservationDataType["TEXT"] = "TEXT";
    ObservationDataType["INTEGER"] = "INTEGER";
    ObservationDataType["DECIMAL"] = "DECIMAL";
    ObservationDataType["BOOLEAN"] = "BOOLEAN";
    ObservationDataType["DATETIME"] = "DATETIME";
    ObservationDataType["PICKLIST"] = "PICKLIST";
})(ObservationDataType$1 || (ObservationDataType$1 = {}));

class TreatmentCollection {
}

class TrialFilterDefinition {
    static getFields() {
        return [
            TrialFilterDefinition.Site,
            TrialFilterDefinition.Contact,
            TrialFilterDefinition.ActiveStatus,
            TrialFilterDefinition.Name,
            TrialFilterDefinition.Permission,
            TrialFilterDefinition.Tag,
        ];
    }
}
TrialFilterDefinition.Site = FilterField.createWithOptions(FilterFieldName.TrialSite, {
    flags: FilterFieldFlags.MultiValue,
    selectorGroup: FilterFieldLabel.Site,
});
TrialFilterDefinition.Tag = FilterField.createWithOptions(FilterFieldName.Tags, {
    flags: FilterFieldFlags.MultiValue,
});
TrialFilterDefinition.Contact = FilterField.createWithOptions(FilterFieldName.TrialContact, {
    selectorGroup: FilterFieldLabel.Contact,
});
TrialFilterDefinition.ActiveStatus = FilterField.createWithOptions(FilterFieldName.TrialActiveStatus, {
    selectorGroup: FilterFieldLabel.ActiveStatus,
});
TrialFilterDefinition.Name = FilterField.createWithOptions(FilterFieldName.TrialName);
TrialFilterDefinition.Permission = FilterField.createWithOptions(FilterFieldName.TrialPermission, {
    selectorGroup: FilterFieldLabel.Permissions,
});

class EntityMaker {
    static empty() {
        return {};
    }
    static singlePage(totalElements) {
        return {
            number: 0,
            size: totalElements,
            totalElements: totalElements,
            totalPages: 1
        };
    }
    /**
     * @description Method for creating a new Trial Permission entity against a trial.
     * @param group The group details passed from the TrialPermissionsView component
     * @param trial The trial the permission is being added to
     */
    static trialPermission(group, trial) {
        const r = EntityMaker.empty();
        r.uuid = group.id;
        r.keycloakUserName = group.name;
        r.keycloakUserId = group.id;
        r.nameType = 'GROUP';
        r.canRead = true;
        r.canCapture = false;
        r.canEdit = false;
        r.trial = ApiHelper.selfUri(trial);
        return r;
    }
}

var FilterModelType;
(function (FilterModelType) {
    FilterModelType["Undefined"] = "";
    FilterModelType["ObservationValues"] = "ObservationValues";
    FilterModelType["Trials"] = "Trials";
    FilterModelType["Canes"] = "Canes";
    FilterModelType["Scions"] = "Scions";
    FilterModelType["Plants"] = "Plants";
    FilterModelType["Fruits"] = "Fruits";
    FilterModelType["Genotypes"] = "Genotypes";
    FilterModelType["Users"] = "Users";
    FilterModelType["BiomaterialCollections"] = "BiomaterialCollections";
    FilterModelType["ObservationVariables"] = "ObservationVariables";
    FilterModelType["Batches"] = "Batches";
    FilterModelType["BatchBiomaterials"] = "BatchBiomaterials";
    FilterModelType["Samples"] = "Samples";
    FilterModelType["OperationsPlans"] = "OperationsPlans";
    FilterModelType["BiomaterialRequests"] = "BiomaterialRequests";
    FilterModelType["RemainingBiomaterials"] = "RemaningBiomaterials";
    FilterModelType["SuggestedBiomaterials"] = "SuggestedBiomaterials";
    FilterModelType["Biomaterials"] = "Biomaterials";
    FilterModelType["Programmes"] = "Programmes";
})(FilterModelType || (FilterModelType = {}));
class SavedFilter {
    constructor(modelType, filterModel, selectors) {
        this.modelType = modelType;
        this.filterModel = filterModel;
        this.selectors = selectors;
    }
}

class UserGroup {
}

/**
 * api entities
 */

class Dictionary {
    constructor() {
        this._collection = {};
        this._count = 0;
    }
    get count() {
        return this._count;
    }
    getValue(key) {
        if (key == undefined) {
            throw new Error(ExceptionMessageFormatter.argumentNull('key'));
        }
        return this._collection[key];
    }
    setValue(key, value) {
        if (key == undefined) {
            throw new Error(ExceptionMessageFormatter.argumentNull('key'));
        }
        if (!this.containsKey(key)) {
            this._count++;
        }
        this._collection[key] = value;
    }
    remove(key) {
        if (key == undefined) {
            throw new Error(ExceptionMessageFormatter.argumentNull('key'));
        }
        if (!this.containsKey(key))
            return undefined;
        const result = this._collection[key];
        delete this._collection[key];
        this._count--;
        return result;
    }
    clear() {
        if (this._count > 0) {
            this._collection = {};
            this._count = 0;
        }
    }
    containsKey(key) {
        if (key == undefined) {
            throw new Error(ExceptionMessageFormatter.argumentNull('key'));
        }
        return this._collection.hasOwnProperty(key);
    }
    getKeys() {
        return Object.keys(this._collection);
    }
    getValues() {
        const result = [];
        const c = this._collection;
        for (const key in c) {
            if (c[key]) {
                result.push(c[key]);
            }
        }
        return result;
    }
    getKeyValueCollection() {
        const result = {};
        const c = this._collection;
        for (const key in c) {
            if (result[key]) {
                result[key] = c[key];
            }
        }
        return result;
    }
}

var ObservationDataType;
(function (ObservationDataType) {
    ObservationDataType["TEXT"] = "TEXT";
    ObservationDataType["INTEGER"] = "INTEGER";
    ObservationDataType["DECIMAL"] = "DECIMAL";
    ObservationDataType["BOOLEAN"] = "BOOLEAN";
    ObservationDataType["DATETIME"] = "DATETIME";
    ObservationDataType["PICKLIST"] = "PICKLIST";
})(ObservationDataType || (ObservationDataType = {}));
const dataTypeOptions = [
    {
        value: ObservationDataType.TEXT,
        label: ObservationDataType.TEXT
    },
    {
        value: ObservationDataType.INTEGER,
        label: ObservationDataType.INTEGER
    },
    {
        value: ObservationDataType.DECIMAL,
        label: ObservationDataType.DECIMAL
    },
    {
        value: ObservationDataType.BOOLEAN,
        label: ObservationDataType.BOOLEAN
    },
    {
        value: ObservationDataType.DATETIME,
        label: ObservationDataType.DATETIME
    },
    {
        value: ObservationDataType.PICKLIST,
        label: ObservationDataType.PICKLIST
    }
];

class FormattedObservationValue {
    static createFrom(src, scale) {
        const r = TypeHelper.clone(src);
        r.bindValue = undefined;
        if (r.observationDate) {
            r.observationTimeDescriptive = moment
                .utc(r.observationDate)
                .local()
                .format('DD/MM/YYYY HH:mm:ss');
        }
        if (scale) {
            let min;
            let max;
            if (r.dataType == undefined) {
                r.dataType = scale.dataType;
            }
            switch (scale.dataType) {
                case 'DATETIME':
                    min = scale.maxDaysBefore;
                    max = scale.maxDaysAfter;
                    break;
                case 'DECIMAL':
                    min = scale.minDecimalValue;
                    max = scale.maxDecimalValue;
                    break;
                case 'INTEGER':
                    min = scale.minIntegerValue;
                    max = scale.maxIntegerValue;
                    break;
            }
            r.min = min;
            r.max = max;
        }
        switch (r.dataType) {
            case ObservationDataType.BOOLEAN:
                r.typedValue =
                    TypeHelper.sanitizeString(src.observationValue).toLowerCase() ===
                        'true';
                r.bindValue = r.typedValue;
                break;
            case ObservationDataType.DATETIME:
                r.typedValue = TypeHelper.isStringNullOrEmpty(r.observationValue)
                    ? undefined
                    : new Date(r.observationValue);
                r.bindValue = r.typedValue;
                r.minDescriptive = dateToString(r, true);
                r.maxDescriptive = dateToString(r, false);
                break;
            case ObservationDataType.INTEGER:
                r.typedValue = parseInt(r.observationValue, 10);
                if (Number.isNaN(r.typedValue)) {
                    r.typedValue = undefined;
                }
                else {
                    r.bindValue = r.typedValue;
                }
                r.minDescriptive = numberToString(r.min);
                r.maxDescriptive = numberToString(r.max);
                break;
            case ObservationDataType.DECIMAL:
                r.typedValue = parseFloat(r.observationValue);
                if (Number.isNaN(r.typedValue)) {
                    r.typedValue = undefined;
                }
                else {
                    r.bindValue = r.typedValue;
                }
                r.minDescriptive = numberToString(r.min);
                r.maxDescriptive = numberToString(r.max);
                break;
            default:
                r.typedValue = src.observationValue;
                r.bindValue = r.typedValue;
                break;
        }
        return r;
    }
    static toEntity(src) {
        const r = TypeHelper.clone(src);
        switch (r.dataType) {
            case 'DATETIME':
                if (r.bindValue != undefined) {
                    r.observationValue = FormatHelper.formatDateTimeAsUTC(r.bindValue);
                }
                else {
                    r.bindValue = undefined;
                }
                break;
            default:
                r.observationValue = r.bindValue ? r.bindValue.toString() : undefined;
                break;
        }
        delete r.typedValue;
        delete r.bindValue;
        delete r.min;
        delete r.max;
        delete r.minDescriptive;
        delete r.maxDescriptive;
        delete r.observationTimeDescriptive;
        delete r.observationDateLocal;
        delete r.observationTimeLocal;
        return r;
    }
    static isDateInRange(obs, v) {
        if (v == undefined || obs.observationDateLocal == undefined)
            return true;
        v = TypeHelper.dateOf(v);
        return ((obs.min == undefined || dateDiffDays(obs, v, 0 - obs.min) >= 0) &&
            (obs.max == undefined || dateDiffDays(obs, v, obs.max) <= 0));
    }
    static isNumberInRange(obs, v) {
        return ((obs.min == undefined || v >= obs.min) &&
            (obs.max == undefined || v <= obs.max));
    }
}
function dateDiffDays(obs, d1, offset) {
    if (d1 == undefined)
        return 0;
    const d2 = new Date(obs.observationDateLocal.getTime());
    d2.setDate(d2.getDate() + offset);
    return d1.valueOf() - d2.valueOf();
}
function numberToString(v) {
    return v != undefined ? v.toString(10) : undefined;
}
function dateToString(v, isMin) {
    if (v == undefined || v.observationDate == undefined)
        return undefined;
    let offset = isMin ? v.min : v.max;
    if (offset == undefined)
        return undefined;
    if (isMin) {
        offset = 0 - offset;
    }
    // The observation date is milliseconds since 1 Jan 1970 00:00:00.000 UTC time.
    let d = TypeHelper.localTimeFromUTCMilliseconds(v.observationDate);
    d = TypeHelper.dateOf(d); // Reset the time component to zero.
    d.setDate(d.getDate() + offset); // Apply the offset
    return FormatHelper.formatUIDate(d); // Format for display
}

class ErrorRedirect {
    constructor(router) {
        this.router = router;
    }
    gotoErrorPageAuto(apiResponse) {
        let target;
        if (apiResponse) {
            switch (apiResponse.code) {
                case ApiResponseCode.BadRequest:
                    target = 'BadRequest';
                    break;
                case ApiResponseCode.NotFound:
                    target = 'NotFound';
                    break;
                case ApiResponseCode.AccessDenied:
                    target = 'Forbidden';
                    break;
                case ApiResponseCode.InternalServerError:
                    target = 'InternalServerError';
                    break;
                case ApiResponseCode.HttpError:
                    target = 'HttpError';
                    break;
            }
        }
        return this.gotoErrorPage(target != undefined ? target : 'AppError', apiResponse);
    }
    gotoErrorPage(target, details) {
        let route;
        switch (target) {
            case 'BadRequest':
                route = '400';
                break;
            case 'Forbidden':
                route = '403';
                break;
            case 'NotFound':
                route = '404';
                break;
            case 'InternalServerError':
                route = '500';
                break;
            case 'HttpError':
                route = 'http-error';
                break;
            default:
                route = 'error';
                break;
        }
        let options;
        if (details) {
            options = {
                queryParams: {
                    code: details.code,
                    message: details.message
                }
            };
        }
        return this.router.navigate([route], options);
    }
}

class UserNotifications {
    constructor(textService, logger) {
        this.textService = textService;
        this.logger = logger;
    }
    init() {
        return of(Promise.resolve());
    }
    handleEntityActionApiResponse(observable, actionType, entityType, entityName, ...handlers) {
        return this.handleAsyncApiResponse({
            actionType: actionType,
            response: observable,
            entityType: entityType,
            entityName: entityName,
        }, ...handlers);
    }
    /**
     * Notifies the user of the outcome of an asynchronous API response.
     * @param descriptor The descriptor that should be used to contruct the notification message.
     * @param handlers Optional handlers that may be used to modify the descriptor.
     */
    handleAsyncApiResponse(descriptor, ...handlers) {
        let completed = false;
        let sub = descriptor.response.subscribe((response) => {
            if (sub != undefined) {
                sub.unsubscribe();
                sub = undefined;
            }
            completed = true;
            const revised = {
                actionType: descriptor.actionType,
                response: response,
                condition: descriptor.condition,
                entityType: descriptor.entityType,
                entityName: descriptor.entityName,
                propertyName: descriptor.propertyName,
            };
            this.handleApiResponse(revised, ...handlers);
        });
        if (completed && sub != undefined)
            sub.unsubscribe();
        return descriptor.response;
    }
    /**
     * Notifies the user of the outcome of an API response.
     * @param descriptor The descriptor that should be used to contruct the notification message.
     * @param handlers Optional handlers that may be used to modify the descriptor.
     */
    handleApiResponse(descriptor, ...handlers) {
        this.applyApiResponse(descriptor, ...handlers);
        const message = descriptor.detailMessage;
        if (descriptor.response.isOk) {
            const condition = descriptor.condition != undefined
                ? descriptor.condition
                : NotificationCondition.Default;
            if (condition === NotificationCondition.Always) {
                this.notifySuccess(message);
            }
        }
        else {
            let level = descriptor.failureLevel;
            if (level == undefined)
                level = FailureLevel.Default;
            switch (level) {
                case FailureLevel.Warn:
                    this.notifyFailure(message);
                    break;
                case FailureLevel.Error:
                    this.notifyError(message);
                    break;
            }
        }
    }
    applyApiResponse(descriptor, ...handlers) {
        const condition = descriptor.condition != undefined
            ? descriptor.condition
            : NotificationCondition.Default;
        if (!(descriptor.response.isOk &&
            condition === NotificationCondition.FailureOnly)) {
            this.processHandlers(descriptor, handlers);
        }
    }
    getApiResponseMessage(descriptor, ...handlers) {
        this.applyApiResponse(descriptor, ...handlers);
        return descriptor.detailMessage;
    }
    processHandlers(descriptor, handlers) {
        let handled = false;
        for (let i = 0; !handled && i < handlers.length; i++) {
            handled = handlers[i](this.textService.messageFormatter, descriptor);
        }
        if (!handled) {
            defaultApiOutcomeHandler(this.textService.messageFormatter, descriptor);
        }
    }
    notifySuccess(message, action, onAction) {
        // TODO: Katalon - If we abandon the snackbar for such responses
        // for success: .kup-snackbar-success
        setTimeout(() => {
            this.logger.success(message, action, onAction);
        }, 0);
    }
    notifyFailure(message, response) {
        // TODO: Katalon - If we abandon the snackbar for such responses
        // for error: .kup-snackbar-error
        setTimeout(() => {
            this.logger.warn(message, response);
        }, 0);
    }
    notifyError(message, response) {
        // TODO: Katalon - If we abandon the snackbar for such responses
        // for error: .kup-snackbar-error
        setTimeout(() => {
            this.logger.error(message, response);
        }, 0);
    }
}
UserNotifications.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: UserNotifications, deps: [{ token: AppTextService }, { token: Logger }], target: i0.ɵɵFactoryTarget.Injectable });
UserNotifications.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: UserNotifications, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: UserNotifications, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: AppTextService }, { type: Logger }]; } });

class SubscriptionManager {
    constructor() {
        this.subscriptions = [];
        this.counter = 0;
    }
    /**
     * add subscription to the manager. Returns the id of the subscriptions
     * @param subscription subscription that shall be added
     * @param tag optional tag
     * @returns number
     */
    add(subscription, tag) {
        this.subscriptions.push({
            id: ++this.counter,
            tag,
            subscription
        });
        return this.counter;
    }
    /**
     * unsubscribes all subscriptions
     */
    destroy() {
        if (!(this.subscriptions === null || this.subscriptions === undefined)) {
            for (const elem of this.subscriptions) {
                elem.subscription.unsubscribe();
            }
            this.subscriptions = [];
        }
    }
    /**
     * unsubscribes specific Subscription with specific id.
     * @param id id that is looked for
     */
    removeById(id) {
        for (let i = 0; i < this.subscriptions.length; i++) {
            const element = this.subscriptions[i];
            if (element.id === id) {
                element.subscription.unsubscribe();
                this.subscriptions.splice(i, 1);
                return true;
            }
        }
        return false;
    }
    /***
     * unsubscribes all subscriptions with a specific tag
     * @param tag name that is tagged to the subscription
     */
    removeByTag(tag) {
        let removed = false;
        for (let i = 0; i < this.subscriptions.length; i++) {
            const element = this.subscriptions[i];
            if (element.tag === tag) {
                element.subscription.unsubscribe();
                this.subscriptions.splice(i, 1);
                removed = true;
            }
        }
        return removed;
    }
}

var UserRole;
(function (UserRole) {
    UserRole["KUP_USER"] = "KUP_USER";
    UserRole["KUP_ADMIN"] = "KUP_ADMIN";
    UserRole["KUP_TRIAL_CREATOR"] = "KUP_TRIAL_CREATOR";
    UserRole["KUP_TRIAL_ADMIN"] = "KUP_TRIAL_ADMIN";
    UserRole["KUP_TRAIT_ADMIN"] = "KUP_TRAIT_ADMIN";
    UserRole["KUP_TREATMENT_ADMIN"] = "KUP_TREATMENT_ADMIN";
    UserRole["KUP_TASK_ADMIN"] = "KUP_TASK_ADMIN";
    UserRole["KUP_SCALE_ADMIN"] = "KUP_SCALE_ADMIN";
    UserRole["KUP_METHOD_ADMIN"] = "KUP_METHOD_ADMIN";
    UserRole["KUP_BIOMATERIAL_ADMIN"] = "KUP_BIOMATERIAL_ADMIN";
    UserRole["KUP_BIOMATERIAL_COLLECTION_ADMIN"] = "KUP_BIOMATERIAL_COLLECTION_ADMIN";
    UserRole["KUP_BIOMATERIAL_COLLECTION_CREATOR"] = "KUP_BIOMATERIAL_COLLECTION_CREATOR";
    UserRole["KUP_PROCESS_ADMIN"] = "KUP_PROCESS_ADMIN";
    UserRole["KUP_SECURITY_ADMIN"] = "KUP_SECURITY_ADMIN";
    UserRole["KUP_IMPORT_ADMIN"] = "KUP_IMPORT_ADMIN";
    UserRole["KUP_IMPORT_USER"] = "KUP_IMPORT_USER";
    UserRole["KUP_FACTOR_KEYWORD_ADMIN"] = "KUP_FACTOR_KEYWORD_ADMIN";
    UserRole["KUP_GENOTYPE_ADMIN"] = "KUP_GENOTYPE_ADMIN";
    UserRole["KUP_GENOTYPE_LABEL_ADMIN"] = "KUP_GENOTYPE_LABEL_ADMIN";
    UserRole["KUP_FACTOR_ADMIN"] = "KUP_FACTOR_ADMIN";
    UserRole["KUP_SITE_ADMIN"] = "KUP_SITE_ADMIN";
    UserRole["KUP_SEASON_ADMIN"] = "KUP_SEASON_ADMIN";
    UserRole["KUP_OPERATIONS_PLAN_ADMIN"] = "KUP_OPERATIONS_PLAN_ADMIN";
    UserRole["KUP_LAUNCH"] = "KUP_LAUNCH";
    UserRole["KUP_OBSERVATIONS_ADMIN"] = "KUP_OBSERVATIONS_ADMIN";
    UserRole["KUP_OPERATIONS_PLAN_CREATOR"] = "KUP_OPERATIONS_PLAN_CREATOR";
    UserRole["KUP_TAG_ADMIN"] = "KUP_TAG_ADMIN";
    UserRole["KUP_OBSERVATION_VARIABLES_ADMIN"] = "KUP_OBSERVATION_VARIABLES_ADMIN";
    UserRole["KUP_OBS_QUERY_CREATOR"] = "KUP_OBS_QUERY_CREATOR";
    UserRole["KUP_BIOMATERIAL_BATCH_ADMIN"] = "KUP_BIOMATERIAL_BATCH_ADMIN";
    UserRole["KUP_BIOMATERIAL_BATCH_CREATOR"] = "KUP_BIOMATERIAL_BATCH_CREATOR";
})(UserRole || (UserRole = {}));

/**
 * A convenience class that serializes asynchronous operations.
 */
class SerializedOperationQueue {
    /**
     * Creates a new `SerializedOperationQueue` instance.
     * @param latestOnly If `true`, only the most recently queued operation will be executed; the rest will be discarded.
     * The default value is `false`.
     */
    constructor(latestOnly = false) {
        this.latestOnly = latestOnly;
        this._queue = [];
        this._isBusy = false;
    }
    /**
     * Enqueues a new serialized operation.
     * @param invoker A function which initiates a serialized operation.
     */
    enqueue(invoker) {
        this._queue.push(invoker);
        if (!this._isBusy) {
            this.initProcess();
        }
    }
    initProcess() {
        this._isBusy = true;
        setTimeout(() => {
            this.process();
        }, 0);
    }
    process() {
        let op;
        if (this.latestOnly) {
            op = this._queue.pop();
            this._queue = [];
        }
        else {
            op = this._queue.shift();
        }
        Disposables.global.subscribeReplayOnce(op(), () => {
            this.handleOutcome();
        }, () => {
            this.handleOutcome();
        });
    }
    handleOutcome() {
        this._isBusy = this._queue.length > 0;
        if (this._isBusy) {
            this.initProcess();
        }
    }
}

const maxRange = 1000;
/**
 * Enables integer list source data to be shared across multiple `IntegerListDropdownProvider` instances.
 */
class IntegerListRangeProvider {
    constructor(start, end) {
        if (start == undefined) {
            throw new Error(ExceptionMessageFormatter.argumentNull('start'));
        }
        if (end == undefined) {
            throw new Error(ExceptionMessageFormatter.argumentNull('end'));
        }
        if (!Number.isInteger(start)) {
            throw new Error(ExceptionMessageFormatter.argumentMustBeInt('start'));
        }
        if (!Number.isInteger(end)) {
            throw new Error(ExceptionMessageFormatter.argumentMustBeInt('end'));
        }
        if (end < start) {
            throw new Error(ExceptionMessageFormatter.argumentBelowBound('end', 'start'));
        }
        if (end - start > maxRange) {
            throw new Error(`The maximum allowable range is ${maxRange}.`);
        }
        const items = [];
        while (start <= end) {
            items.push(start.toString());
            start++;
        }
        this.range = DropdownDatasource.automap(items, 'string');
    }
    static createDefaultTrialRange() {
        const absoluteStartYear = 1970;
        const currentYear = new Date(Date.now()).getFullYear();
        return new IntegerListRangeProvider(absoluteStartYear, currentYear + 1);
    }
}
class IntegerListDropdownProvider extends DropdownProvider {
    constructor(rangeProvider) {
        if (rangeProvider == undefined) {
            throw new Error(ExceptionMessageFormatter.argumentNull('range'));
        }
        super(DropdownDatasource.createStatic(rangeProvider.range));
    }
}

const pageDefaults = {
    size: 10,
    totalElements: null,
    totalPages: null,
    number: null
};

const serviceList = {
    GET_TRIALS: {
        action: 'GET',
        endpoint: 'trials',
    },
    GET_OPS_PLANS: {
        action: 'GET',
        endpoint: 'operationsPlans/filters',
    },
    GET_BIO_COLLECTIONS: {
        action: 'GET',
        endpoint: 'biomaterialCollections/filters',
    },
};
class BlockPlanEntityIdDropdownProvider extends DropdownProvider {
    constructor(service, type) {
        super(DropdownDatasource.createMapDynamic((filter) => {
            let obs;
            if (type === 'trials') {
                obs = service
                    .apiService(serviceList.GET_TRIALS, null, null, `?trial.name=${filter}&permissionType=READ&projection=trialManagementTable&size=${pageDefaults.size}`)
                    .pipe(map((res) => (res.result._embedded = filterTrialByPermissions(res.result._embedded[type]))));
            }
            if (type === 'operationsPlans') {
                obs = service
                    .apiService(serviceList.GET_OPS_PLANS, null, null, `?operationsPlan.name=${filter}&permissionType=READ&projection=operationsPlanManagementTable&size=${pageDefaults.size}`)
                    .pipe(map((res) => (res.result._embedded = res.result._embedded[type])));
            }
            if (type === 'biomaterialCollections') {
                obs = service
                    .apiService(serviceList.GET_BIO_COLLECTIONS, null, null, 
                // eslint-disable-next-line max-len
                `?biomaterialCollection.name=${filter}&permissionType=READ&projection=biomaterialCollectionManagementTable&size=${pageDefaults.size}`)
                    .pipe(map((res) => (res.result._embedded = res.result._embedded[type])));
            }
            return obs;
        }, 'uuid'));
    }
}
function filterTrialByPermissions(list) {
    return list.filter((x) => x['trialRightsSummary'] && x['trialRightsSummary']['canRead']);
}

class BiomaterialLinkDropdownProvider extends DropdownProvider {
    constructor(service, filterType, type, defaultTerm) {
        const fn = DropdownDatasource.getAutomapFunction('name|uuid');
        const defaultExportPageSize = 10;
        super(DropdownDatasource.createMapDynamic((filter) => service.apiService({
            action: 'GETLIST',
            endpoint: '',
        }, null, null, `${filterType}?contains=${filter !== '' ? filter : defaultTerm}&size=${defaultExportPageSize}`), (value) => {
            const item = fn(value);
            item.value = `${service.endpoint}/${type}/${item.value}`;
            return item;
        }));
    }
}

class EntityNameDropdownProvider extends DropdownProvider {
    constructor(service, filterType, pageSize) {
        const defaultExportPageSize = 2147483647;
        pageSize = Math.max(Math.min(pageSize ? pageSize : defaultExportPageSize), 1);
        super(DropdownDatasource.createMapDynamic((filter) => service.apiService({
            action: 'GETLIST',
            endpoint: '',
        }, null, null, `${filterType}?contains=${filter}&size=${pageSize}`), 'name|*'));
    }
}

class EntityNameIdDropdownProvider extends DropdownProvider {
    constructor(service, filterType, pageSize, uuids, automap) {
        const defaultExportPageSize = 2147483647;
        pageSize = Math.max(Math.min(pageSize ? pageSize : defaultExportPageSize), 1);
        super(DropdownDatasource.createMapDynamic((filter) => service.apiService({
            action: 'GETLIST',
            endpoint: '',
        }, null, null, `${filterType}?contains=${filter}&size=${pageSize}&uuids=${!filter && uuids ? uuids : ''}`), automap || 'name|uuid'));
    }
}

class ObservationsEntityIdDropdownProvider extends DropdownProvider {
    constructor(service, type) {
        super(DropdownDatasource.createMapDynamic((filter) => {
            let obs;
            filter = filter != undefined ? filter.toLowerCase() : '';
            if (type === 'traits') {
                const params = `trait.name=${filter}&page=0&size=${defaultExportPageSize}`;
                obs = service
                    .apiService({
                    action: 'GETLIST',
                    endpoint: 'traits',
                }, null, null, `?${params}`)
                    .pipe(map((res) => res.result._embedded.traits));
            }
            if (type === 'methods') {
                const params = `method.name=${filter}&page=0&size=${defaultExportPageSize}`;
                obs = service
                    .apiService({
                    action: 'GETLIST',
                    endpoint: 'methods',
                }, null, null, `?${params}`)
                    .pipe(map((res) => res.result._embedded.methods));
            }
            if (type === 'scales') {
                const params = `scale.name=${filter}&page=0&size=${defaultExportPageSize}`;
                obs = service
                    .apiService({
                    action: 'GETLIST',
                    endpoint: 'scales',
                }, null, null, `?${params}`)
                    .pipe(map((res) => res.result._embedded.scales));
            }
            if (type === 'processes') {
                const params = `process.name=${filter}&page=0&size=${defaultExportPageSize}`;
                obs = service
                    .apiService({
                    action: 'GETLIST',
                    endpoint: 'processes',
                }, null, null, `?${params}`)
                    .pipe(map((res) => res.result._embedded.processes));
            }
            return obs;
        }, 'uuid'));
    }
}

class UsernameDropdownProviderNew extends DropdownProvider {
    constructor(service) {
        super(DropdownDatasource.createMapDynamic((filter) => {
            const params = `match=${filter}&page=0&size=${defaultExportPageSize}`;
            const obs = service
                .apiService({
                action: 'GETLIST',
                endpoint: '',
            }, null, null, `keycloak/usermembership?${params}`)
                .pipe(map((res) => res.result.content));
            return obs;
        }, (item) => ({
            value: item.username,
            label: this.getLabel(item),
        })));
    }
    getLabel(item) {
        if (item.firstName === null && item.firstName === null) {
            return item.username;
        }
        else {
            return `${item.firstName} ${item.lastName} (${item.username})`;
        }
    }
}

class GenotypeLabelDropdownProviderNew extends DropdownProvider {
    constructor(service, idAsValue = false) {
        super(DropdownDatasource.createMapDynamic((filter) => service.apiService({
            action: 'GETLIST',
            endpoint: ''
        }, null, null, `unique/labels?contains=${filter}`), idAsValue === true ? 'name|uuid' : 'name|*'));
    }
}

class TrialNameDropdownProviderNew extends DropdownProvider {
    constructor(service) {
        super(DropdownDatasource.createMapDynamic((filter) => {
            filter = filter != undefined ? filter.toLowerCase() : '';
            const params = `trial.name=${filter}&page=0&size=${defaultExportPageSize}`;
            const obs = service
                .apiService({
                action: 'GETLIST',
                endpoint: 'trials'
            }, null, null, `?${params}`)
                .pipe(map(res => res.result._embedded.trials));
            return obs;
        }, 'name'));
    }
}

class SitesDropdownProvider extends DropdownProvider {
    constructor(service, type) {
        super(DropdownDatasource.createMapDynamic((filter) => {
            const params = `size=${defaultExportPageSize}`;
            const obs = service
                .apiService({
                action: 'GETLIST',
                endpoint: 'sites',
            }, null, null, `?${params}`)
                .pipe(map((res) => res.result._embedded.sites.sort((x, y) => TypeHelper.stringSortCompare(x.name, y.name))));
            return obs;
        }, type));
    }
}

class TrialIdDropdownProviderNew extends DropdownProvider {
    constructor(service) {
        super(DropdownDatasource.createMapDynamic((filter) => {
            const maxLength = 50;
            filter = filter !== undefined ? filter.toLowerCase() : '';
            const params = `trial.name=${filter}&page=0&size=${maxLength}`;
            const obs = service
                .apiService({
                action: 'GETLIST',
                endpoint: 'trials'
            }, null, null, `?${params}`)
                .pipe(map(res => res.result._embedded.trials));
            return obs;
        }, 'uuid'));
    }
}

class ImportTypesDropdownProvider extends DropdownProvider {
    constructor(service) {
        super(DropdownDatasource.createMapDynamic((filter) => {
            const params = `size=${defaultExportPageSize}`;
            const obs = service
                .apiService({
                action: 'GETLIST',
                endpoint: 'importTypes'
            }, null, null, `?${params}`)
                .pipe(map(res => res.result._embedded.importTypes));
            return obs;
        }, 'name'));
    }
}

class BatchIdDropdownProvider extends DropdownProvider {
    constructor(service) {
        super(DropdownDatasource.createMapDynamic((filter) => {
            filter = filter != undefined ? filter.toLowerCase() : '';
            const params = `batchName=${filter}&page=0&size=${defaultExportPageSize}`;
            const obs = service
                .apiService({
                action: 'GETLIST',
                endpoint: 'biomaterialBatches/filters'
            }, null, null, `?projection=biomaterialBatchManagementTable&${params}`)
                .pipe(map(res => res.result._embedded.biomaterialBatches));
            return obs;
        }, 'uuid'));
    }
}

class RequestTypeIdDropdownProvider extends DropdownProvider {
    constructor(service) {
        super(DropdownDatasource.createMapDynamic((filter) => {
            filter = filter != undefined ? filter.toLowerCase() : '';
            const params = `type.id=${filter}&page=0&size=${defaultExportPageSize}`;
            const obs = service
                .apiService({
                action: 'GETLIST',
                endpoint: 'biomaterialRequestTypes',
            }, null, null, `?${params}`)
                .pipe(map((res) => res.result._embedded.biomaterialRequestTypes));
            return obs;
        }, 'uuid'));
    }
}

class LocationDropdownProvider extends DropdownProvider {
    constructor(service, idAsValue = false) {
        super(DropdownDatasource.createMapDynamic((filter) => service.apiService({
            action: 'GETLIST',
            endpoint: '',
        }, null, null, `unique/locationOntologyTerms?contains=${filter}`), idAsValue === true ? 'name|uuid' : 'name|*'));
    }
}

class CollectionDropdownProvider extends DropdownProvider {
    constructor(service, type) {
        super(DropdownDatasource.createMapDynamic(() => {
            const params = `&permissionType=READ&page=0&size=${defaultExportPageSize}`;
            const obs = service
                .apiService({
                action: 'GETLIST',
                endpoint: 'biomaterialCollections/filters',
            }, null, null, `?projection=biomaterialCollectionManagementTable&${params}`)
                .pipe(map((res) => res.result._embedded.biomaterialCollections));
            return obs;
        }, type));
    }
}

class RequestTypeDropdownProvider extends DropdownProvider {
    constructor(service) {
        super(DropdownDatasource.createMapDynamic(() => {
            const params = `size=${defaultExportPageSize}`;
            const obs = service
                .apiService({
                action: 'GETLIST',
                endpoint: 'biomaterialRequestTypes',
            }, null, null, `?${params}`)
                .pipe(map((res) => res.result._embedded.biomaterialRequestTypes));
            return obs;
        }, 'link'));
    }
}

class TagDropdownProvider extends DropdownProvider {
    constructor(service, category) {
        super(DropdownDatasource.createMapDynamic((filter) => {
            let obs;
            filter = filter != undefined ? filter.toLowerCase() : '';
            const params = `category=${category}&page=0&size=${defaultExportPageSize}`;
            obs = service
                .apiService({
                action: 'GETLIST',
                endpoint: 'tags/search/findByCategory',
            }, null, null, `?${params}`)
                .pipe(map((res) => res.result._embedded.tags));
            return obs;
        }, 'uuid'));
    }
}

class SiteBlocksDropdownProvider extends DropdownProvider {
    constructor(service, type, siteId) {
        super(DropdownDatasource.createMapDynamic((filter) => {
            const params = `size=${defaultExportPageSize}`;
            const obs = service
                .apiService({
                action: 'GETLIST',
                endpoint: `sites/${siteId}/blocks`,
            }, null, null, `?${params}`)
                .pipe(map((res) => res.result._embedded ? res.result._embedded.blocks : []));
            return obs;
        }, type));
    }
}

// to do
class GenotypeSynonymDropdownProvider extends DropdownProvider {
    constructor(service, type, pageSize, uuids, defaultTerm) {
        const defaultExportPageSize = 2147483647;
        pageSize = Math.max(Math.min(pageSize ? pageSize : defaultExportPageSize), 1);
        super(DropdownDatasource.createMapDynamic((filter = '') => service.apiService({
            action: 'GETLIST',
            endpoint: '',
        }, null, null, `genotypes/synonyms?contains=${filter !== '' ? filter : defaultTerm}&genotypeType=${type}&size=${pageSize}&uuids=${!filter && uuids ? uuids : ''}`), 'name|uuid'));
    }
}

class DynamicDropdownDatasource extends DropdownDatasource {
    constructor() {
        super();
    }
    get queryFn() {
        return this._queryFn;
    }
    set queryFn(value) {
        this._queryFn = value;
    }
}

class BiomaterialDropdownProvider extends DropdownProvider {
    constructor(service, type, idAsValue = false, pageSize, uuids) {
        const defaultExportPageSize = 2147483647;
        pageSize = Math.max(Math.min(pageSize ? pageSize : defaultExportPageSize), 1);
        super(DropdownDatasource.createMapDynamic((filter) => {
            const urlEncodedFilter = filter != undefined ? encodeURIComponent(filter) : '';
            const obs = service.apiService({
                action: 'GETLIST',
                endpoint: '',
            }, null, null, `biomaterials/namesOrAliases?contains=${urlEncodedFilter}&type=${type}&size=${pageSize}`);
            return obs;
        }, idAsValue === true ? 'name|uuid' : 'name|*'));
    }
}

class ModalFormDialogRef {
    constructor(matRef, data) {
        this.matRef = matRef;
        this.data = data;
    }
    get model() {
        return this.data.model;
    }
    get onCancel() {
        return this.data.onModalCancel;
    }
    get onCreate() {
        return this.data.onModalSubmit;
    }
    get onUpdate() {
        return this.data.onModalSubmit;
    }
}

var DismissReason;
(function (DismissReason) {
    DismissReason[DismissReason["cancel"] = 0] = "cancel";
    DismissReason[DismissReason["backdrop"] = 1] = "backdrop";
    DismissReason[DismissReason["close"] = 2] = "close";
    DismissReason[DismissReason["esc"] = 3] = "esc";
    DismissReason[DismissReason["timer"] = 4] = "timer";
})(DismissReason || (DismissReason = {}));
const swalDefaults = {
    customClass: 'swal2-custom',
    showCancelButton: true,
    confirmButtonText: 'Yes',
    confirmButtonColor: '#751947',
};
class SwalDialog {
    constructor(userNotifications, text) {
        this.userNotifications = userNotifications;
        this.text = text;
    }
    openModalForm(dialog, componentOrTemplateRef, config) {
        const matConfig = dialogConfigFromModalFormConfig(config);
        const r = dialog.open(componentOrTemplateRef, matConfig);
        if (config.provider === 'integrated') {
            matConfig.data.provider =
                r.componentInstance;
        }
        return new ModalFormDialogRef(r, matConfig.data);
    }
    confirm(message, options) {
        let title;
        let buttonText;
        let type;
        let interval;
        if (options != undefined) {
            title = options.title;
            buttonText = options.confirmButtonText;
            type = options.type;
            if (options.delayCanConfirm === true) {
                interval = 2000;
            }
        }
        const o = Object.assign(Object.assign({ title: title != undefined ? title : 'Are you sure?', text: message, icon: dialogType(type) }, swalDefaults), { confirmButtonText: buttonText != undefined ? buttonText : 'Yes' });
        if (interval != undefined) {
            applyDelayConfirm(o);
        }
        return this.dialog(o).then((r) => r.value === true);
    }
    confirmAsApiResponse(apiOperation, message, options) {
        return processApiDialogResult(this.confirm(message, options), apiOperation);
    }
    confirmEntityDelete(entityType, options) {
        return this.confirmDelete(this.text.getText(entityType), options);
    }
    confirmEntityDeleteAsApiResponse(apiOperation, entityType, options) {
        return processApiDialogResult(this.confirmEntityDelete(entityType, options), apiOperation);
    }
    confirmDelete(entityTypeName, options) {
        const o = {
            title: `Delete ${entityTypeName}?`,
            confirmButtonText: 'Delete',
            type: 'question',
        };
        let message;
        let name;
        if (options != undefined) {
            message = options.message;
            name = options.entityName;
        }
        if (message == undefined) {
            message =
                name == undefined
                    ? `Are you sure you want to delete the ${entityTypeName}?`
                    : `Are you sure you want to delete the ${entityTypeName} "${name}"?`;
        }
        return this.confirm(message, o);
    }
    confirmDeleteAsApiResponse(apiOperation, message, options) {
        return processApiDialogResult(this.confirmDelete(message, options), apiOperation);
    }
    confirmDiscard() {
        return this.confirm('Proceeding with this action will cause all changes to be lost', {
            title: 'Discard Changes?',
            confirmButtonText: 'Discard Changes',
            type: 'warning',
        });
    }
    confirmAddAllBiomaterials(total) {
        return this.confirm(`Proceeding with this action add ${total} biomaterials to this trial`, {
            title: 'Add all biomaterials',
            confirmButtonText: 'Continue',
            type: 'warning',
        });
    }
    confirmRemoveAllBiomaterials(total) {
        return this.confirm(`Proceeding with this action remove ${total} biomaterials from this trial`, {
            title: 'Remove all biomaterials',
            confirmButtonText: 'Continue',
            type: 'warning',
        });
    }
    asyncApiAlert(response, actionType, entityType) {
        return new Promise((resolve, reject) => {
            Disposables.global.subscribeReplayOnce(response, (r) => {
                this.apiAlert(r, actionType, entityType)
                    .then((dr) => resolve(dr))
                    .catch((e) => {
                    reject(e);
                });
            });
        });
    }
    apiAlert(response, actionType, entityType) {
        return this.errorAlert(this.userNotifications.getApiResponseMessage({
            actionType: actionType,
            entityType: entityType ? entityType : EntityTypeKey.GenericData,
            response: response,
        }), this.text.getApiResponseTitle(response.code));
    }
    errorAlert(message, title) {
        if (TypeHelper.isStringNullOrEmpty(title)) {
            title = '@error-title.generic';
        }
        return this.dialog(Object.assign(Object.assign({}, swalDefaults), { title: title, text: message, icon: 'error', confirmButtonText: 'Ok', showCancelButton: false }));
    }
    infoAlert(message, title) {
        if (TypeHelper.isStringNullOrEmpty(title)) {
            title = '@dialog-title.info';
        }
        return this.dialog(Object.assign(Object.assign({}, swalDefaults), { title: title, text: message, icon: 'info', confirmButtonText: 'Ok', showCancelButton: false }));
    }
    cloneEntityPrompt(entity, entityName) {
        return this.dialog(Object.assign(Object.assign({}, swalDefaults), { title: `Clone ${entityName}`, text: `Enter a new name for this ${entityName}`, input: 'text', icon: `question`, confirmButtonText: 'Clone', inputPlaceholder: 'Enter a new name', inputValue: `${entity.name}_copy`, inputValidator: this.cloneEntityValidator(entityName) }));
    }
    setPinPrompt(username) {
        const PIN_LENGTH = 4;
        return this.dialog(Object.assign(Object.assign({}, swalDefaults), { title: `Set PIN`, text: `Set PIN for ${username}`, input: 'password', icon: 'question', confirmButtonText: 'Save', confirmButtonColor: '#81c341', cancelButtonColor: '#660033', inputPlaceholder: 'PIN', inputAttributes: {
                minLength: '4',
                maxLength: '4',
                style: 'text-align: center',
            }, inputValidator: (value) => {
                const containsOnlyNumbers = ValidationReference.onlyIntegersRegex.test(value);
                if (value.length === PIN_LENGTH && containsOnlyNumbers)
                    return;
                return `PIN must be ${PIN_LENGTH} digits!`;
            } }));
    }
    pinSuccess(username) {
        return this.dialog(Object.assign(Object.assign({}, swalDefaults), { title: 'Updated!', text: `PIN has been updated for ${username}`, icon: 'success', showCancelButton: false, confirmButtonText: 'OK' }));
    }
    cloneEntityValidator(entityName) {
        return (value) => {
            if (TypeHelper.isStringNullOrEmpty(value)) {
                return `The ${entityName} name is required`;
            }
            return null;
        };
    }
    dialog(args) {
        args.text = this.text.resolveText(args.text);
        args.title = this.text.resolveText(args.title);
        return swalNative.fire(args);
    }
}
SwalDialog.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: SwalDialog, deps: [{ token: UserNotifications }, { token: AppTextService }], target: i0.ɵɵFactoryTarget.Injectable });
SwalDialog.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: SwalDialog, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: SwalDialog, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: UserNotifications }, { type: AppTextService }]; } });
function dialogType(dialogType) {
    if (dialogType == undefined)
        return 'question';
    return dialogType !== 'unspecified' ? dialogType : undefined;
}
function applyDelayConfirm(o, interval = 2000) {
    o.willOpen = () => {
        const content = swalNative.getActions();
        const btn = content.querySelector('button.swal2-confirm');
        if (btn == undefined)
            return;
        btn.setAttribute('disabled', 'disabled');
        setTimeout(() => {
            btn.removeAttribute('disabled');
        }, interval);
    };
}
function dialogConfigFromModalFormConfig(c) {
    const r = dialogConfigFromModalConfig(c);
    r.disableClose = true;
    r.closeOnNavigation = false;
    if (c != undefined) {
        r.data = {
            title: c.title,
            provider: c.provider,
            mode: c.mode,
            model: c.model,
            data: c.data,
            entityType: c.entityType,
            submitButtonText: c.submitButtonText,
            submitButtonTooltip: c.submitButtonTooltip,
        };
    }
    else {
        r.data = {};
    }
    return r;
}
function dialogConfigFromModalConfig(c) {
    const r = {
        panelClass: 'app-modal-dialog',
        width: '600px',
        height: 'auto',
        hasBackdrop: true,
    };
    if (c) {
        if (!TypeHelper.isStringNullOrEmpty(c.width)) {
            r.width = c.width;
        }
        if (!TypeHelper.isStringNullOrEmpty(c.height)) {
            r.height = c.height;
        }
    }
    return r;
}
function processApiDialogResult(dialogResult, apiOperation) {
    const promise = dialogResult
        .then((proceed) => {
        let result;
        if (proceed) {
            result = apiOperation().toPromise();
        }
        return result;
    })
        .then((r) => {
        return r ? r : ApiResponse.errorCustom(ApiResponseCode.Cancelled);
    });
    return from(promise);
}

const ICON_STATUSES = [
    {
        matchStatus: 'Permission Issue',
        ligature: 'warning',
        toolTip: 'This Trial is no longer requesting work to be done',
    },
    {
        matchStatus: 'WARNING',
        ligature: 'warning',
        toolTip: '',
    },
    {
        matchStatus: 'SUCCESS',
        ligature: 'complete',
        toolTip: '',
    },
    {
        matchStatus: 'FAILED',
        ligature: 'fatal_error',
        toolTip: '',
    },
];
class IconStatusHelper {
    static getStatusLigature(status) {
        const iconStatus = ICON_STATUSES.find((s) => s.matchStatus === status);
        return iconStatus ? iconStatus.ligature : undefined;
    }
    static getStatusTooltip(status) {
        const iconStatus = ICON_STATUSES.find((s) => s.matchStatus === status);
        return iconStatus ? iconStatus.toolTip : undefined;
    }
}

class FacadeBase {
    /**
     * When overridden in a derived class, initiates any application initialisation that is the responsibility of that class.
     */
    init() {
        return of(Promise.resolve());
    }
}

class KupUsersMigrationHelper extends FacadeBase {
    constructor(keycloak, apiService) {
        super();
        this.keycloak = keycloak;
        this.apiService = apiService;
        this._userProfile = emptyProfile();
        this._userProfile$ = new BehaviorSubject(emptyProfile());
        this.userProfile$ = this._userProfile$.asObservable();
    }
    init() {
        return this.initProfileData();
    }
    get currentProfile() {
        return this._userProfile;
    }
    // formatDisplayName(user: User): string {
    //   return this.messageFormatter.userDisplayName(user);
    // }
    // setPIN(username?: string, displayName?: string, userId?: string) {
    //   if (!this.auth.enforceApplicationAccess()) return;
    //   const dialogRef = this.dialog.setPinPrompt(displayName);
    //   dialogRef.then(response => {
    //     if (response.value == undefined) return;
    //     Disposables.global.subscribeReplayOnce(
    //       this.currentProfile.userName === username
    //         ? this.api.setOwnPIN(response.value)
    //         : this.api.setPIN(username, response.value, userId),
    //       response => {
    //         if (response.isOk) {
    //           this.dialog.pinSuccess(displayName);
    //         } else {
    //           this.dialog.errorAlert(`PIN change failed, please try again`);
    //         }
    //       }
    //     );
    //   });
    // }
    // getUser(userId: string): Observable<ApiResponse<User>> {
    //   return this.api.getUser(userId);
    // }
    // deprecatedGetUsers(): Observable<ApiResponse<User[]>> {
    //   return this.api.deprecatedGetUsers();
    // }
    // getUsers(params: Params): Observable<TypedRestResponse<User>> {
    //   return this.api.getUsers(params);
    // }
    // filterUsersByName(name: string, maxLength: number = 50): Observable<User[]> {
    //   name = name != undefined ? name.toLowerCase() : '';
    //   const params = {
    //     match: name,
    //     page: 0,
    //     size: maxLength
    //   };
    //   return this.api.getUsers(params).pipe(
    //     map(result => {
    //       return result._embedded;
    //     })
    //   );
    // }
    loadUserData() {
        return this.loadUserDataByUsername(this._userProfile.userName).pipe(tap((response) => {
            if (response.isOk) {
                this.assignUserProfile(response.result);
            }
        }));
    }
    saveUserData(userData) {
        deleteRedundantUserData(userData);
        const entity = toUserDataEntity(userData);
        const result = userData.uuid != undefined
            ? // ? this.api.updateUserData(entity)
                this.apiService.apiService({ action: 'UPDATEQUERY', endpoint: 'userDatas' }, entity)
            : // : this.api.createUserData(entity);
                this.apiService.apiService({ action: 'CREATE', endpoint: 'userDatas' }, entity);
        Disposables.global.subscribeSubjectOnce(result, (r) => {
            if (r.isOk) {
                this.assignUserProfile(fromUserDataEntity(r.result));
            }
        });
        return Disposables.global.observeReplayOnce(result).pipe(map((r) => {
            return r.isOk
                ? ApiResponse.ok(fromUserDataEntity(r.result))
                : r;
        }));
    }
    saveQueryPageSize(pageSize) {
        if (pageSize == undefined) {
            throw new Error(ExceptionMessageFormatter.argumentNull('pageSize'));
        }
        if (pageSize <= 0) {
            throw new Error(ExceptionMessageFormatter.argumentBelowBound('pageSize', 0));
        }
        const r = this.loadUserData().pipe(map((r) => {
            return r.isOk ? this.savePageSizeImp(pageSize, r.result) : r;
        }));
        return Disposables.global.observeReplayOnce(r);
    }
    // saveFilter(
    //   modelType: FilterModelType,
    //   filterModel: any,
    //   selectors: string[]
    // ): Observable<ApiResponse<SavedFilter>> {
    //   if (modelType == undefined) {
    //     throw new Error(ExceptionMessageFormatter.argumentNull('modelType'));
    //   }
    //   if (filterModel == undefined) {
    //     throw new Error(ExceptionMessageFormatter.argumentNull('filterModel'));
    //   }
    //   if (TypeHelper.isStringNullOrEmpty(modelType)) {
    //     throw new Error(ExceptionMessageFormatter.argument('modelType'));
    //   }
    //   const r = this.loadUserData(true).pipe(
    //     map(r => {
    //       return r.isOk
    //         ? this.saveFilterImp(modelType, filterModel, selectors, r.result)
    //         : <any>r;
    //     })
    //   );
    //   return Disposables.global.observeReplayOnce(r);
    // }
    /**
     * Returns a `SavedFilter` from the current user profile where a filter of the specified type exists, otherwise returns `undefined`.
     * @param modelType The filter model type to get.
     */
    // getSavedFilter(modelType: FilterModelType): SavedFilter {
    //   const filters = this._userProfile.userData.filters;
    //   let model: any = filters.filters ? filters.filters[modelType] : undefined;
    //   let selectors: any = filters.selectors
    //     ? filters.selectors[modelType]
    //     : undefined;
    //   model = model ? TypeHelper.clone(model) : {};
    //   selectors = selectors ? TypeHelper.clone(selectors) : undefined;
    //   return filters != undefined
    //     ? new SavedFilter(modelType, model, selectors)
    //     : undefined;
    // }
    loadUserDataByUsername(username) {
        // return this.api.getUserData().pipe(
        return this.apiService
            .apiService({ action: 'GETLIST', endpoint: 'userDatas' }, null)
            .pipe(map((response) => {
            switch (response.code) {
                case ApiResponseCode.Ok:
                    return ApiResponse.ok(fromUserDataEntity(response.result));
                case ApiResponseCode.NotFound:
                    return ApiResponse.ok(defaultUserDataset(username));
                default:
                    return response;
            }
        }));
    }
    initProfileData() {
        return from(this.keycloak
            .loadUserProfile(false)
            .then((p) => {
            this._keycloakProfile = p;
            return this.loadUserDataByUsername(p.username).toPromise();
        })
            .then((response) => {
            this.assignUserProfile(response.result);
        }));
    }
    assignUserProfile(data) {
        const p = TypeHelper.clone(data);
        delete p.uuid;
        p.firstName = TypeHelper.sanitizeString(this._keycloakProfile.firstName);
        p.lastName = TypeHelper.sanitizeString(this._keycloakProfile.lastName);
        p.displayName = TypeHelper.sanitizeString(`${p.firstName} ${p.lastName}`, data.userName);
        if (p.userData == undefined) {
            p.userData = {};
        }
        if (p.userData.preferences == undefined) {
            p.userData.preferences = {};
        }
        if (p.userData.blockPlanFilters == undefined) {
            p.userData.blockPlanFilters = [];
        }
        if (p.userData.filters == undefined) {
            p.userData.filters = {};
        }
        this._userProfile = p;
        this._userProfile$.next(p);
    }
    // private saveFilterImp(
    //   type: FilterModelType,
    //   filterModel: any,
    //   selectors: string[],
    //   userData: UserData
    // ): Observable<ApiResponse<SavedFilter>> {
    //   if (userData.userData == undefined) {
    //     userData.userData = {};
    //   }
    //   let set = userData.userData.filters;
    //   if (set == undefined) {
    //     set = { filters: {}, selectors: {} };
    //     userData.userData.filters = set;
    //   } else {
    //     if (set.filters == undefined) {
    //       set.filters = {};
    //     }
    //     if (set.selectors == undefined) {
    //       set.selectors = {};
    //     }
    //   }
    //   set.filters[type] = filterModel;
    //   set.selectors[type] = selectors;
    //   const r = this.saveUserData(userData).pipe(
    //     map(r => {
    //       return r.isOk
    //         ? ApiResponse.ok(new SavedFilter(type, filterModel, selectors))
    //         : <any>r;
    //     })
    //   );
    //   return this.notification.handleAsyncApiResponse({
    //     entityType: EntityTypeKey.QueryFilter,
    //     actionType: ApiActionType.Update,
    //     entityName: type,
    //     response: r
    //   });
    // }
    savePageSizeImp(pageSize, userData) {
        if (userData.userData == undefined)
            userData.userData = {};
        userData.userData.defaultPageSize = pageSize;
        return this.saveUserData(userData).pipe(map((r) => {
            return r.isOk ? ApiResponse.ok(pageSize) : r;
        }));
    }
}
KupUsersMigrationHelper.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: KupUsersMigrationHelper, deps: [{ token: i1$8.KeycloakService }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable });
KupUsersMigrationHelper.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: KupUsersMigrationHelper, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: KupUsersMigrationHelper, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1$8.KeycloakService }, { type: ApiService }]; } });
function fromUserDataEntity(src) {
    if (src == undefined)
        return undefined;
    const result = TypeHelper.clone(src);
    const json = src.userData != undefined ? src.userData.trim() : '';
    if (json.length > 0) {
        // JSON.parse twice to unescape the persisted JSON (this is because the userData property
        // is serialized as as a string at the remote endpoint).
        result.userData = JSON.parse(JSON.parse(src.userData));
    }
    else {
        result.userData = undefined;
    }
    return result;
}
function toUserDataEntity(src) {
    if (src == undefined)
        return undefined;
    const result = TypeHelper.clone(src);
    if (src.userData != undefined) {
        // JSON.stringify twice to escape the initial JSON (this is because the userData property
        // is deserialized as as a string at the remote endpoint).
        result.userData = JSON.stringify(JSON.stringify(src.userData));
    }
    return result;
}
function defaultUserDataset(username) {
    return {
        uuid: undefined,
        userName: username,
    };
}
function emptyProfile() {
    return {
        firstName: '',
        lastName: '',
        displayName: '',
        userName: '',
        userData: {
            preferences: {
                blockPlanFilters: [],
                dataTableColConfig: {},
            },
            filters: { filters: {}, selectors: {} },
        },
    };
}
/**
 * Removes any deprecated/redundant data from the `UserData` entity before it is saved.
 */
function deleteRedundantUserData(userData) {
    if (userData.userData == undefined)
        return;
    if (userData.userData.filters && userData.userData.filters.filters) {
        delete userData.userData.filters.filters['Seedlings'];
        delete userData.userData.filters.filters['Plant'];
        delete userData.userData.filters.filters['Scion'];
        delete userData.userData.filters.filters['Cane'];
    }
}

const IMPORT_STATUSES = [
    {
        matchStatus: 'Complete',
        ligature: 'complete',
    },
    {
        matchStatus: 'Pending processing',
        ligature: 'processing',
    },
    {
        matchStatus: 'Complete with errors',
        ligature: 'complete_with_errors',
    },
    {
        matchStatus: 'Uploading, Please Wait...',
        ligature: 'processing',
    },
    {
        matchStatus: 'Processing',
        ligature: 'processing',
    },
];
class ImportStatusHelper {
    static getStatusLigature(status) {
        const statusIcon = IMPORT_STATUSES.find((s) => s.matchStatus === status);
        return statusIcon ? statusIcon.ligature : 'fatal_error';
    }
}
class ColumnCheckboxChange {
    constructor(column, checked) {
        this.column = column;
        this.checked = checked;
    }
}
class TableCheckboxChange extends ColumnCheckboxChange {
    constructor(column, checked, data) {
        super(column, checked);
        this.data = data;
    }
}
const DefaultActions = {
    delete: {
        svgIcon: 'delete',
        color: 'primary',
        tooltip: 'Delete',
        class: 'delete-button',
    },
    add: {
        icon: 'add_circle',
        color: 'primary',
        tooltip: 'Add',
        class: 'add-button',
    },
    clone: {
        svgIcon: 'clone_entity',
        tooltip: 'Clone',
        class: 'clone-button',
    },
};
/**
 * Creates valid id from string
 */
function idfy(s) {
    return s.replace(/([^A-Za-z0-9[\]{}_.:-])\s?/g, '');
}
class TableComponentBaseDirective {
    constructor(changeDetector, usersFacade, activeNavFacade) {
        this.changeDetector = changeDetector;
        this.usersFacade = usersFacade;
        this.activeNavFacade = activeNavFacade;
        this._disposables = new Disposables();
        this._initialising = true;
        this._loading = false;
        this._opQueue = new SerializedOperationQueue(true);
        this._activePageSize = 20;
        this._defaultExportPageSize = 2147483647;
        this._selectedColumns = new KeySet();
        this.pageSizeOptions = [20, 50, 100];
        this.dateFormat = 'dd/MM/yyyy';
        this.dateTimeFormat = 'dd/MM/yyyy HH:mm';
        this.paged = true;
        this.canDrag = false;
        /**
         * If true, page parameters (page, size, sort, etc) are not written to the active route's query parameter collection.
         */
        this.suppressPageParams = false;
        this.hasActions = false;
        this.hasSearch = false;
        /** An optional id key prop */
        this.idKey = 'uuid';
        this.pageChange = new EventEmitter();
        this.sortChange = new EventEmitter();
        this.selectRow = new EventEmitter();
        this.deleteRow = new EventEmitter();
        this.clickFileLink = new EventEmitter();
        this.columnSelect = new EventEmitter();
        this.checkboxSelect = new EventEmitter();
        this.renderCellValue = (row, columnDef) => get(row, columnDef);
        const pageSize = usersFacade.currentProfile.userData.defaultPageSize;
        if (pageSize != undefined) {
            this._activePageSize = pageSize;
        }
        // TODO: Refactor to remove the row.isDisabled evaluation.
        // We should not expect the model to have to be mutated (potentially violating its interface) in order
        // to effect a change in this component's behaviour. Instead, we should only use the disabledEvalFn.
        this.disabledEvalFn = (row) => row.isDisabled === true;
    }
    set actions(actionConfig) {
        this._actions = Object.keys(actionConfig).map((name) => {
            let action = actionConfig[name];
            if (typeof action === 'function') {
                action = {
                    name: name,
                    handlerFn: action,
                    class: `${name}-button`,
                };
            }
            else {
                action.name = name;
                action.class = action.class || `${name}-button`;
            }
            return action;
        });
    }
    get tableDefinition() {
        return this._tableDefinition;
    }
    get loading() {
        return this._loading;
    }
    set loading(value) {
        this.setLoading(value);
    }
    set tableDefinition(value) {
        if (this._tableDefinition === value)
            return;
        this._tableDefinition = value;
        this.loadTableDefinition();
        this.changeDetector.detectChanges();
    }
    get masterPaginator() {
        return this._masterPaginator;
    }
    get activePageSize() {
        return this._activePageSize;
    }
    get domParser() {
        if (this._domParser == undefined) {
            this._domParser = new DOMParser();
        }
        return this._domParser;
    }
    get initialising() {
        return this._initialising;
    }
    get showPager() {
        return this.paged && !this.initialising && !this.hasNoResults();
    }
    get showNoResults() {
        return !this.initialising && this.hasNoResults();
    }
    setInitialising(value) {
        this._initialising = value === true;
    }
    setLoading(value) {
        this._loading = value === true;
    }
    ngOnInit() {
        if (this.tableDefinition == undefined) {
            throw new Error(ExceptionMessageFormatter.propertyNotAssigned('tableDefinition', this));
        }
        this._masterPaginator = this.topPaginator;
        this._disposables.addSubscription(this.topPaginator.page.subscribe((event) => {
            this.onPaginatorEvent(this.topPaginator, event);
        }));
        this._disposables.addSubscription(this.bottomPaginator.page.subscribe((event) => {
            this.onPaginatorEvent(this.bottomPaginator, event);
        }));
        this.loadTableDefinition(true);
        this.hydrateFromParams()
            .then(() => {
            if (!this.paged) {
                this._masterPaginator.pageSize = this._defaultExportPageSize;
                this._activePageSize = this._defaultExportPageSize;
            }
        })
            .then(() => {
            this.sort.sortChange.subscribe((sort) => {
                this.sortActive = sort.active;
                this.sortDirection = sort.direction;
                this.resetPaging();
                this.updateQueryParams();
                this.sortChange.emit(sort);
            });
            this.updateQueryParams();
            this.replicatePaginator(this.topPaginator, true);
        });
    }
    ngOnDestroy() {
        this._disposables.dispose();
    }
    detectChanges() {
        this.changeDetector.detectChanges();
    }
    markForCheck() {
        this.changeDetector.markForCheck();
    }
    /**
     * The columnTracker method enables dynamic changes to column headers. Without it, changes to columns would not be applied unless the
     * columnDef changed (which would mean the model property couldn't be referenced).
     */
    columnTracker(index, _item) {
        return index;
    }
    onMasterPaginatorChanged(_master) { }
    resetPaging() {
        this.masterPaginator.pageIndex = 0;
        this.replicatePaginator(this.masterPaginator);
    }
    resyncPaginators() {
        if (this.masterPaginator == undefined)
            return;
        // There is currently no public paginator datasource event that is raised when a paginator's state is initially updated
        // after having been connected to a datasource (as with the `SimpleTableComponent`). Furthermore, a paginator's state is
        // not guaranteed to be updated during the same event cycle within which it was assigned to a datasource.
        // For this reason it is necessary to use setTimeout to handle replication to the slave after the framework has propagated the
        // state change.
        this.detectChanges();
        const master = this.masterPaginator;
        const slave = master === this.topPaginator ? this.bottomPaginator : this.topPaginator;
        setTimeout(() => {
            slave.length = master.length;
            slave.pageIndex = master.pageIndex;
            slave.pageSize = master.pageSize;
        }, 0);
    }
    getActions() {
        return this._actions;
    }
    stripHTML(htmlFragment) {
        if (htmlFragment == undefined || htmlFragment === '')
            return '';
        const doc = this.domParser.parseFromString(htmlFragment, 'text/html');
        return doc && doc.body ? doc.body.textContent : '';
    }
    onColumnSelectChange(event, columnDef) {
        if (event.checked) {
            this._selectedColumns.set(columnDef);
        }
        else {
            this._selectedColumns.remove(columnDef);
        }
        this.columnSelect.emit(new ColumnCheckboxChange(columnDef, event.checked));
    }
    applyColumnSelected(columnDef, selected) {
        this._selectedColumns.apply(columnDef, selected);
    }
    selectColumn(columnDef) {
        this._selectedColumns.set(columnDef);
    }
    unSelectColumn(columnDef) {
        this._selectedColumns.remove(columnDef);
    }
    clearSelectedColumns() {
        this._selectedColumns.clear();
    }
    getSelectedColumnDefs() {
        return this._selectedColumns.getKeys();
    }
    isColumnSelected(columnDef) {
        return this._selectedColumns.containsKey(columnDef);
    }
    onCheckboxExChange(event, row, columnDef) {
        let target = row[columnDef];
        if (target == undefined) {
            target = {};
            row[columnDef] = target;
        }
        target.checked = event.checked;
        this.checkboxSelect.emit(new TableCheckboxChange(columnDef, event.checked, row));
    }
    onCheckboxChange(event, row, columnDef) {
        this.checkboxSelect.emit(new TableCheckboxChange(columnDef, event.checked, row));
    }
    resolveValueAsAttribute(row, columnDef) {
        return this.resolveValue(row, columnDef) ? true : undefined;
    }
    getStatusIcon(status) {
        return status ? ImportStatusHelper.getStatusLigature(status) : undefined;
    }
    getTrueIcon(row) {
        return row.operationsPlanTasks.length ? 'complete' : undefined;
    }
    getIcon(value) {
        return value ? IconStatusHelper.getStatusLigature(value) : undefined;
    }
    getIconTooltip(value) {
        return value ? IconStatusHelper.getStatusTooltip(value) : undefined;
    }
    rowIsSubtle(row) {
        return evalFnAsBoolean(row, this.subtleEvalFn);
    }
    rowShowWarningIcon(row) {
        return evalFnAsBoolean(row, this.warningEvalFn);
    }
    rowHighlightWarning(row) {
        return evalFnAsBoolean(row, this.warningEvalFn) && !this.rowIsSubtle(row);
    }
    rowIsReadOnly(row) {
        return this.readOnly === true || evalFnAsBoolean(row, this.disabledEvalFn);
    }
    resolveValue(row, columnDef) {
        const resolver = this.resolvers ? this.resolvers[columnDef] : undefined;
        return resolver ? resolver(row) : row[columnDef];
    }
    //#region Common action handler methods
    onClickRow(row) {
        this.selectRow.emit(row);
    }
    onDeleteRow(event, row) {
        event.stopPropagation();
        this.deleteRow.emit(row);
    }
    onClickAction(row, action, event) {
        event.stopPropagation();
        action.handlerFn(row);
    }
    onClickFile(file) {
        this.clickFileLink.emit(Object.assign({}, file));
    }
    getActionColour(action) {
        if (action.color != undefined)
            return action.color;
        const d = DefaultActions[action.name];
        return d ? d.color : undefined;
    }
    hasSvg(action) {
        if (action.svgIcon != undefined)
            return true;
        return DefaultActions[action.name] && DefaultActions[action.name].svgIcon
            ? true
            : false;
    }
    getActionIcon(action) {
        if (action.icon != undefined)
            return action.icon;
        if (action.svgIcon != undefined)
            return action.svgIcon;
        const d = DefaultActions[action.name];
        if (d && d.svgIcon != undefined) {
            return d.svgIcon;
        }
        if (d && d.icon != undefined) {
            return d.icon;
        }
        return undefined;
    }
    getColumnTooltip(item, column) {
        if (column.tooltipKey == undefined)
            return undefined;
        const value = item[column.tooltipKey];
        return column.formatter === 'truncate' ? this.stripHTML(value) : value;
    }
    getActionTooltip(action) {
        if (action.tooltip != undefined)
            return action.tooltip;
        const d = DefaultActions[action.name];
        return d ? d.tooltip : undefined;
    }
    resolveFormat(item, column) {
        return column.formatter !== 'dynamic' || this.columnFormatter == undefined
            ? column.formatter
            : this.columnFormatter(item, column.columnDef);
    }
    //#endregion
    //#region Private methods
    updateQueryParams() {
        if (this.suppressPageParams)
            return;
        const paginator = this.masterPaginator;
        const tableParams = {
            page: `${paginator.pageIndex}`,
            size: `${paginator.pageSize}`,
        };
        if (this.sortActive != undefined && this.sortDirection != undefined) {
            tableParams.sort = `${this.sortActive},${this.sortDirection}`;
        }
        else {
            this.activeNavFacade.removeQuery(['sort']);
        }
        this.activeNavFacade.addQuery(tableParams);
    }
    loadTableDefinition(initial = false) {
        // The table definition can be changed dynamically, but we need to prevent the loading step when set prior to ngOnInit.
        if (this.columns == undefined && !initial)
            return;
        this.columns = this.tableDefinition.columns;
        this.displayedColumns = this.selectDisplayedColumns(this.columns);
        // Apply default sort on init or revert if existing sort not on current columns
        if (initial ||
            (this.sortActive != undefined &&
                this.columns.find((item) => item.columnDef === this.sortActive) ==
                    undefined)) {
            this.sortActive = this.tableDefinition.sortActive;
            this.sortDirection = this.tableDefinition.sortDirection;
        }
    }
    selectDisplayedColumns(columns) {
        const displayedColumns = columns.map((x) => x.columnDef);
        if (this.hasActions) {
            displayedColumns.push('actions');
        }
        return displayedColumns;
    }
    onPaginatorEvent(src, page) {
        this.replicatePaginator(src);
        this.updateQueryParams();
        if (this.activePageSize !== page.pageSize) {
            this._activePageSize = page.pageSize;
            this.persistPageSize(page.pageSize);
        }
        this.pageChange.emit(page);
    }
    replicatePaginator(master, forceMasterUpdate = false) {
        if (forceMasterUpdate || this._masterPaginator !== master) {
            this._masterPaginator = master;
            this.onMasterPaginatorChanged(master);
        }
        this.resyncPaginators();
    }
    persistPageSize(pageSize) {
        this._opQueue.enqueue(() => {
            return this.usersFacade.saveQueryPageSize(pageSize);
        });
    }
    hydrateFromParams() {
        if (this.suppressPageParams)
            return Promise.resolve();
        const nav = this.activeNavFacade;
        return nav.getQueryParams().then((params) => {
            if (this.paged && (params.size || params.page)) {
                this.masterPaginator.pageIndex = TypeHelper.safeConvertInteger(params.page, 0);
                this.masterPaginator.pageSize = TypeHelper.safeConvertInteger(params.size, this.activePageSize);
            }
            if (!TypeHelper.isStringNullOrEmpty(params.sort)) {
                const parts = params.sort.split(',');
                this.sortActive = parts[0];
                this.sortDirection =
                    parts.length > 1 ? sanitizeSortDirection(parts[1]) : 'asc';
            }
            return Promise.resolve();
        });
    }
    rowId(row) {
        if (this.idKey && row && row[this.idKey]) {
            return `${this.id ? `${this.id}-` : ''}${idfy(row[this.idKey])}`;
        }
    }
}
TableComponentBaseDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: TableComponentBaseDirective, deps: [{ token: i0.ChangeDetectorRef }, { token: KupUsersMigrationHelper }, { token: MigrationHelper }], target: i0.ɵɵFactoryTarget.Directive });
TableComponentBaseDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.2", type: TableComponentBaseDirective, inputs: { readOnly: "readOnly", selectable: "selectable", dateFormat: "dateFormat", dateTimeFormat: "dateTimeFormat", paged: "paged", canDrag: "canDrag", suppressPageParams: "suppressPageParams", hasActions: "hasActions", actions: "actions", resolvers: "resolvers", hasSearch: "hasSearch", disabledEvalFn: "disabledEvalFn", warningEvalFn: "warningEvalFn", subtleEvalFn: "subtleEvalFn", columnFormatter: "columnFormatter", idKey: "idKey", id: "id", tableDefinition: "tableDefinition", loading: "loading" }, outputs: { pageChange: "pageChange", sortChange: "sortChange", selectRow: "selectRow", deleteRow: "deleteRow", clickFileLink: "clickFileLink", columnSelect: "columnSelect", checkboxSelect: "checkboxSelect" }, viewQueries: [{ propertyName: "topPaginator", first: true, predicate: ["topPaginator"], descendants: true }, { propertyName: "bottomPaginator", first: true, predicate: ["bottomPaginator"], descendants: true }, { propertyName: "sort", first: true, predicate: MatSort, descendants: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: TableComponentBaseDirective, decorators: [{
            type: Directive
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: KupUsersMigrationHelper }, { type: MigrationHelper }]; }, propDecorators: { topPaginator: [{
                type: ViewChild,
                args: ['topPaginator']
            }], bottomPaginator: [{
                type: ViewChild,
                args: ['bottomPaginator']
            }], sort: [{
                type: ViewChild,
                args: [MatSort]
            }], readOnly: [{
                type: Input
            }], selectable: [{
                type: Input
            }], dateFormat: [{
                type: Input
            }], dateTimeFormat: [{
                type: Input
            }], paged: [{
                type: Input
            }], canDrag: [{
                type: Input
            }], suppressPageParams: [{
                type: Input
            }], hasActions: [{
                type: Input
            }], actions: [{
                type: Input
            }], resolvers: [{
                type: Input
            }], hasSearch: [{
                type: Input
            }], disabledEvalFn: [{
                type: Input
            }], warningEvalFn: [{
                type: Input
            }], subtleEvalFn: [{
                type: Input
            }], columnFormatter: [{
                type: Input
            }], idKey: [{
                type: Input
            }], id: [{
                type: Input
            }], pageChange: [{
                type: Output
            }], sortChange: [{
                type: Output
            }], selectRow: [{
                type: Output
            }], deleteRow: [{
                type: Output
            }], clickFileLink: [{
                type: Output
            }], columnSelect: [{
                type: Output
            }], checkboxSelect: [{
                type: Output
            }], tableDefinition: [{
                type: Input
            }], loading: [{
                type: Input
            }] } });
function sanitizeSortDirection(value) {
    value = value != undefined ? value.toLowerCase() : undefined;
    switch (value) {
        case 'asc':
        case 'desc':
            return value;
        default:
            return 'asc';
    }
}
function evalFnAsBoolean(item, fn) {
    return (item && fn ? fn(item) : false) ? true : undefined;
}

// MOVE

/**
 * Generated bundle index. Do not edit.
 */

export { AapiService, ApiActionType, ApiErrorCategory, ApiHelper, ApiOutcomeDescriptorFactory, ApiResponse, ApiResponseCode, ApiService, ApiSharedServices, AppFormlyModule, AppTextPipe, AppTextService, AsyncApiOutcomeDescriptorFactory, AsyncHelper, AutoDispose, AutocompleteTypeComponent, BatchIdDropdownProvider, BiomaterialDropdownProvider, BiomaterialFilterDefinition, BiomaterialLinkDropdownProvider, BlockPlanEntityIdDropdownProvider, BusyStateWrapperComponent, ButtonGroupComponent, ButtonTypeComponent, CollectionDropdownProvider, ColumnCheckboxChange, ConfigProvider, DateTimePickerComponent, DialogComponent, DialogService, Dictionary, DismissReason, Disposables, DropdownDatasource, DropdownItem, DropdownProvider, DynamicDropdownDatasource, EntityMaker, EntityNameDropdownProvider, EntityNameIdDropdownProvider, EntityTypeKey, ErrorRedirect, ExceptionMessageFormatter, FailureLevel, FileHelperService, FileLink, FileUploadComponent, FileUploadWrapperComponent, FileValueAccessorDirective, FilterFieldLabel, FilterFieldName, FormActionEventArgs, FormActionEventType, FormViewComponent, FormatHelper, FormattedObservationValue, FormlyFormFlexLayoutComponent, GenotypeFilterDefinition, GenotypeLabelDropdownProviderNew, GenotypeSynonymDropdownProvider, HapiService, HtmlTypeComponent, IconStatusHelper, ImportTypesDropdownProvider, InfoFieldComponent, IntegerListDropdownProvider, IntegerListRangeProvider, KeySet, KupCoreModule, KupSnackBarService, LabApiService, LabelTemplateDropdownProvider, LoadingState, LoadingStateChangedEventArgs, LoadingStateErrorEventArgs, LoadingStateEventArgs, LoadingStateMonitor, LocationDropdownProvider, Logger, ManualBusyState, MapiServiceBase, MaterialModule, MessageFormatter, MigrationHelper, NamePlaceholderPipe, NewRepeatTypeComponent, NgSelectTypeComponent, NotificationCondition, OapiService, OapiServiceBase, ObservableOperation, ObservationsEntityIdDropdownProvider, PapiService, PrintLabelsModalComponent, PrinterDropdownProvider, RepeatTypeComponent, RequestTypeDropdownProvider, RequestTypeIdDropdownProvider, RightsSummary, SavedFilter, SerializedOperationQueue, ServiceBase, SimpleStandardFormComponent, SiteBlocksDropdownProvider, SitesDropdownProvider, StandardFormActionEventArgs, StandardFormComponent, StandardFormEventArgs, StandardFormStateFlags, StandardHeaderComponent, StandardViewComponent, StateActions, StringFormatPipe, StriphtmlPipe, SubscriptionManager, SwalDialog, TableCheckboxChange, TagDropdownProvider, TagInputComponent, TextEditorComponent, TreatmentCollection, TrialFilterDefinition, TrialIdDropdownProviderNew, TrialNameDropdownProviderNew, TypeHelper, UserGroup, UserNotifications, UserRightsFlags, UserRole, UsernameDropdownProviderNew, ValidationReference, autocompleteValidator, autocompleteValidatorMessage, contactNumberValidator, contactNumberValidatorMessage, decimalValidator, decimalValidatorMessage, defaultApiOutcomeHandler, emailValidator, emailValidatorMessage, fieldValidatorMessage, fileUploadValidator, fileUploadValidatorMessage, formatAuditHeaders, formatAuditMessage, integerValidator, integerValidatorMessage, maxDatePickerValidatorMessage, maxLengthQuillValidator, maxlengthValidationMessage, maxlengthValidationMessageQuill, minDatePickerValidatorMessage, notUniqueValidatorMessage, patternValidatorMessage, pinValidator, pinValidatorMessage, singleActiveDateValidatorMessage, specialCharactersValidator };
